import React, { useState, useEffect, useRef, useCallback } from "react";
import { createClient } from "@supabase/supabase-js";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";

// ─── SUPABASE ─────────────────────────────────────────────────────────────────
const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_KEY
);


const ADMIN_ACCOUNTS = [
  { email: "admin@nunya.academy", password: "NunyaAdmin2026!", role: "admin" }
];

const COUNTRIES = [
  // A
  "Afghanistan","Afrique du Sud","Albanie","Algérie","Allemagne","Andorre","Angola",
  "Antigua-et-Barbuda","Arabie Saoudite","Argentine","Arménie","Australie","Autriche","Azerbaïdjan",
  // B
  "Bahamas","Bahreïn","Bangladesh","Barbade","Belgique","Belize","Bénin","Bhoutan",
  "Biélorussie","Birmanie","Bolivie","Bosnie-Herzégovine","Botswana","Brésil","Brunei",
  "Bulgarie","Burkina Faso","Burundi",
  // C
  "Cabo Verde","Cambodge","Cameroun","Canada","Centrafrique","Chili","Chine","Chypre",
  "Colombie","Comores","Congo","Corée du Nord","Corée du Sud","Costa Rica","Côte d'Ivoire",
  "Croatie","Cuba",
  // D
  "Danemark","Djibouti","Dominique",
  // E
  "Égypte","Émirats arabes unis","Équateur","Érythrée","Eswatini","Espagne","Estonie",
  "États-Unis","Éthiopie",
  // F
  "Fidji","Finlande","France",
  // G
  "Gabon","Gambie","Géorgie","Ghana","Grèce","Grenade","Guatemala","Guinée",
  "Guinée-Bissau","Guinée équatoriale","Guyana",
  // H
  "Haïti","Honduras","Hongrie",
  // I
  "Îles Marshall","Îles Salomon","Inde","Indonésie","Irak","Iran","Irlande","Islande",
  "Israël","Italie",
  // J
  "Jamaïque","Japon","Jordanie",
  // K
  "Kazakhstan","Kenya","Kirghizistan","Kiribati","Kosovo","Koweït",
  // L
  "Laos","Lesotho","Lettonie","Liban","Liberia","Libye","Liechtenstein","Lituanie",
  "Luxembourg",
  // M
  "Macédoine du Nord","Madagascar","Malaisie","Malawi","Maldives","Mali","Malte",
  "Maroc","Maurice","Mauritanie","Mexique","Micronésie","Moldavie","Monaco","Mongolie",
  "Monténégro","Mozambique",
  // N
  "Namibie","Nauru","Népal","Nicaragua","Niger","Nigeria","Norvège","Nouvelle-Zélande",
  // O
  "Oman","Ouganda","Ouzbékistan",
  // P
  "Pakistan","Palaos","Palestine","Panama","Papouasie-Nouvelle-Guinée","Paraguay","Pays-Bas",
  "Pérou","Philippines","Pologne","Portugal",
  // Q
  "Qatar",
  // R
  "RDC","République dominicaine","République tchèque","Roumanie","Royaume-Uni","Russie",
  "Rwanda",
  // S
  "Saint-Kitts-et-Nevis","Saint-Marin","Saint-Vincent-et-les-Grenadines","Sainte-Lucie",
  "Salvador","Samoa","São Tomé-et-Príncipe","Sénégal","Serbie","Seychelles",
  "Sierra Leone","Singapour","Slovaquie","Slovénie","Somalie","Soudan","Soudan du Sud",
  "Sri Lanka","Suède","Suisse","Suriname","Syrie",
  // T
  "Tadjikistan","Tanzanie","Tchad","Thaïlande","Timor oriental","Togo","Tonga",
  "Trinité-et-Tobago","Tunisie","Turkménistan","Turquie","Tuvalu",
  // U
  "Ukraine","Uruguay",
  // V
  "Vanuatu","Vatican","Venezuela","Vietnam",
  // Y
  "Yémen",
  // Z
  "Zambie","Zimbabwe",
  // Territoires francophones
  "Guadeloupe","Martinique","Guyane","Réunion","Mayotte","Nouvelle-Calédonie",
  "Polynésie française","Saint-Pierre-et-Miquelon",
  // Autre
  "Autre pays",
];

const SPECIALTIES = [
  { id:"maths",  label:"Maths (spé)",    icon:"🔢" },
  { id:"nsi",    label:"NSI",            icon:"💻" },
  { id:"pc",     label:"PC (spé)",       icon:"⚗️" },
  { id:"svt",    label:"SVT (spé)",      icon:"🧬" },
  { id:"ses",    label:"SES",            icon:"📈" },
  { id:"hggsp",  label:"HGGSP",          icon:"🌐" },
  { id:"hlp",    label:"HLP",            icon:"📖" },
  { id:"llcer",  label:"LLCER",          icon:"🗣️" },
  { id:"si",     label:"SI",             icon:"⚙️" },
  { id:"arts",   label:"Arts",           icon:"🎨" },
];

const LEVELS = ["6ème","5ème","4ème","3ème","2nde","1ère Générale","Terminale Générale"];
const LEVELS_TECHNO = ["1ère Techno","Terminale Techno"];
const LEVELS_PRO = ["1ère Pro","Terminale Pro"];
const LEVELS_LYCEE_SUP = ["1ère Générale","Terminale Générale"]; // niveaux avec voies

const PLANS = {
  Gratuit:    { fcfa:0,    eur:"0",    usd:"0",    gbp:"0",    cad:"0",    cny:"0",    aed:"0"    },
  Essentiel:  { fcfa:1999, eur:"2,99", usd:"3,29", gbp:"2,59", cad:"4,39", cny:"21,89",aed:"10,99"},
  Premium:    { fcfa:3499, eur:"4,99", usd:"5,49", gbp:"4,29", cad:"7,49", cny:"35,99",aed:"18,39"},
  Famille:    { fcfa:6499, eur:"9,99", usd:"10,99",gbp:"8,49", cad:"14,99",cny:"72,99",aed:"36,99"},
};

const BADGES = [
  { id:"first_lesson",   label:"Première leçon",    icon:"🌟", desc:"Tu as complété ta première leçon !" },
  { id:"streak_3",       label:"3 jours de suite",  icon:"🔥", desc:"3 jours consécutifs d'apprentissage" },
  { id:"streak_7",       label:"Semaine parfaite",  icon:"💪", desc:"7 jours consécutifs — impressionnant !" },
  { id:"streak_30",      label:"Mois de feu",       icon:"🏆", desc:"30 jours consécutifs — tu es une légende !" },
  { id:"streak_100",     label:"Centurion",         icon:"👑", desc:"100 jours — Warrior Nunya !" },
  { id:"first_exercise", label:"Premier exercice",  icon:"✏️", desc:"Tu as résolu ton premier exercice" },
  { id:"perfect_score",  label:"Score parfait",     icon:"💯", desc:"10/10 à un exercice !" },
  { id:"chapter_done",   label:"Chapitre complet",  icon:"📚", desc:"Tu as terminé un chapitre entier" },
  { id:"challenger",     label:"Challenger",        icon:"⚡", desc:"Tu as participé à un défi quotidien" },
  { id:"league_gold",    label:"Ligue Or",          icon:"🥇", desc:"Tu as atteint la ligue Or !" },
  { id:"top_country",    label:"Champion national", icon:"🌍", desc:"Top 10 de ton pays cette semaine !" },
];

const LEAGUES = [
  { id:"bronze",   label:"Bronze",  icon:"🥉", color:"#CD7F32", minXP:0    },
  { id:"argent",   label:"Argent",  icon:"🥈", color:"#C0C0C0", minXP:500  },
  { id:"or",       label:"Or",      icon:"🥇", color:"#FFD700", minXP:1500 },
  { id:"platine",  label:"Platine", icon:"💎", color:"#E5E4E2", minXP:3000 },
  { id:"diamant",  label:"Diamant", icon:"👑", color:"#C9972C", minXP:6000 },
];

// ─── DESIGN SYSTEM ─────────────────────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --bg:        #F7F8FA;
    --surface:   #FFFFFF;
    --surface2:  #EFF1F5;
    --border:    #DDE1EA;
    --border2:   #EFF1F5;
    --text:      #0A1F44;
    --muted:     #4B5468;
    --faint:     #8B93A5;
    --gold:      #C9972C;
    --gold-light:#FDF3DC;
    --green:     #10B981;
    --blue:      #1A56DB;
    --blue-light:#EBF2FF;
    --red:       #EF4444;
    --purple:    #7C3AED;
    --navy:      #0A1F44;
    --font-display: 'Cormorant Garamond', Georgia, serif;
    --font-body:    'DM Sans', system-ui, sans-serif;
    --radius:    8px;
    --radius-lg: 16px;
    --shadow:    0 2px 12px rgba(10,31,68,0.08);
    --shadow-md: 0 8px 32px rgba(10,31,68,0.12);
  --bottom-nav-h: calc(64px + env(safe-area-inset-bottom));
  }

  /* Mode lecture */
  body.read-night {
    --bg: #1A1A2E; --surface: #16213E; --surface2: #0F3460;
    --text: #E8E8E8; --muted: #A0A8B8; --border: rgba(255,255,255,0.1);
  }
  body.read-sepia {
    --bg: #F5F0E8; --surface: #FAF6EE; --surface2: #EDE8DC;
    --text: #2C1810; --muted: #6B4C3B; --border: #D4C9B0;
  }

  html, body, #root { height: 100%; }

  body {
    font-family: var(--font-body);
    background: var(--bg);
    color: var(--text);
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
    padding-bottom: env(safe-area-inset-bottom);
    padding-top: env(safe-area-inset-top);
  }

  /* Scrollbar */
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: var(--border); border-radius: 2px; }

  /* Animations */
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50%       { transform: scale(1.05); }
  }
  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position: 200% center; }
  }
  @keyframes confetti {
    0%   { transform: translateY(0) rotate(0deg); opacity: 1; }
    100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
  }
  @keyframes xpFloat {
    0%   { transform: translateY(0); opacity: 1; }
    100% { transform: translateY(-60px); opacity: 0; }
  }
  @keyframes streakPulse {
    0%, 100% { filter: drop-shadow(0 0 4px rgba(201,151,44,0.6)); }
    50%       { filter: drop-shadow(0 0 12px rgba(201,151,44,1)); }
  }

  .fade { animation: fadeIn 0.4s cubic-bezier(0.16,1,0.3,1); }
  .slide-up { animation: slideUp 0.5s cubic-bezier(0.16,1,0.3,1); }

  /* Boutons hover */
  .btn-hover { transition: all 0.18s ease; }
  .btn-hover:hover { transform: translateY(-1px); box-shadow: var(--shadow-md); }
  .btn-hover:active { transform: translateY(0); }

  /* Cards hover */
  .card-hover { transition: all 0.2s ease; cursor: pointer; }
  .card-hover:hover { border-color: var(--gold) !important; transform: translateY(-2px); box-shadow: var(--shadow-md); }

  /* Navigation bottom */
  .bottom-nav {
    position: fixed;
    bottom: 0; left: 0; right: 0;
    height: var(--bottom-nav-h);
    background: rgba(255,255,255,0.95);
    backdrop-filter: blur(20px);
    border-top: 1px solid var(--border);
    display: flex;
    z-index: 100;
  }
  .bottom-nav-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    cursor: pointer;
    transition: all 0.15s;
    border: none;
    background: transparent;
    font-family: var(--font-body);
    padding: 8px 0;
  }
  .bottom-nav-item.active { color: var(--gold); }
  .bottom-nav-item:not(.active) { color: var(--faint); }
  .bottom-nav-icon { font-size: 22px; line-height: 1; }
  .bottom-nav-label { font-size: 10px; font-weight: 600; letter-spacing: 0.02em; }

  /* Main content avec bottom nav */
  .main-content {
    padding-bottom: calc(var(--bottom-nav-h) + 16px);
    min-height: 100vh;
  }

  /* Streak fire animation */
  .streak-fire { animation: streakPulse 2s ease-in-out infinite; }

  /* XP float */
  .xp-float {
    position: fixed;
    font-size: 18px;
    font-weight: 700;
    color: var(--gold);
    pointer-events: none;
    z-index: 9999;
    animation: xpFloat 1.5s ease-out forwards;
  }

  /* Confetti */
  .confetti-piece {
    position: fixed;
    width: 10px;
    height: 10px;
    pointer-events: none;
    z-index: 9999;
    border-radius: 2px;
    animation: confetti 2s ease-out forwards;
  }

  /* Mode lecture */
  .read-mode-content {
    max-width: 680px;
    margin: 0 auto;
    padding: 0 20px;
  }
  .read-mode-content p, .read-mode-content div {
    line-height: 1.9;
  }

  /* Responsive */
  @media (max-width: 480px) {
    .bottom-nav-label { font-size: 9px; }
    .bottom-nav-icon { font-size: 20px; }
  }

  /* Shimmer badge */
  .badge-shimmer {
    background: linear-gradient(90deg, var(--gold) 25%, #FFE89A 50%, var(--gold) 75%);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shimmer 2s linear infinite;
  }
  /* KaTeX formules */
  .katex-formula .katex-display { margin: 0; }
  .katex-formula .katex { color: var(--gold); font-size: 1.2em; }

  /* Progress bar */
  .progress-bar {
    height: 6px;
    background: var(--border);
    border-radius: 3px;
    overflow: hidden;
  }
  .progress-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--gold), #FFD700);
    border-radius: 3px;
    transition: width 0.6s cubic-bezier(0.16,1,0.3,1);
  }

  /* Toast notification */
  .toast {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--navy);
    color: white;
    padding: 12px 24px;
    border-radius: 100px;
    font-size: 14px;
    font-weight: 600;
    z-index: 9999;
    animation: slideUp 0.3s ease;
    white-space: nowrap;
    box-shadow: var(--shadow-md);
  }

  /* Skeleton loading */
  .skeleton {
    background: linear-gradient(90deg, var(--surface2) 25%, var(--border) 50%, var(--surface2) 75%);
    background-size: 200% auto;
    animation: shimmer 1.5s linear infinite;
    border-radius: var(--radius);
  }
`;

// ─── COMPOSANTS UI DE BASE ─────────────────────────────────────────────────────

// Logo Nunya
const NunyaLogo = ({ size = "md", showText = true, textColor = "var(--text)" }) => {
  const sizes = { sm: { box:24, font:13, textSize:16 }, md: { box:32, font:17, textSize:20 }, lg: { box:48, font:26, textSize:28 } };
  const s = sizes[size] || sizes.md;
  return (
    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
      <div style={{ width:s.box, height:s.box, background:"var(--navy)", borderRadius:Math.round(s.box/4), display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, boxShadow:"0 2px 8px rgba(10,31,68,0.3)" }}>
        <span style={{ fontFamily:"Georgia,serif", fontSize:s.font, fontWeight:700, color:"var(--gold)", lineHeight:1 }}>N</span>
      </div>
      {showText && (
        <span style={{ fontFamily:"'Cormorant Garamond',Georgia,serif", fontSize:s.textSize, fontWeight:700, letterSpacing:"-0.02em", color:textColor }}>
          Nunya<span style={{ color:"var(--gold)" }}>.</span>
        </span>
      )}
    </div>
  );
};

// Bouton principal
const Btn = ({ children, onClick, color = "var(--navy)", variant = "fill", style = {}, disabled = false, size = "md", loading = false }) => {
  const sizes = {
    sm: { padding:"8px 16px", fontSize:13, minHeight:36 },
    md: { padding:"12px 24px", fontSize:15, minHeight:48 },
    lg: { padding:"16px 32px", fontSize:17, minHeight:56 },
  };
  const s = sizes[size] || sizes.md;
  const base = {
    display:"inline-flex", alignItems:"center", justifyContent:"center", gap:8,
    border:"none", borderRadius:"10px", cursor: disabled ? "not-allowed" : "pointer",
    fontFamily:"var(--font-body)", fontWeight:600, letterSpacing:"0.01em",
    transition:"all 0.18s ease", opacity: disabled ? 0.55 : 1,
    ...s, borderRadius:"10px",
  };
  const variants = {
    fill:    { background:color, color:"#fff", boxShadow:"0 2px 8px rgba(10,31,68,0.15)" },
    outline: { background:"transparent", color:color, border:`1.5px solid ${color}` },
    ghost:   { background:"transparent", color:color },
    soft:    { background:`${color}15`, color:color },
  };
  return (
    <button
      onClick={disabled ? undefined : onClick}
      className="btn-hover"
      style={{ ...base, ...variants[variant], ...style }}
    >
      {loading ? <Spinner size={16} color={variant === "fill" ? "#fff" : color} /> : children}
    </button>
  );
};

// Surface / Card
const Surface = ({ children, style = {}, className = "", onClick }) => (
  <div
    onClick={onClick}
    className={className}
    style={{
      background:"var(--surface)",
      border:"1px solid var(--border)",
      borderRadius:"var(--radius-lg)",
      ...style
    }}
  >
    {children}
  </div>
);

// Spinner
const Spinner = ({ size = 20, color = "var(--gold)" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ animation:"spin 0.8s linear infinite" }}>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    <circle cx="12" cy="12" r="10" stroke={color} strokeOpacity="0.25" strokeWidth="2.5"/>
    <path d="M12 2a10 10 0 0 1 10 10" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

// Chip / Badge
const Chip = ({ children, color = "var(--gold)", style = {} }) => (
  <span style={{
    display:"inline-flex", alignItems:"center",
    background:`${color}18`, color,
    fontSize:11, fontWeight:700, letterSpacing:"0.04em",
    padding:"3px 10px", borderRadius:100,
    border:`1px solid ${color}30`,
    ...style
  }}>
    {children}
  </span>
);

// Divider
const Divider = ({ style = {} }) => (
  <div style={{ height:1, background:"var(--border)", margin:"8px 0", ...style }} />
);

// Input Field global
const InputField = ({ label, type="text", value, onChange, placeholder, required=false, id }) => {
  const fieldId = id || label.toLowerCase().replace(/\s+/g, '-');
  return (
    <div style={{ marginBottom:14 }}>
      <label htmlFor={fieldId} style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>
        {label} {required && <span style={{ color:"var(--red)" }}>*</span>}
      </label>
      <input
        id={fieldId}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        style={{ width:"100%", padding:"12px 16px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:15, outline:"none", boxSizing:"border-box" }}
        onFocus={e => e.target.style.borderColor="var(--gold)"}
        onBlur={e => e.target.style.borderColor="var(--border)"}
      />
    </div>
  );
};
const ProgressBar = ({ value = 0, max = 100, color = "var(--gold)", style = {} }) => {
  const pct = Math.min(100, Math.round((value / max) * 100));
  return (
    <div className="progress-bar" style={style}>
      <div className="progress-bar-fill" style={{ width:`${pct}%`, background:color }} />
    </div>
  );
};

// Toast notification
const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, [onClose]);
  return <div className="toast">{message}</div>;
};

// Confettis
const Confetti = ({ onDone }) => {
  const colors = ["#C9972C","#FFD700","#0A1F44","#10B981","#1A56DB","#EF4444"];
  const pieces = Array.from({ length: 40 }, (_, i) => ({
    id: i,
    color: colors[i % colors.length],
    left: Math.random() * 100,
    delay: Math.random() * 0.8,
    size: 6 + Math.random() * 8,
    rotate: Math.random() * 360,
  }));
  useEffect(() => {
    const t = setTimeout(onDone, 2500);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <>
      {pieces.map(p => (
        <div
          key={p.id}
          className="confetti-piece"
          style={{
            left:`${p.left}%`, top:"-10px",
            background:p.color,
            width:p.size, height:p.size,
            transform:`rotate(${p.rotate}deg)`,
            animationDelay:`${p.delay}s`,
          }}
        />
      ))}
    </>
  );
};

// XP Float animation
const XPFloat = ({ amount, x, y, onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 1500);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <div className="xp-float" style={{ left:x, top:y }}>
      +{amount} XP ⚡
    </div>
  );
};

// Modal
const Modal = ({ children, onClose, title, style = {} }) => (
  <div
    onClick={onClose}
    style={{
      position:"fixed", inset:0,
      background:"rgba(10,31,68,0.6)",
      backdropFilter:"blur(8px)",
      display:"flex", alignItems:"center", justifyContent:"center",
      zIndex:1000, padding:16,
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      className="slide-up"
      style={{
        background:"var(--surface)",
        borderRadius:"var(--radius-lg)",
        width:"100%", maxWidth:500,
        maxHeight:"90vh", overflow:"auto",
        boxShadow:"0 24px 64px rgba(10,31,68,0.2)",
        ...style
      }}
    >
      {title && (
        <div style={{ padding:"20px 24px 0", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700 }}>{title}</h3>
          <button onClick={onClose} aria-label="Fermer" style={{ background:"none", border:"none", fontSize:22, cursor:"pointer", color:"var(--muted)", lineHeight:1 }}>×</button>
        </div>
      )}
      <div style={{ padding:24 }}>{children}</div>
    </div>
  </div>
);

// CGU Modal
const CGUModal = ({ onAccept, onClose }) => (
  <Modal onClose={onClose} title="Conditions d'utilisation" style={{ maxWidth:600 }}>
    <div style={{ fontSize:14, color:"var(--muted)", lineHeight:1.8, maxHeight:300, overflow:"auto", marginBottom:20 }}>
      <p><strong style={{ color:"var(--text)" }}>1. Utilisation de la plateforme</strong></p>
      <p>Nunya Academy est une plateforme éducative destinée aux élèves francophones du monde entier. L'utilisation est soumise au respect des présentes conditions.</p>
      <br/>
      <p><strong style={{ color:"var(--text)" }}>2. Données personnelles</strong></p>
      <p>Vos données sont protégées conformément au RGPD. Nous ne partageons jamais vos informations avec des tiers sans votre consentement.</p>
      <br/>
      <p><strong style={{ color:"var(--text)" }}>3. Contenu</strong></p>
      <p>Le contenu de Nunya Academy est protégé par le droit d'auteur. Toute reproduction non autorisée est interdite.</p>
      <br/>
      <p><strong style={{ color:"var(--text)" }}>4. Abonnements</strong></p>
      <p>Les abonnements sont renouvelés automatiquement. Vous pouvez les annuler à tout moment. Garantie satisfait ou remboursé 30 jours.</p>
      <br/>
      <p><strong style={{ color:"var(--text)" }}>5. Contact</strong></p>
      <p>Pour toute question : support@nunya.academy</p>
      <br/>
<p style={{ textAlign:"center" }}>
  <a href="https://nunya.academy/cgu.html" target="_blank" 
    style={{ color:"var(--gold)", fontSize:13, fontWeight:600 }}>
    📄 Lire les CGU complètes →
  </a>
</p>
    </div>
    <div style={{ display:"flex", gap:12 }}>
      <Btn onClick={onClose} variant="outline" color="var(--muted)" style={{ flex:1 }}>Refuser</Btn>
      <Btn onClick={onAccept} color="var(--gold)" style={{ flex:2 }}>J'accepte les CGU</Btn>
    </div>
  </Modal>
);

// Streak badge
const StreakBadge = ({ streak = 0, size = "md" }) => {
  const getStreakIcon = (s) => {
    if (s >= 100) return "👑";
    if (s >= 30) return "🔥";
    if (s >= 7) return "🔥";
    return "🔥";
  };
  const getStreakColor = (s) => {
    if (s >= 100) return "var(--gold)";
    if (s >= 30) return "#FF4500";
    if (s >= 7) return "#FF6B35";
    return "#FF8C42";
  };
  const sizes = { sm: { font:12, icon:14 }, md: { font:14, icon:18 }, lg: { font:18, icon:24 } };
  const s = sizes[size] || sizes.md;
  return (
    <div style={{ display:"flex", alignItems:"center", gap:4 }}>
      <span
        style={{ fontSize:s.icon, lineHeight:1 }}
        className={streak >= 7 ? "streak-fire" : ""}
      >
        {getStreakIcon(streak)}
      </span>
      <span style={{ fontSize:s.font, fontWeight:700, color:getStreakColor(streak) }}>
        {streak}j
      </span>
    </div>
  );
};

// Ligue badge
const LeagueBadge = ({ xp = 0 }) => {
  const league = [...LEAGUES].reverse().find(l => xp >= l.minXP) || LEAGUES[0];
  return (
    <div style={{ display:"flex", alignItems:"center", gap:4 }}>
      <span style={{ fontSize:16 }}>{league.icon}</span>
      <span style={{ fontSize:12, fontWeight:600, color:league.color }}>{league.label}</span>
    </div>
  );
};

// Skeleton loader
const SkeletonCard = ({ height = 80 }) => (
  <div className="skeleton" style={{ height, borderRadius:"var(--radius-lg)", marginBottom:12 }} />
);

// Empty state
const EmptyState = ({ icon = "📭", title, message, action }) => (
  <div style={{ textAlign:"center", padding:"48px 24px" }}>
    <div style={{ fontSize:48, marginBottom:16 }}>{icon}</div>
    <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, marginBottom:8, color:"var(--text)" }}>{title}</h3>
    <p style={{ color:"var(--muted)", fontSize:14, lineHeight:1.7, marginBottom:action ? 24 : 0 }}>{message}</p>
    {action}
  </div>
);

// Kodjo Avatar flottant

// ─── BOUTON FLOTTANT MODE LECTURE ────────────────────────────────────────────
const ReadingModeFAB = ({ mode, setMode }) => {
  const [open, setOpen] = useState(false);
  const modes = [
    { id:"day",   icon:"☀️", label:"Jour" },
    { id:"sepia", icon:"📜", label:"Sépia" },
    { id:"night", icon:"🌙", label:"Nuit" },
  ];
  const current = modes.find(m => m.id === mode) || modes[0];

 return (
    <div style={{ position:"fixed", bottom:"calc(var(--bottom-nav-h) + 80px)", right:16, zIndex:100 }}>
      {/* Overlay click outside */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{ position:"fixed", inset:0, zIndex:-1 }}
        />
      )}
      {/* Options */}
      {open && (
        <div style={{
          position:"absolute", bottom:44, right:0,
          background:"var(--surface)", borderRadius:12,
          border:"1px solid var(--border)", padding:6,
          boxShadow:"0 4px 20px rgba(0,0,0,0.15)",
          display:"flex", flexDirection:"column", gap:4, minWidth:100,
        }}>
          {modes.map(m => (
            <button key={m.id} onClick={() => { setMode(m.id); setOpen(false); }}
              style={{
                padding:"8px 12px", borderRadius:8, border:"none", cursor:"pointer",
                background: mode===m.id ? "var(--gold-light)" : "transparent",
                color: mode===m.id ? "var(--gold)" : "var(--text)",
                fontFamily:"var(--font-body)", fontSize:13, fontWeight:mode===m.id?700:400,
                display:"flex", alignItems:"center", gap:8, textAlign:"left",
              }}>
              <span>{m.icon}</span> {m.label}
              {mode===m.id && <span style={{marginLeft:"auto", color:"var(--gold)"}}>✓</span>}
            </button>
          ))}
        </div>
      )}
      {/* Bouton principal */}
      <button onClick={() => setOpen(o => !o)}
        style={{
          width:36, height:36, borderRadius:"50%",
          background:"var(--surface)", border:"1px solid var(--border)",
          cursor:"pointer", fontSize:18, display:"flex",
          alignItems:"center", justifyContent:"center",
          boxShadow:"0 2px 8px rgba(0,0,0,0.12)",
        }}>
        {current.icon}
      </button>
    </div>
  );
};

const KodjoFAB = ({ onClick, hasAlert = false }) => (
  <button
    onClick={onClick}
    className="btn-hover"
    style={{
      position:"fixed",
      bottom:`calc(var(--bottom-nav-h) + 16px)`,
      right:16,
      width:52, height:52,
      borderRadius:"50%",
      background:"linear-gradient(135deg, var(--navy), #1A3A6B)",
      border: hasAlert ? "2px solid var(--gold)" : "none",
      cursor:"pointer",
      display:"flex", alignItems:"center", justifyContent:"center",
      boxShadow: hasAlert ? "0 4px 20px rgba(201,151,44,0.5)" : "0 4px 20px rgba(10,31,68,0.35)",
      zIndex:50,
      fontSize:24,
      animation: hasAlert ? "pulse 2s ease-in-out infinite" : "none",
    }}
    title="Parler à Kodjo"
  >
    🤖
    {hasAlert && (
      <span style={{
        position:"absolute", top:-2, right:-2,
        width:14, height:14, borderRadius:"50%",
        background:"var(--red)", border:"2px solid var(--bg)",
      }} />
    )}
  </button>
);

// ─── HELPERS ───────────────────────────────────────────────────────────────────

const getLevelColor = (level) => {
  const colors = {
    "6ème":"#10B981", "5ème":"#3B82F6", "4ème":"#8B5CF6",
    "3ème":"#F59E0B", "2nde":"#EF4444", "1ère":"#EC4899", "Terminale":"#C9972C"
  };
  return colors[level] || "var(--gold)";
};

const getSubjectIcon = (name) => {
  const icons = {
    "Mathématiques":"📐","Maths":"📐",
    "Français":"📝",
    "SVT":"🌱",
    "Histoire-Géo":"🌍",
    "Physique-Chimie":"⚗️",
    "Anglais":"🇬🇧",
    "Philosophie":"🧠",
    "Économie":"📈",
    "Éducation Civique":"🏛️",
    "Espagnol":"🇪🇸",
  };
  return icons[name] || "📚";
};

const formatNumber = (n) => {
  if (n >= 1000) return (n/1000).toFixed(1).replace(".0","") + "k";
  return String(n);
};

const timeAgo = (date) => {
  const diff = Date.now() - new Date(date).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}min`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  return `${Math.floor(hrs/24)}j`;
};

// Envoyer email via Edge Function
const sendEmail = async (type, to, variables = {}) => {
  try {
    await supabase.functions.invoke("send-email", {
      body: { type, to, variables }
    });
  } catch (e) {
    console.warn("Email non envoyé:", e);
  }
};

// Sauvegarder progression
const saveProgress = async (userId, chapterId, score, completed) => {
  try {
    const { error } = await supabase.from("progress").upsert({
      user_id: userId,
      chapter_id: chapterId,
      score,
      completed,
      updated_at: new Date().toISOString(),
    }, { onConflict: "user_id,chapter_id" });
    if (error) console.warn("Progress save error:", error);
  } catch (e) {
    console.warn("Progress save failed:", e);
  }
};

// Streak freeze — 1 gratuit par semaine
const getStreakFreezeKey = (userId) => {
  const week = Math.floor(Date.now() / (7 * 86400000));
  return `nunya_freeze_${userId}_${week}`;
};
const hasStreakFreeze = (userId) => !localStorage.getItem(getStreakFreezeKey(userId));
const useStreakFreeze = (userId) => localStorage.setItem(getStreakFreezeKey(userId), "used");

// Mettre à jour XP et streak
const updateXPAndStreak = async (userId, xpGain, currentStreak, lastActivity, badges) => {
  try {
    const today = new Date().toDateString();
    const lastDay = lastActivity ? new Date(lastActivity).toDateString() : null;
    const yesterday = new Date(Date.now() - 86400000).toDateString();
    let newStreak = currentStreak || 0;

    if (lastDay !== today) {
      if (lastDay === yesterday) {
        newStreak = newStreak + 1;
      } else if (lastDay && hasStreakFreeze(userId)) {
        // Utiliser le freeze automatique hebdomadaire
        useStreakFreeze(userId);
        newStreak = newStreak; // streak conservé grâce au freeze
      } else {
        newStreak = 1;
      }
    }

    const newBadges = [...(badges || [])];
    if (newStreak >= 100 && !newBadges.includes("streak_100")) newBadges.push("streak_100");
    else if (newStreak >= 30 && !newBadges.includes("streak_30")) newBadges.push("streak_30");
    else if (newStreak >= 7 && !newBadges.includes("streak_7")) newBadges.push("streak_7");
    else if (newStreak >= 3 && !newBadges.includes("streak_3")) newBadges.push("streak_3");

    const { data: profile } = await supabase
      .from("profiles").select("xp").eq("id", userId).single();
    const newXP = (profile?.xp || 0) + xpGain;

    await supabase.from("profiles").update({
      xp: newXP,
      streak: newStreak,
      last_activity: new Date().toISOString(),
      badges: newBadges,
    }).eq("id", userId);

    return { newXP, newStreak, newBadges };
  } catch (e) {
    console.warn("XP update failed:", e);
    return { newXP: 0, newStreak: 0, newBadges: [] };
  }
};


// ─── PARTIE 2 — ONBOARDING + LANDING + AUTH ──────────────────────────────────
// Dépend de : Partie 1 (imports nécessaires)



// ─── KODJO PROACTIF — Détection d'alertes ────────────────────────────────────
const computeKodjoAlert = async (user) => {
  try {
    // 1. Inactivité (3+ jours sans activité, mais avait un streak)
    if (user.last_activity) {
      const daysSince = Math.floor((Date.now() - new Date(user.last_activity).getTime()) / 86400000);
      if (daysSince >= 3 && (user.streak || 0) >= 1) {
        return {
          type: "inactive",
          message: `Salut ${user.name?.split(" ")[0]} ! 👋 Ça fait ${daysSince} jours que je ne t'ai pas vu. Ton streak m'attend ! On reprend où tu en étais ?`
        };
      }
    }

    // 2. Chapitre avec score faible (difficulté détectée)
    const { data: lowScores } = await supabase
      .from("progress")
      .select("chapter_id, score, completed")
      .eq("user_id", user.id)
      .lt("score", 5)
      .eq("completed", false)
      .order("updated_at", { ascending: false })
      .limit(1);

    if (lowScores?.length) {
      const { data: chapter } = await supabase.from("chapters").select("title").eq("id", lowScores[0].chapter_id).single();
      if (chapter) {
        return {
          type: "struggling",
          message: `Salut ${user.name?.split(" ")[0]} ! Je vois que tu as eu un peu de mal sur "${chapter.title}" (${lowScores[0].score}/10). Tu veux qu'on revoie ça ensemble ? Je suis là pour t'aider 💪`
        };
      }
    }

    return null;
  } catch (e) {
    return null;
  }
};

// ── FREEMIUM HELPERS ─────────────────────────────────────────────────────────
const FREE_CHAPTERS_LIMIT = 1; // 1 chapitre complet par matière pour Gratuit
const FREE_DAILY_KODJO_ESSAI = 3; // questions Kodjo pour Essai (sans compte)
const FREE_DAILY_KODJO = 10; // questions Kodjo pour Gratuit/jour

const hasFullAccess = (user) =>
  ["Essentiel","Premium","Famille","Admin","SuperAdmin"].includes(user?.plan) ||
  user?.role === "superadmin" || user?.role === "admin";

const isChapterLocked = (chapterIndex, user) => {
  if (hasFullAccess(user)) return false;
  return chapterIndex >= FREE_CHAPTERS_LIMIT;
};

const getKodjoUsageToday = (userId) => {
  const key = `nunya_kodjo_${userId}_${new Date().toDateString()}`;
  return parseInt(localStorage.getItem(key) || "0");
};

const incrementKodjoUsage = (userId) => {
  const key = `nunya_kodjo_${userId}_${new Date().toDateString()}`;
  localStorage.setItem(key, String(getKodjoUsageToday(userId) + 1));
};

const canUseKodjo = (user) => {
  if (hasFullAccess(user)) return true;
  if (!user) return getKodjoUsageToday('essai') < FREE_DAILY_KODJO_ESSAI;
  return getKodjoUsageToday(user?.id) < FREE_DAILY_KODJO;
};

// ─── LANDING PAGE (avant connexion) ──────────────────────────────────────────
const Landing = ({ onEnter, onDemo }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 50); }, []);

 const [stats, setStats] = useState([
  { n:"120+", l:"Pays dans le monde" },
  { n:"7+",   l:"Niveaux scolaires" },
  { n:"6+",   l:"Matières fondamentales" },
  { n:"804+", l:"Chapitres disponibles" },
  { n:"16 000+", l:"Exercices & Corrigés" },
]);

useEffect(() => {
  const loadStats = async () => {
    try {
      const { count: lessonCount } = await supabase.from("lessons").select("*", { count:"exact", head:true });
      const { count: chapterCount } = await supabase.from("chapters").select("*", { count:"exact", head:true });
      if (lessonCount && chapterCount) {
        setStats([
          { n:"120+", l:"Pays dans le monde" },
          { n:"7+",   l:"Niveaux scolaires" },
          { n:"6+",   l:"Matières fondamentales" },
          { n:chapterCount.toLocaleString("fr")+ "+", l:"Chapitres disponibles" },
          { n:(lessonCount * 6).toLocaleString("fr")+"+", l:"Exercices & Corrigés" },
        ]);
      }
    } catch(e) {}
  };
  loadStats();
}, []);

  const features = [
    { icon:"🤖", title:"Tuteur IA Kodjo", desc:"Disponible 24h/24, il t'explique, guide et encourage sans jamais donner la réponse directement." },
    { icon:"🏆", title:"Compétitions mondiales", desc:"Défie des élèves de 120+ pays. Monte dans les ligues Bronze → Diamant chaque semaine." },
    { icon:"📄", title:"Annales officielles", desc:"Les vrais sujets DNB et Bac des années précédentes, corrigés et expliqués pas à pas." },
    { icon:"👨‍👩‍👧", title:"Dashboard parents", desc:"Suivez la progression de vos enfants en temps réel avec des rapports hebdomadaires automatiques." },
    { icon:"🌍", title:"100% francophone", desc:"Le seul programme aligné sur les curricula francophones — du Gabon au Canada, de la France au Sénégal." },
    { icon:"💰", title:"Prix adapté à tous", desc:"À partir de $0/mois. Le savoir accessible à tous les francophones du monde entier." },
  ];

  return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", fontFamily:"var(--font-body)" }}>

      {/* Background gradient */}
      <div style={{ position:"fixed", inset:0, background:"radial-gradient(ellipse 80% 60% at 50% -20%, rgba(201,151,44,0.08) 0%, transparent 60%)", pointerEvents:"none", zIndex:0 }} />

      {/* Navbar */}
      <nav style={{ padding:"16px 24px", display:"flex", justifyContent:"space-between", alignItems:"center", position:"sticky", top:0, zIndex:10, background:"rgba(247,248,250,0.92)", backdropFilter:"blur(12px)", borderBottom:"1px solid var(--border)" }}>
        <NunyaLogo size="md" />
        <div style={{ display:"flex", gap:8 }}>
          <Btn onClick={() => onEnter("register")} color="var(--gold)" size="sm">
  S'inscrire
</Btn>
          <Btn onClick={() => onEnter("login")} color="var(--navy)" size="sm">
            Se connecter
          </Btn>
        </div>
      </nav>

      {/* Hero */}
      <section style={{ padding:"64px 24px 48px", textAlign:"center", maxWidth:720, margin:"0 auto", position:"relative", zIndex:1 }}>
        <div
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "none" : "translateY(20px)",
            transition: "all 0.7s cubic-bezier(0.16,1,0.3,1)"
          }}
        >
          {/* Badge */}
          <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(201,151,44,0.1)", border:"1px solid rgba(201,151,44,0.25)", borderRadius:100, padding:"6px 16px", marginBottom:28 }}>
            <span style={{ color:"var(--gold)", fontSize:13, fontWeight:700, letterSpacing:"0.04em" }}>✦ Nunya — Le savoir</span>
          </div>

          {/* Titre */}
          <h1 style={{ fontFamily:"var(--font-display)", fontSize:"clamp(2.8rem,7vw,5rem)", fontWeight:700, lineHeight:1.05, letterSpacing:"-0.03em", marginBottom:20, color:"var(--text)" }}>
            Le savoir,<br/>
            <span style={{ color:"var(--gold)", fontStyle:"italic" }}>pour tous</span>.
          </h1>

          {/* Description */}
          <p style={{ fontSize:"clamp(15px,2vw,18px)", color:"var(--muted)", lineHeight:1.7, maxWidth:560, margin:"0 auto 32px" }}>
            La plateforme académique numérique de référence pour les élèves francophones du monde entier. Du secondaire au supérieur, un tuteur IA, des compétitions mondiales et la préparation au DNB et au Baccalauréat — pour réussir.
          </p>

          {/* CTAs */}
          <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap", marginBottom:16 }}>
            <Btn onClick={onDemo} color="var(--gold)" size="lg" style={{ borderRadius:14, minWidth:200 }}>
              🚀 Essayer gratuitement
            </Btn>
            <Btn onClick={() => onEnter("login")} variant="outline" color="var(--text)" size="lg" style={{ borderRadius:14 }}>
              Se connecter
            </Btn>
          </div>

          {/* Trust badges */}
          <div style={{ display:"flex", gap:8, justifyContent:"center", flexWrap:"wrap", marginTop:16 }}>
            {["✅ Gratuit pour commencer","✅ Sans carte bancaire",`✅ ${stats[3]?.n} chapitres disponibles`].map(b => (
              <span key={b} style={{ display:"inline-flex", alignItems:"center", gap:4, background:"rgba(10,31,68,0.06)", border:"1px solid rgba(10,31,68,0.10)", borderRadius:100, padding:"5px 14px", fontSize:12, fontWeight:500, color:"var(--text)" }}>
                {b}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section style={{ background:"var(--navy)", padding:"40px 16px", position:"relative", zIndex:1 }}>
        <div style={{ maxWidth:900, margin:"0 auto", display:"flex", flexWrap:"wrap", justifyContent:"center", gap:0 }}>
          {stats.map(({ n, l }) => (
            <div key={l} style={{ textAlign:"center", padding:"16px 8px" }}>
              <div style={{ fontFamily:"var(--font-display)", fontSize:"clamp(28px,4vw,52px)", fontWeight:700, color:"var(--gold)", lineHeight:1 }}>{n}</div>
              <div style={{ fontSize:"clamp(9px,1.2vw,12px)", color:"rgba(255,255,255,0.6)", marginTop:6, fontWeight:500, letterSpacing:"0.03em", textTransform:"uppercase" }}>{l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Pourquoi Nunya */}
      <section style={{ padding:"80px 24px", background:"var(--bg)", position:"relative", zIndex:1 }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <p style={{ textAlign:"center", fontSize:12, fontWeight:700, color:"var(--gold)", letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:12 }}>NOTRE DIFFÉRENCE</p>
          <h2 style={{ fontFamily:"var(--font-display)", fontSize:"clamp(2rem,4vw,3rem)", fontWeight:700, textAlign:"center", marginBottom:48, color:"var(--text)" }}>
            Pourquoi choisir Nunya ?
          </h2>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:20 }}>
            {features.map(f => (
              <Surface key={f.title} className="card-hover" style={{ padding:28 }}>
                <div style={{ fontSize:32, marginBottom:14 }}>{f.icon}</div>
                <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"var(--text)", marginBottom:10 }}>{f.title}</h3>
                <p style={{ color:"var(--muted)", fontSize:14, lineHeight:1.7 }}>{f.desc}</p>
              </Surface>
            ))}
          </div>
        </div>
      </section>

      {/* Comment ça marche */}
      <section style={{ padding:"80px 24px", background:"var(--surface)", position:"relative", zIndex:1 }}>
        <div style={{ maxWidth:900, margin:"0 auto" }}>
          <p style={{ textAlign:"center", fontSize:12, fontWeight:700, color:"var(--gold)", letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:12 }}>SIMPLE ET EFFICACE</p>
          <h2 style={{ fontFamily:"var(--font-display)", fontSize:"clamp(2rem,4vw,3rem)", fontWeight:700, textAlign:"center", marginBottom:48, color:"var(--text)" }}>
            Commence en 3 étapes
          </h2>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:32 }}>
            {[
              { step:"1", icon:"🎯", title:"Choisis ton niveau", desc:"Sélectionne ta classe — de la 6ème à la Terminale. Nunya s'adapte à ton programme officiel." },
              { step:"2", icon:"📚", title:"Apprends avec Kodjo", desc:"Cours complets, exercices corrigés, tuteur IA disponible 24h/24. À ton rythme, sans pression." },
              { step:"3", icon:"🏆", title:"Progresse et réussis", desc:"Monte dans les ligues mondiales, décroche des badges et prépare tes examens DNB et Bac." },
            ].map(s => (
              <div key={s.step} style={{ textAlign:"center", padding:"24px 16px" }}>
                <div style={{ width:56, height:56, borderRadius:"50%", background:"var(--gold-light)", border:"2px solid var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px", fontSize:24 }}>
                  {s.icon}
                </div>
                <div style={{ fontSize:11, fontWeight:700, color:"var(--gold)", letterSpacing:"0.08em", textTransform:"uppercase", marginBottom:8 }}>Étape {s.step}</div>
                <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, marginBottom:10, color:"var(--text)" }}>{s.title}</h3>
                <p style={{ color:"var(--muted)", fontSize:14, lineHeight:1.7 }}>{s.desc}</p>
              </div>
            ))}
          </div>

          {/* Garantie */}
          <div style={{ marginTop:48, background:"linear-gradient(135deg,var(--blue-light),var(--gold-light))", borderRadius:16, padding:28, display:"flex", alignItems:"center", gap:20, flexWrap:"wrap" }}>
            <div style={{ fontSize:40, flexShrink:0 }}>🛡️</div>
            <div style={{ flex:1 }}>
              <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"var(--text)", marginBottom:6 }}>Satisfait ou remboursé — 30 jours</h3>
              <p style={{ color:"var(--muted)", fontSize:14, lineHeight:1.6 }}>Pas convaincu dans les 30 premiers jours ? On te rembourse intégralement, sans question. Zéro risque.</p>
            </div>
            <Btn onClick={() => onEnter("register")} color="var(--navy)" style={{ flexShrink:0 }}>
              Essayer gratuitement →
            </Btn>
          </div>
        </div>
      </section>

      {/* CTA final */}
      <section style={{ padding:"80px 24px", background:"var(--navy)", textAlign:"center", position:"relative", zIndex:1 }}>
        <div style={{ maxWidth:600, margin:"0 auto" }}>
          <h2 style={{ fontFamily:"var(--font-display)", fontSize:"clamp(2rem,4vw,3rem)", fontWeight:700, color:"#fff", margin:"0 0 16px" }}>
            Rejoins <span style={{ color:"var(--gold)" }}>120+ pays</span>
          </h2>
          <p style={{ color:"rgba(255,255,255,0.65)", fontSize:16, lineHeight:1.7, marginBottom:32 }}>
            Le savoir, pour tous. Commence gratuitement aujourd'hui.
          </p>
          <Btn onClick={onDemo} color="var(--gold)" size="lg" style={{ borderRadius:14, minWidth:220 }}>
            🚀 Commencer maintenant — c'est gratuit
          </Btn>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ background:"var(--navy)", borderTop:"1px solid rgba(255,255,255,0.08)", padding:"24px", textAlign:"center" }}>
        <p style={{ color:"rgba(255,255,255,0.4)", fontSize:12 }}>
          © {new Date().getFullYear()} Nunya Academy — Le savoir, pour tous. · <a href="mailto:support@nunya.academy" style={{ color:"rgba(255,255,255,0.4)", textDecoration:"none" }}>support@nunya.academy</a>
        </p>
      </footer>
    </div>
  );
};

// ─── ONBOARDING (exploration sans compte) ───────────────────────────────────
const Onboarding = ({ onComplete, onSkip }) => {
  const [step, setStep] = useState(0);
  const [cycleStep, setCycleStep] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [demoLesson, setDemoLesson] = useState(null);
  const [demoChapter, setDemoChapter] = useState(null);
  const [kodjoAnswer, setKodjoAnswer] = useState("");
  const [kodjoFeedback, setKodjoFeedback] = useState("");
  const [showConfetti, setShowConfetti] = useState(false);
  const [loading, setLoading] = useState(false);
  const [chapterCount, setChapterCount] = useState(804);

  useEffect(() => {
    supabase.from("chapters").select("*", { count:"exact", head:true })
      .then(({ count }) => { if (count) setChapterCount(count); });
  }, []);

  const DEMO_SUBJECTS = selectedLevel === "1ère Générale" ? [
    { name:"Français",      icon:"📝" },
    { name:"Histoire-Géo",  icon:"🌍" },
    { name:"Anglais",       icon:"🇬🇧" },
    { name:"Enseignement Scientifique", icon:"🔬" },
  ] : selectedLevel === "Terminale Générale" ? [
    { name:"Philosophie",   icon:"🧠" },
    { name:"Histoire-Géo",  icon:"🌍" },
    { name:"Anglais",       icon:"🇬🇧" },
    { name:"Enseignement Scientifique", icon:"🔬" },
  ] : [
    { name:"Mathématiques", icon:"📐" },
    { name:"Français",      icon:"📝" },
    { name:"SVT",           icon:"🌱" },
    { name:"Histoire-Géo",  icon:"🌍" },
    { name:"Physique-Chimie",icon:"⚗️" },
    { name:"Anglais",       icon:"🇬🇧" },
  ];
  const loadDemoContent = async (level, subjectName) => {
    // Adapter le nom de la matière selon le niveau
    let adaptedSubject = subjectName;
    if (["1ère Générale", "Terminale Générale"].includes(level)) {
      if (subjectName === "SVT") adaptedSubject = "SVT Spé";
      if (subjectName === "Physique-Chimie") adaptedSubject = "Physique-Chimie Spé";
      if (subjectName === "Mathématiques") adaptedSubject = "Mathématiques Spé";
    }
    setLoading(true);
    try {
      // Trouver le subject et le level dans Supabase
      const { data: subjects } = await supabase.from("subjects").select("id,name").eq("name", adaptedSubject);
      const { data: levels } = await supabase.from("levels").select("id,name").eq("name", level);
      if (!subjects?.length || !levels?.length) {
        setDemoLesson({ titre:"Introduction", contenu:`Bienvenue en ${subjectName} niveau ${level} !

Nunya Academy te propose des cours complets, des exercices corrigés et un tuteur IA pour t'aider à progresser.

Ce contenu arrive bientôt pour ce niveau !` });
        setLoading(false);
        setStep(3);
        return;
      }
      // Charger le premier chapitre
      const { data: chapters } = await supabase
        .from("chapters")
        .select("id, title")
        .eq("subject_id", subjects[0].id)
        .eq("level_id", levels[0].id)
        .order("order_num")
        .limit(1);

      if (chapters?.length) {
        setDemoChapter(chapters[0]);
        // Charger la première leçon
        const { data: lessons } = await supabase
          .from("lessons")
          .select("id, title, content")
          .eq("chapter_id", chapters[0].id)
          .order("order_num")
          .limit(1);
        if (lessons?.length && lessons[0].content !== "...") {
          setDemoLesson({ titre: lessons[0].title, contenu: lessons[0].content });
        } else {
          setDemoLesson({ titre: chapters[0].title, contenu:`Bienvenue dans "${chapters[0].title}" !

DÉFINITION :
Ce chapitre te permettra de maîtriser les bases de ${subjectName} en ${level}.

Nunya prépare du contenu complet pour ce niveau. Inscris-toi pour être notifié dès que c'est prêt !` });
        }
      } else {
        setDemoLesson({ titre:`${subjectName} — ${level}`, contenu:`Bienvenue sur Nunya Academy !

Nous préparons du contenu de qualité pour ${subjectName} en ${level}.

Inscris-toi gratuitement pour accéder à tout le contenu disponible !` });
      }
    } catch (e) {
      setDemoLesson({ titre:"Bienvenue sur Nunya", contenu:"La plateforme académique de référence pour les élèves francophones du monde entier." });
    }
    setLoading(false);
    setStep(3);
  };

  const handleKodjoAnswer = () => {
    if (!kodjoAnswer.trim()) return;
    setKodjoFeedback("Bonne réflexion ! Tu commences à comprendre. Sur Nunya, Kodjo t'accompagne comme ça à chaque leçon, 24h/24. 🔥");
  };

  const handleFinish = () => {
    setShowConfetti(true);
    setTimeout(() => setStep(4), 600);
  };

  // ── Écran 0 — Cycle ────────────────────────────────────────────────────────
  if (step === 0 && !cycleStep) return (
    <div className="fade" style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px" }}>
      <NunyaLogo size="lg" />
      <h2 style={{ fontFamily:"var(--font-display)", fontSize:"clamp(1.8rem,5vw,2.8rem)", fontWeight:700, textAlign:"center", marginBottom:8, marginTop:24, color:"var(--text)" }}>
        Tu es en quelle étape ?
      </h2>
      <p style={{ color:"var(--muted)", fontSize:15, textAlign:"center", marginBottom:36 }}>
        Nunya adapte le contenu à ton parcours.
      </p>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, width:"100%", maxWidth:460 }}>
        <button onClick={() => { setCycleStep("secondaire"); }}
          className="btn-hover"
          style={{ padding:"28px 16px", borderRadius:16, border:"2px solid var(--border)", background:"var(--surface)", cursor:"pointer", fontFamily:"var(--font-body)", textAlign:"center", transition:"all 0.18s" }}
          onMouseEnter={e => { e.currentTarget.style.borderColor="var(--gold)"; e.currentTarget.style.background="var(--gold-light)"; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor="var(--border)"; e.currentTarget.style.background="var(--surface)"; }}
        >
          <div style={{ fontSize:40, marginBottom:10 }}>📚</div>
          <p style={{ fontSize:16, fontWeight:700, color:"var(--text)", marginBottom:4 }}>Secondaire</p>
          <p style={{ fontSize:12, color:"var(--muted)" }}>6ème → Terminale</p>
        </button>
        <div style={{ padding:"28px 16px", borderRadius:16, border:"2px dashed var(--border)", background:"var(--surface2)", textAlign:"center" }}>
          <div style={{ fontSize:40, marginBottom:10 }}>🎓</div>
          <p style={{ fontSize:16, fontWeight:700, color:"var(--faint)", marginBottom:4 }}>Supérieur</p>
          <p style={{ fontSize:12, color:"var(--faint)" }}>🔒 Bientôt</p>
        </div>
      </div>
      <button onClick={onSkip} style={{ marginTop:28, background:"none", border:"none", color:"var(--muted)", fontSize:13, cursor:"pointer", textDecoration:"underline" }}>
        J'ai déjà un compte → Se connecter
      </button>
    </div>
  );

  // ── Écran 1 — Classe ───────────────────────────────────────────────────────
  if (step === 0 && cycleStep === "secondaire") return (
    <div className="fade" style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px" }}>
      <button onClick={() => setCycleStep(null)} style={{ background:"none", border:"none", color:"var(--muted)", fontSize:13, cursor:"pointer", marginBottom:24, alignSelf:"flex-start" }}>← Retour</button>
      <h2 style={{ fontFamily:"var(--font-display)", fontSize:"clamp(1.8rem,5vw,2.8rem)", fontWeight:700, textAlign:"center", marginBottom:8, color:"var(--text)" }}>
        Tu es en quelle classe ?
      </h2>
      <p style={{ color:"var(--muted)", fontSize:15, textAlign:"center", marginBottom:36 }}>
        Nunya adapte le contenu à ton niveau exact.
      </p>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:10, width:"100%", maxWidth:460 }}>
        {LEVELS.map(level => (
          <button key={level}
            onClick={() => { setSelectedLevel(level); setStep(1); }}
            className="btn-hover"
            style={{ padding:"14px 6px", borderRadius:12, border:"2px solid var(--border)", background:"var(--surface)", cursor:"pointer", fontFamily:"var(--font-body)", fontSize:13, fontWeight:600, color:"var(--text)", textAlign:"center", minHeight:48, transition:"all 0.18s" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor="var(--gold)"; e.currentTarget.style.background="var(--gold-light)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor="var(--border)"; e.currentTarget.style.background="var(--surface)"; }}
          >
            {level}
          </button>
        ))}
      </div>
      <button onClick={onSkip} style={{ marginTop:24, background:"none", border:"none", color:"var(--muted)", fontSize:13, cursor:"pointer", textDecoration:"underline" }}>
        J'ai déjà un compte → Se connecter
      </button>
    </div>
  );

  // ── Écran 2 — Choix matière ────────────────────────────────────────────────
  if (step === 1) return (
    <div className="fade" style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px" }}>
      <button onClick={() => setStep(0)} style={{ background:"none", border:"none", color:"var(--muted)", fontSize:13, cursor:"pointer", marginBottom:24, alignSelf:"flex-start" }}>← Retour</button>
      <h2 style={{ fontFamily:"var(--font-display)", fontSize:"clamp(1.6rem,4vw,2.4rem)", fontWeight:700, textAlign:"center", marginBottom:8, color:"var(--text)" }}>
        Quelle matière veux-tu explorer ?
      </h2>
      <p style={{ color:"var(--muted)", fontSize:14, textAlign:"center", marginBottom:32 }}>
        Tu vas voir le premier chapitre de {selectedLevel}
      </p>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, width:"100%", maxWidth:400 }}>
        {DEMO_SUBJECTS.map(s => (
          <button key={s.name}
            onClick={() => { setSelectedSubject(s); loadDemoContent(selectedLevel, s.name); }}
            disabled={loading}
            className="btn-hover"
            style={{ padding:"20px 12px", borderRadius:14, border:"2px solid var(--border)", background:"var(--surface)", cursor:"pointer", fontFamily:"var(--font-body)", textAlign:"center", transition:"all 0.18s", opacity:loading?0.7:1 }}
            onMouseEnter={e => { if(!loading){e.currentTarget.style.borderColor="var(--gold)"; e.currentTarget.style.background="var(--gold-light)";} }}
            onMouseLeave={e => { e.currentTarget.style.borderColor="var(--border)"; e.currentTarget.style.background="var(--surface)"; }}
          >
            <div style={{ fontSize:32, marginBottom:8 }}>{s.icon}</div>
            <p style={{ fontSize:13, fontWeight:700, color:"var(--text)" }}>{s.name}</p>
          </button>
        ))}
      </div>
      {loading && <div style={{ marginTop:24 }}><Spinner size={28} /></div>}
    </div>
  );

  // ── Écran 3 — Leçon démo ──────────────────────────────────────────────────
  if (step === 3 && demoLesson) return (
    <div className="fade" style={{ minHeight:"100vh", background:"var(--bg)", padding:"0 0 32px" }}>
      {showConfetti && <Confetti onDone={() => setShowConfetti(false)} />}

      {/* Header */}
      <div style={{ background:"var(--navy)", padding:"16px" }}>
        <button onClick={() => setStep(1)} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:10 }}>← {selectedSubject?.name}</button>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:24 }}>{selectedSubject?.icon}</span>
          <div>
            <p style={{ fontSize:11, color:"rgba(255,255,255,0.5)" }}>{selectedSubject?.name} · {selectedLevel} · Aperçu gratuit</p>
            <h2 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"#fff" }}>
              {demoChapter?.title || demoLesson.titre}
            </h2>
          </div>
        </div>
        <div style={{ marginTop:12 }}>
          <ProgressBar value={kodjoFeedback ? 100 : 50} max={100} color="var(--gold)" />
        </div>
      </div>

      <div style={{ padding:"16px", maxWidth:680, margin:"0 auto" }}>

        {/* Leçon */}
        <Surface style={{ padding:20, marginBottom:16 }}>
          <h3 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"var(--text)", marginBottom:14 }}>
            {demoLesson.titre}
          </h3>
          <LessonContent content={demoLesson.contenu} color="var(--gold)" />
        </Surface>

        {/* Kodjo interactif */}
        <Surface style={{ padding:20, background:"var(--blue-light)", borderColor:"rgba(26,86,219,0.2)", marginBottom:16 }}>
          <div style={{ display:"flex", gap:10, marginBottom:12 }}>
            <span style={{ fontSize:24 }}>🤖</span>
            <div>
              <p style={{ fontSize:12, fontWeight:700, color:"var(--blue)", marginBottom:4 }}>KODJO dit</p>
              <p style={{ fontSize:14, color:"var(--text)", lineHeight:1.7 }}>
                Bien ! Maintenant dis-moi : qu'est-ce que tu retiens de ce que tu viens de lire ?
              </p>
            </div>
          </div>

          {!kodjoFeedback ? (
            <div style={{ display:"flex", gap:8 }}>
              <input
                value={kodjoAnswer}
                onChange={e => setKodjoAnswer(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleKodjoAnswer()}
                placeholder="Tape ta réponse ici..."
                style={{ flex:1, padding:"10px 14px", borderRadius:10, border:"1.5px solid rgba(26,86,219,0.3)", background:"rgba(255,255,255,0.8)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}
              />
              <button
                onClick={handleKodjoAnswer}
                disabled={!kodjoAnswer.trim()}
                style={{ padding:"10px 16px", borderRadius:10, background:kodjoAnswer.trim()?"var(--blue)":"var(--border)", border:"none", color:"#fff", cursor:kodjoAnswer.trim()?"pointer":"not-allowed", fontWeight:600, fontSize:14 }}
              >
                →
              </button>
            </div>
          ) : (
            <div style={{ background:"rgba(16,185,129,0.1)", borderRadius:10, padding:12, border:"1px solid rgba(16,185,129,0.3)" }}>
              <p style={{ fontSize:14, color:"var(--text)", lineHeight:1.7 }}>
                🎉 {kodjoFeedback}
              </p>
            </div>
          )}
        </Surface>

        <Btn
          onClick={handleFinish}
          color="var(--gold)" size="lg"
          style={{ width:"100%", borderRadius:14 }}
        >
          ✓ J'ai compris ! +50 XP →
        </Btn>

      </div>
    </div>
  );

  // ── Écran 4 — Victoire + inscription ──────────────────────────────────────
  if (step === 4) return (
    <div className="fade" style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px", textAlign:"center" }}>
      <div style={{ fontSize:72, marginBottom:16 }}>🎉</div>
      <div style={{ background:"var(--gold)", color:"#fff", borderRadius:100, padding:"6px 20px", fontSize:13, fontWeight:700, marginBottom:16 }}>
        +50 XP gagnés !
      </div>
      <h2 style={{ fontFamily:"var(--font-display)", fontSize:"clamp(1.8rem,5vw,2.8rem)", fontWeight:700, marginBottom:12, color:"var(--text)" }}>
        Excellent travail ! 🔥
      </h2>
      <p style={{ color:"var(--muted)", fontSize:15, lineHeight:1.7, maxWidth:400, marginBottom:32 }}>
        Tu viens de terminer ta première leçon de <strong>{selectedSubject?.name}</strong> en <strong>{selectedLevel}</strong>. Crée ton compte pour accéder à {chapterCount.toLocaleString("fr")}+ chapitres
      </p>
      <div style={{ display:"flex", flexDirection:"column", gap:12, width:"100%", maxWidth:360 }}>
        <Btn onClick={() => onComplete("register", selectedLevel)} color="var(--gold)" size="lg" style={{ borderRadius:14 }}>
          🚀 Créer mon compte — c'est gratuit
        </Btn>
        <Btn onClick={() => onComplete("login", selectedLevel)} variant="outline" color="var(--text)" size="md" style={{ borderRadius:14 }}>
          J'ai déjà un compte
        </Btn>
        <button onClick={onSkip} style={{ background:"none", border:"none", color:"var(--muted)", fontSize:13, cursor:"pointer", textDecoration:"underline", marginTop:8 }}>
          Continuer sans compte (accès limité)
        </button>
      </div>
    </div>
  );

  return null;
};

// ─── AUTH (connexion / inscription) ─────────────────────────────────────────────
const Auth = ({ mode: initialMode = "login", onAuth, onSwitch, prefillLevel = null }) => {
  const [mode, setMode] = useState(initialMode);
  const [profileType, setProfileType] = useState(null); // "student" ou "parent"
  const [form, setForm] = useState({
    name:"", email:"", password:"", dob:"",
    country:"", level: prefillLevel || "", specialties:[],
    plan:"Gratuit", cycle:null,
  });
  const [cguAccepted, setCguAccepted] = useState(false);
  const [parentalConsent, setParentalConsent] = useState(false);
  const [showCGU, setShowCGU] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isRegister = mode === "register";
  const isParent = profileType === "parent";
  const isStudent = profileType === "student";
  const needsSpecialties = ["1ère Générale","Terminale Générale"].includes(form.level);
  const maxSpecialties = ["Terminale Générale"].includes(form.level) ? 2 : 3;

  const toggleSpecialty = (id) => {
    const curr = form.specialties || [];
    const selected = curr.includes(id);
    if (curr.length >= maxSpecialties && !selected) return;
    setForm(f => ({ ...f, specialties: selected ? curr.filter(s=>s!==id) : [...curr, id] }));
  };

  const validatePassword = (pwd) => {
    if (pwd.length < 8) return "Le mot de passe doit contenir au moins 8 caractères.";
    if (!/[A-Z]/.test(pwd)) return "Le mot de passe doit contenir au moins une majuscule.";
    if (!/[0-9]/.test(pwd)) return "Le mot de passe doit contenir au moins un chiffre.";
    return null;
  };

  const handleSubmit = async () => {
    setError("");

    if (!form.email || !form.password) { setError("Email et mot de passe requis."); return; }

    if (isRegister) {
      if (!form.name) { setError("Le prénom est requis."); return; }
      const pwdError = validatePassword(form.password);
      if (pwdError) { setError(pwdError); return; }
      if (!form.dob) { setError("La date de naissance est requise."); return; }
      const age = Math.floor((Date.now() - new Date(form.dob)) / 31536000000);
if (age < 13 && !parentalConsent) { setError("Tu as moins de 13 ans. Tu dois avoir l'autorisation de tes parents pour t'inscrire."); return; }
      if (!form.country) { setError("Le pays est requis."); return; }

      if (isStudent) {
        if (!form.cycle) { setError("Choisis ton cycle."); return; }
        if (!form.level) { setError("Choisis ta classe."); return; }
        if (form.level === "1ère Générale" && (form.specialties||[]).length < 3) {
          setError("Tu dois choisir exactement 3 spécialités pour la 1ère."); return;
        }
        if (form.level === "Terminale Générale" && (form.specialties||[]).length < 2) {
          setError("Tu dois choisir exactement 2 spécialités pour la Terminale."); return;
        }
      }

      if (isParent) {
        if (!["Premium","Famille"].includes(form.plan)) {
          setError("Choisis un plan tarifaire."); return;
        }
      }

      if (!cguAccepted) { setError("Accepte les conditions d'utilisation."); return; }
    }

    setLoading(true);
    try {
      if (isRegister) {
        const { data, error: signUpError } = await supabase.auth.signUp({
          email: form.email,
          password: form.password,
          options: { 
            data: { 
              name: form.name,
              plan: form.plan || "Gratuit",
              billing: form.billing || 'monthly',
              level: form.level || "6ème",
              country: form.country || "",
              specialties: JSON.stringify(form.specialties || []),
              dob: form.dob || "",
              role: isParent ? "parent" : "student",
            } 
          },
        });
        if (signUpError) {
  if (signUpError.message.includes('already registered') || signUpError.message.includes('already exists')) {
    setError('Cet email est déjà utilisé. Connecte-toi plutôt.');
  } else {
    setError(signUpError.message);
  }
  setLoading(false); return; 
}

if (data?.user || data?.session === null) {
          setLoading(false);
          setError("✅ Compte créé ! Vérifie ta boîte mail (" + form.email + ") et clique sur le lien de confirmation pour accéder à Nunya Academy.");
          return;
        }
      } else {
        const { data, error: signInError } = await supabase.auth.signInWithPassword({
          email: form.email, password: form.password,
        });
        if (signInError) { setError("Email ou mot de passe incorrect."); setLoading(false); return; }

        if (data?.user) {
          const { data: profile } = await supabase.from("profiles").select("*").eq("id", data.user.id).maybeSingle();
if (!data.user.email_confirmed_at) {
            setError("Confirme ton adresse email avant de te connecter. Vérifie ta boîte mail.");
            await supabase.auth.signOut();
            setLoading(false);
            return;
          }
          if (profile?.status === "banned") {
            setError("Ce compte a été banni. Contacte support@nunya.academy.");
            await supabase.auth.signOut(); setLoading(false); return;
          }
          if (profile?.status === "suspended") {
            setError("Ce compte est temporairement suspendu. Contacte support@nunya.academy.");
            await supabase.auth.signOut(); setLoading(false); return;
          }

          if (!profile) {
            // Créer le profil s'il n'existe pas (après confirmation email)
            const newProfile = {
              id: data.user.id,
              name: data.user.user_metadata?.name || 'Élève',
              plan: data.user.user_metadata?.plan || 'Gratuit',
              role: data.user.user_metadata?.role || 'student',
              profile_type: data.user.user_metadata?.role || 'student',
              level: data.user.user_metadata?.level || '6ème',
              country: data.user.user_metadata?.country || '',
              specialties: JSON.parse(data.user.user_metadata?.specialties || '[]'),
              dob: data.user.user_metadata?.dob || null,
              xp: 0, streak: 0, badges: [], status: 'active',
            };
            const { error: insertError } = await supabase.from('profiles').insert(newProfile);
console.log('Profile insert result:', insertError);
            const role = newProfile.role;
            onAuth({
              ...newProfile,
              email: form.email,
              profileType: newProfile.role,
              last_activity: null,
              must_change_password: false,
              plan_expires_at: null,
            });
            setLoading(false);
            return;
          }
          const role = profile?.role || "student";
          onAuth({
            id: data.user.id,
            name: profile?.name || "Utilisateur",
            email: form.email,
            level: profile?.level || (role==="parent" ? "Parent" : "6ème"),
            country: profile?.country || "",
            plan: profile?.plan || "Gratuit",
            plan_expires_at: profile?.plan_expires_at || null,
            role,
            profileType: profile?.profile_type || "student",
            xp: profile?.xp || 0,
            streak: profile?.streak || 0,
            last_activity: profile?.last_activity,
            badges: profile?.badges || [],
            specialties: profile?.specialties || [],
            parent_email: profile?.parent_email,
            dob: profile?.dob,
            must_change_password: profile?.must_change_password || false,
          });
        }
      }
    } catch (e) {
      setError("Une erreur est survenue. Réessaie.");
    }
    setLoading(false);
  };



  // ── Écran connexion ────────────────────────────────────────────────────────
 
  if (!isRegister) return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ width:"100%", maxWidth:420 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <NunyaLogo size="lg" />
          <h2 style={{ fontFamily:"var(--font-display)", fontSize:26, fontWeight:700, color:"var(--text)", marginTop:20, marginBottom:8 }}>
            Bon retour ! 👋
          </h2>
          <p style={{ color:"var(--muted)", fontSize:14 }}>Connecte-toi pour continuer</p>
        </div>

        <Surface style={{ padding:28 }}>
          <InputField label="Email" type="email" value={form.email}
            onChange={e => setForm(f=>({...f,email:e.target.value}))} placeholder="ton@email.com" required />
          <InputField label="Mot de passe" type="password" value={form.password}
            onChange={e => setForm(f=>({...f,password:e.target.value}))} placeholder="Ton mot de passe" required />

          {error && <p style={{ color:"var(--red)", fontSize:13, marginBottom:12, background:"rgba(239,68,68,0.08)", padding:"10px 14px", borderRadius:8 }}>{error}</p>}

          <Btn onClick={handleSubmit} color="var(--gold)" size="lg" loading={loading} style={{ width:"100%", borderRadius:12 }}>
            {loading ? "Connexion..." : "Se connecter →"}
          </Btn>

          <p style={{ textAlign:"center", marginTop:16, fontSize:14, color:"var(--muted)" }}>
            Pas encore de compte ?{" "}
            <button onClick={() => setMode("register")} style={{ background:"none", border:"none", color:"var(--gold)", cursor:"pointer", fontWeight:700, fontSize:14 }}>
              S'inscrire
            </button>
          </p>
        </Surface>
      </div>
    </div>
  );

  // ── Écran inscription — Étape 0 : choix du profil ─────────────────────────
  if (isRegister && !profileType) return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ width:"100%", maxWidth:460 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <NunyaLogo size="lg" />
          <h2 style={{ fontFamily:"var(--font-display)", fontSize:26, fontWeight:700, color:"var(--text)", marginTop:20, marginBottom:8 }}>
            Bienvenue sur Nunya ! 🎓
          </h2>
          <p style={{ color:"var(--muted)", fontSize:14 }}>Tu es :</p>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:24 }}>
          <button onClick={() => setProfileType("student")} className="btn-hover"
            style={{ padding:"28px 16px", borderRadius:16, border:"2px solid var(--border)", background:"var(--surface)", cursor:"pointer", textAlign:"center", transition:"all 0.18s" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor="var(--gold)"; e.currentTarget.style.background="var(--gold-light)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor="var(--border)"; e.currentTarget.style.background="var(--surface)"; }}>
            <div style={{ fontSize:44, marginBottom:12 }}>👨‍🎓</div>
            <p style={{ fontSize:17, fontWeight:700, color:"var(--text)", marginBottom:4 }}>Élève</p>
            <p style={{ fontSize:12, color:"var(--muted)" }}>Je veux apprendre</p>
          </button>

          <button onClick={() => setProfileType("parent")} className="btn-hover"
            style={{ padding:"28px 16px", borderRadius:16, border:"2px solid var(--border)", background:"var(--surface)", cursor:"pointer", textAlign:"center", transition:"all 0.18s" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor="var(--blue)"; e.currentTarget.style.background="rgba(26,86,219,0.05)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor="var(--border)"; e.currentTarget.style.background="var(--surface)"; }}>
            <div style={{ fontSize:44, marginBottom:12 }}>👨‍👩‍👧</div>
            <p style={{ fontSize:17, fontWeight:700, color:"var(--text)", marginBottom:4 }}>Parent / Tuteur</p>
            <p style={{ fontSize:12, color:"var(--muted)" }}>Je suis le parent d'un élève</p>
          </button>
        </div>

        <p style={{ textAlign:"center", fontSize:14, color:"var(--muted)" }}>
          Déjà un compte ?{" "}
          <button onClick={() => setMode("login")} style={{ background:"none", border:"none", color:"var(--gold)", cursor:"pointer", fontWeight:700, fontSize:14 }}>
            Se connecter
          </button>
        </p>
      </div>
    </div>
  );

  // ── Écran inscription — Formulaire selon profil ────────────────────────────
  return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", padding:"24px 16px" }}>
      <div style={{ maxWidth:480, margin:"0 auto" }}>

        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:24 }}>
          <button onClick={() => setProfileType(null)} aria-label="Retour"
            style={{ background:"none", border:"none", color:"var(--muted)", fontSize:22, cursor:"pointer", padding:4 }}>←</button>
          <div>
            <NunyaLogo size="sm" />
          </div>
          <div style={{ marginLeft:"auto" }}>
            <Chip color={isParent?"var(--blue)":"var(--gold)"}>
              {isParent ? "👨‍👩‍👧 Parent" : "👨‍🎓 Élève"}
            </Chip>
          </div>
        </div>

        <h2 style={{ fontFamily:"var(--font-display)", fontSize:24, fontWeight:700, color:"var(--text)", marginBottom:4 }}>
          Créer mon compte
        </h2>
        <p style={{ color:"var(--muted)", fontSize:13, marginBottom:24 }}>
          {isParent ? "Suivez la progression de vos enfants." : "Rejoins 120+ pays dans le monde."}
        </p>

        <Surface style={{ padding:24 }}>

          {/* Champs communs */}
          <InputField label="Prénom" value={form.name}
            onChange={e => setForm(f=>({...f,name:e.target.value}))} placeholder="Ton prénom" required />

          <InputField label="Date de naissance" type="date" value={form.dob}
            onChange={e => setForm(f=>({...f,dob:e.target.value}))} required />

          <InputField label="Email" type="email" value={form.email}
            onChange={e => setForm(f=>({...f,email:e.target.value}))} placeholder="ton@email.com" required />

          <div style={{ marginBottom:14 }}>
           <label htmlFor="password-main" style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>
  Mot de passe <span style={{ color:"var(--red)" }}>*</span>
</label>
<input id="password-main" type="password" value={form.password}
              onChange={e => setForm(f=>({...f,password:e.target.value}))}
              placeholder="Min. 8 car. + majuscule + chiffre"
              style={{ width:"100%", padding:"12px 16px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:15, outline:"none", boxSizing:"border-box" }}
              onFocus={e => e.target.style.borderColor="var(--gold)"}
              onBlur={e => e.target.style.borderColor="var(--border)"} />
            <p style={{ fontSize:11, color:"var(--muted)", marginTop:4 }}>Minimum 8 caractères, 1 majuscule, 1 chiffre</p>
          </div>

          {/* Pays */}
          <div style={{ marginBottom:14 }}>
            <label htmlFor="country-1" style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>
  Pays <span style={{ color:"var(--red)" }}>*</span>
</label>
<select id="country-1" value={form.country} onChange={e => setForm(f=>({...f,country:e.target.value}))}
              style={{ width:"100%", padding:"12px 16px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}>
              <option value="">Sélectionne ton pays</option>
              {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>

          {/* ÉLÈVE — Cycle + Classe + Spécialités */}
          {isStudent && (
            <>
              <div style={{ marginBottom:14 }}>
                <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:8 }}>
                  Cycle <span style={{ color:"var(--red)" }}>*</span>
                </label>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}>
                  {/* Générale */}
                  <button onClick={() => setForm(f=>({...f,cycle:"secondaire",level:""}))}
                    style={{ padding:"14px 6px", borderRadius:12, border:`2px solid ${form.cycle==="secondaire"?"var(--gold)":"var(--border)"}`, background:form.cycle==="secondaire"?"var(--gold-light)":"var(--surface2)", color:form.cycle==="secondaire"?"var(--gold)":"var(--text)", fontFamily:"var(--font-body)", fontSize:12, fontWeight:700, cursor:"pointer", textAlign:"center" }}>
                    📚 Générale<br/><span style={{ fontSize:10, fontWeight:400, opacity:0.7 }}>6ème → Terminale</span>
                  </button>
                  {/* Techno — grisé */}
                  <div style={{ padding:"14px 6px", borderRadius:12, border:"2px dashed var(--border)", background:"var(--surface2)", color:"var(--faint)", textAlign:"center", opacity:0.5 }}>
                    ⚙️ Techno<br/><span style={{ fontSize:10 }}>🔒 Bientôt</span>
                  </div>
                  {/* Pro — grisé */}
                  <div style={{ padding:"14px 6px", borderRadius:12, border:"2px dashed var(--border)", background:"var(--surface2)", color:"var(--faint)", textAlign:"center", opacity:0.5 }}>
                    🔧 Pro<br/><span style={{ fontSize:10 }}>🔒 Bientôt</span>
                  </div>
                </div>
                {/* Supérieur */}
                <div style={{ marginTop:8, padding:"14px 8px", borderRadius:12, border:"2px dashed var(--border)", background:"var(--surface2)", color:"var(--faint)", textAlign:"center", opacity:0.5 }}>
                  🎓 Supérieur<br/><span style={{ fontSize:11 }}>🔒 Bientôt</span>
                </div>
              </div>

              {form.cycle === "secondaire" && (
                <div style={{ marginBottom:14 }}>
                  <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:8 }}>
                    Classe <span style={{ color:"var(--red)" }}>*</span>
                  </label>
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:6 }}>
                    {LEVELS.map(l => (
                      <button key={l} onClick={() => setForm(f=>({...f,level:l,specialties:[]}))}
                        style={{ padding:"8px 4px", borderRadius:8, fontSize:12, fontWeight:600, border:`1.5px solid ${form.level===l?"var(--gold)":"var(--border)"}`, background:form.level===l?"var(--gold-light)":"var(--surface2)", color:form.level===l?"var(--gold)":"var(--text)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
                        {l}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {needsSpecialties && (
                <div style={{ marginBottom:14 }}>
                  <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>
                    Spécialités <span style={{ color:"var(--gold)", fontWeight:700 }}>
                      ({form.level==="1ère Générale"?"exactement 3":"exactement 2"} — {(form.specialties||[]).length}/{form.level==="1ère Générale"?3:2})
                    </span>
                  </label>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:6 }}>
                    {SPECIALTIES.map(sp => {
                      const selected = (form.specialties||[]).includes(sp.id);
                      const maxReached = (form.specialties||[]).length >= maxSpecialties && !selected;
                      return (
                        <button key={sp.id} onClick={() => toggleSpecialty(sp.id)} disabled={maxReached}
                          style={{ padding:"8px 10px", borderRadius:8, fontSize:12, fontWeight:500, border:`1.5px solid ${selected?"var(--gold)":"var(--border)"}`, background:selected?"var(--gold-light)":"var(--surface2)", color:selected?"var(--gold)":maxReached?"var(--faint)":"var(--text)", cursor:maxReached?"not-allowed":"pointer", fontFamily:"var(--font-body)", textAlign:"left", display:"flex", alignItems:"center", gap:6, opacity:maxReached?0.5:1 }}>
                          <span>{sp.icon}</span> {sp.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </>
          )}

          {/* Plan tarifaire */}
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:8 }}>
              Plan tarifaire <span style={{ color:"var(--red)" }}>*</span>
            </label>
            {/* Switch devise */}
            <div style={{ display:"flex", gap:6, overflowX:"auto", paddingBottom:6, marginBottom:10 }}>
              {[
                { id:"fcfa", label:"FCFA" },
                { id:"eur",  label:"€ EUR" },
                { id:"usd",  label:"$ USD" },
                { id:"gbp",  label:"£ GBP" },
                { id:"cad",  label:"CA$" },
                { id:"cny",  label:"¥ CNY" },
                { id:"aed",  label:"AED" },
              ].map(c => (
                <button key={c.id} onClick={() => setForm(f=>({...f, currency: c.id }))}
                  style={{
                    flexShrink:0, padding:"4px 10px", borderRadius:100, fontSize:11, fontWeight:700,
                    border:`1.5px solid ${(form.currency||"usd")===c.id?"var(--gold)":"var(--border)"}`,
                    background:(form.currency||"usd")===c.id?"var(--gold-light)":"transparent",
                    color:(form.currency||"usd")===c.id?"var(--gold)":"var(--muted)",
                    cursor:"pointer", fontFamily:"var(--font-body)",
                  }}>
                  {c.label}
                </button>
              ))}
            </div>
            {/* Cartes plans */}
            <div style={{ display:"grid", gridTemplateColumns:isParent?"1fr 1fr":"repeat(2,1fr)", gap:8 }}>
              {(isParent
                ? [
                    { id:"Premium", icon:"💎", desc:"1 enfant suivi", color:"var(--gold)" },
                    { id:"Famille", icon:"👨‍👩‍👧", desc:"Jusqu'à 4 enfants", color:"var(--purple)" },
                  ]
                : [
                    { id:"Gratuit",   icon:"🎓", desc:"3 chapitres/matière", color:"var(--muted)" },
                    { id:"Essentiel", icon:"⭐", desc:"Tout débloquer", color:"var(--blue)" },
                    { id:"Premium",   icon:"💎", desc:"+ 1 parent", color:"var(--gold)" },
                    { id:"Famille",   icon:"👨‍👩‍👧", desc:"+ 4 enfants", color:"var(--purple)" },
                  ]
              ).map(p => {
                const cur = form.currency || "usd";
                const planData = PLANS[p.id];
                const price = planData ? (planData[cur] === 0 || planData[cur] === "0" ? "Gratuit" : `${cur==="fcfa"?"FCFA":cur==="eur"?"€":cur==="usd"?"$":cur==="gbp"?"£":cur==="cad"?"CA$":cur==="cny"?"¥":"د.إ"} ${planData[cur]}`) : "";
                return (
                  <button key={p.id} onClick={() => setForm(f=>({...f,plan:p.id}))}
                    style={{ padding:"12px 8px", borderRadius:10, border:`2px solid ${form.plan===p.id?p.color:"var(--border)"}`, background:form.plan===p.id?`${p.color}15`:"var(--surface2)", cursor:"pointer", fontFamily:"var(--font-body)", textAlign:"center", transition:"all 0.15s" }}>
                    <div style={{ fontSize:22, marginBottom:4 }}>{p.icon}</div>
                    <p style={{ fontSize:13, fontWeight:700, color:form.plan===p.id?p.color:"var(--text)", marginBottom:2 }}>{p.id}</p>
                    <p style={{ fontSize:11, fontWeight:700, color:p.color, marginBottom:2 }}>{price}</p>
                    <p style={{ fontSize:10, color:"var(--muted)" }}>{p.desc}</p>
                  </button>
                );
              })}
            </div>
            {/* Sélecteur durée — visible seulement pour plans payants */}
            {["Essentiel","Premium","Famille"].includes(form.plan) && (
              <div style={{ marginTop:10, display:"flex", gap:8 }}>
                <button onClick={() => setForm(f=>({...f, billing:'monthly'}))}
                  style={{
                    flex:1, padding:"8px", borderRadius:8, fontSize:12, fontWeight:600,
                    border:`1.5px solid ${(form.billing||'monthly')==='monthly'?"var(--gold)":"var(--border)"}`,
                    background:(form.billing||'monthly')==='monthly'?"var(--gold-light)":"transparent",
                    color:(form.billing||'monthly')==='monthly'?"var(--gold)":"var(--muted)",
                    cursor:"pointer", fontFamily:"var(--font-body)"
                  }}>
                  Mensuel
                </button>
                <button onClick={() => setForm(f=>({...f, billing:'annual'}))}
                  style={{
                    flex:1, padding:"8px", borderRadius:8, fontSize:12, fontWeight:600,
                    border:`1.5px solid ${form.billing==='annual'?"var(--gold)":"var(--border)"}`,
                    background:form.billing==='annual'?"var(--gold-light)":"transparent",
                    color:form.billing==='annual'?"var(--gold)":"var(--muted)",
                    cursor:"pointer", fontFamily:"var(--font-body)"
                  }}>
                  Annuel 🎁 (-2 mois)
                </button>
              </div>
            )}
          </div>

          {form.dob && Math.floor((Date.now() - new Date(form.dob)) / 31536000000) < 13 && (
  <div style={{ display:"flex", alignItems:"flex-start", gap:10, marginBottom:16, background:"rgba(201,151,44,0.06)", padding:"12px 14px", borderRadius:10, border:"1px solid var(--gold)" }}>
    <input type="checkbox" aria-label="Je certifie avoir l'autorisation de mes parents" checked={parentalConsent} onChange={e => setParentalConsent(e.target.checked)}
      style={{ marginTop:3, cursor:"pointer", accentColor:"var(--gold)", width:16, height:16 }} />
    <span style={{ fontSize:13, color:"var(--text)", lineHeight:1.5 }}>
      👨‍👩‍👧 Je certifie avoir l'autorisation de mes parents ou tuteur légal pour m'inscrire sur Nunya Academy.
    </span>
  </div>
)}
          {/* CGU */}
          <div style={{ display:"flex", alignItems:"flex-start", gap:10, marginBottom:16 }}>
            <input type="checkbox" aria-label="J'accepte les conditions d'utilisation" checked={cguAccepted} onChange={e => setCguAccepted(e.target.checked)}
              style={{ marginTop:3, cursor:"pointer", accentColor:"var(--gold)", width:16, height:16 }} />
            <span style={{ fontSize:13, color:"var(--muted)", lineHeight:1.5 }}>
              J'accepte les{" "}
              <a href="https://nunya.academy/cgu.html" target="_blank" rel="noopener noreferrer" style={{ color:"var(--gold)", fontSize:13, fontWeight:600, textDecoration:"underline" }}>
  conditions d'utilisation
</a>
            </span>
          </div>

          {error && <p style={{ color:"var(--red)", fontSize:13, marginBottom:12, background:"rgba(239,68,68,0.08)", padding:"10px 14px", borderRadius:8 }}>{error}</p>}

          <Btn onClick={handleSubmit} color={isParent?"var(--blue)":"var(--gold)"} size="lg" loading={loading} style={{ width:"100%", borderRadius:12 }}>
            {loading ? "Création en cours..." : "Créer mon compte 🚀"}
          </Btn>

          <p style={{ textAlign:"center", marginTop:16, fontSize:14, color:"var(--muted)" }}>
            Déjà un compte ?{" "}
            <button onClick={() => setMode("login")} style={{ background:"none", border:"none", color:"var(--gold)", cursor:"pointer", fontWeight:700, fontSize:14 }}>
              Se connecter
            </button>
          </p>

        </Surface>
      </div>
    </div>
  );
};


// ─── BOTTOM NAVIGATION ────────────────────────────────────────────────────────
const BottomNav = ({ screen, onNav, user }) => {
  const tabs = [
    { id:"dashboard", icon:"🏠", label:"Accueil" },
    { id:"learn",     icon:"📚", label:"Apprendre" },
    { id:"leagues",   icon:"🏆", label:"Ligues" },
    { id:"me",        icon:"👤", label:"Moi" },
  ];
  return (
    <nav className="bottom-nav">
      {tabs.map(t => (
        <button
          key={t.id}
          onClick={() => onNav(t.id)}
          className={`bottom-nav-item${screen === t.id ? " active" : ""}`}
        >
          <span className="bottom-nav-icon">{t.icon}</span>
          <span className="bottom-nav-label">{t.label}</span>
        </button>
      ))}
    </nav>
  );
};

// ─── TOP BAR ──────────────────────────────────────────────────────────────────
const TopBar = ({ user, screen, onNav, title = null }) => {
  const screenTitles = {
    dashboard: null,
    learn: "Apprendre",
    leagues: "Ligues",
    me: "Mon profil",
    annales: "Annales",
    parents: "Espace parents",
    settings: "Paramètres",
  };
  const displayTitle = title || screenTitles[screen];

  return (
    <div style={{
      position:"sticky", top:0, zIndex:50,
      background:"rgba(255,255,255,0.95)",
      backdropFilter:"blur(16px)",
      borderBottom:"1px solid var(--border)",
      padding:"0 16px",
      height:56,
      display:"flex",
      justifyContent:"space-between",
      alignItems:"center",
    }}>
      <div
        style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer" }}
        onClick={() => onNav("dashboard")}
      >
        <NunyaLogo size="sm" />
        {displayTitle && (
          <>
            <span style={{ color:"var(--border)", fontSize:16, lineHeight:1 }}>·</span>
            <span style={{ fontSize:13, color:"var(--muted)", fontWeight:500 }}>{displayTitle}</span>
          </>
        )}
      </div>
      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
        <StreakBadge streak={user?.streak || 0} size="sm" />
        <Chip color="var(--gold)" style={{ fontSize:11 }}>
          ⚡ {user?.xp || 0} XP
        </Chip>
      </div>
    </div>
  );
};

// ─── DASHBOARD ────────────────────────────────────────────────────────────────
const Dashboard = ({ user, onNav, onChapter, subjects, levels, lastChapter, dailyChallengeDone, isPreview, currentLevelId }) => {
  const [greeting, setGreeting] = useState("");
  const firstName = (user?.name || "Élève").split(" ")[0];
  const league = [...LEAGUES].reverse().find(l => (user?.xp || 0) >= l.minXP) || LEAGUES[0];
  const nextLeague = LEAGUES[LEAGUES.findIndex(l => l.id === league.id) + 1];
  const xpToNext = nextLeague ? nextLeague.minXP - (user?.xp || 0) : 0;
  const xpPct = nextLeague ? Math.min(100, Math.round(((user?.xp || 0) - league.minXP) / (nextLeague.minXP - league.minXP) * 100)) : 100;

  useEffect(() => {
    const h = new Date().getHours();
    if (h < 12) setGreeting("Bonjour");
    else if (h < 18) setGreeting("Bon après-midi");
    else setGreeting("Bonsoir");
  }, []);
const previewLevel = isPreview ? (levels.find(l => l.id === currentLevelId)?.name || user?.level) : user?.level;
 const getSubjectsForLevel = (level) => {
    const is1ereOrTle = ["1ère","1ère Générale","1ère Techno","1ère Pro","Terminale","Terminale Générale","Terminale Techno","Terminale Pro"].includes(level);
    return subjects.filter(s => {
     if (s.id > 7 && !(s.id === 22 && ["1ère","1ère Générale","Terminale","Terminale Générale"].includes(level))) return false;
      if (s.name === "Philosophie") return ["Terminale Générale","Terminale Techno","Terminale Pro"].includes(level);
      if (s.name === "Français") return !["Terminale Générale","Terminale Techno","Terminale Pro"].includes(level);
      if (s.name === "Économie") return false;
      if (s.name === "Éducation Civique") return false;
      if (s.name === "Espagnol") return false;
      if (is1ereOrTle && ["Mathématiques","SVT","Physique-Chimie"].includes(s.name)) return false;
      if (["1ère","1ère Générale"].includes(level) && s.name === "Philosophie") return false;
      return true;
    });
  };
  const baseSubjects = getSubjectsForLevel(previewLevel || "6ème");
  const hasPremiumPlan = ["Premium","Famille"].includes(user?.plan) || user?.role === "superadmin" || user?.role === "admin";
const specialtySubjects = isPreview && ["1ère Générale","Terminale Générale"].includes(previewLevel)
    ? SPECIALTIES.map(sp => ({ id: "spec_"+sp.id, name: sp.label, icon: sp.icon, isSpecialty:true }))
    : hasPremiumPlan
    ? (user?.specialties || []).map(sid => {
        const sp = SPECIALTIES.find(s => s.id === sid);
        return sp ? { id: "spec_"+sp.id, name: sp.label, icon: sp.icon, isSpecialty:true } : null;
      }).filter(Boolean)
    : [];
  const userSubjects = [...baseSubjects, ...specialtySubjects];

  return (
    <div className="main-content fade">
      <TopBar user={user} screen="dashboard" onNav={onNav} />

      <div style={{ padding:"20px 16px" }}>

        {/* Greeting + Streak */}
        <div style={{ marginBottom:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
            <div>
              <h2 style={{ fontFamily:"var(--font-display)", fontSize:24, fontWeight:700, color:"var(--text)" }}>
                {greeting}, {firstName} !
              </h2>
              <p style={{ color:"var(--muted)", fontSize:13, marginTop:2 }}>
                {previewLevel || user?.level} · {user?.country}
              </p>
            </div>
            <StreakBadge streak={user?.streak || 0} size="lg" />
          </div>

          {/* XP Progress vers ligue suivante */}
          <div style={{ marginTop:16, background:"var(--surface)", borderRadius:12, padding:"14px 16px", border:"1px solid var(--border)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
              <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                <span style={{ fontSize:18 }}>{league.icon}</span>
                <span style={{ fontSize:13, fontWeight:700, color:league.color }}>{league.label}</span>
              </div>
              <span style={{ fontSize:12, color:"var(--muted)" }}>
                {nextLeague ? `${xpToNext} XP → ${nextLeague.label} ${nextLeague.icon}` : "Niveau max 👑"}
              </span>
            </div>
            <ProgressBar value={xpPct} max={100} color={league.color} />
            <p style={{ fontSize:11, color:"var(--muted)", marginTop:6 }}>
              ⚡ {user?.xp || 0} XP au total
            </p>
          </div>
        </div>

        {/* Continuer ma leçon */}
        {lastChapter && (
          <div style={{ marginBottom:20 }}>
            <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10 }}>
              ▶ CONTINUER
            </p>
            <div
              onClick={() => onChapter(lastChapter)}
              className="card-hover"
              style={{
                background:`linear-gradient(135deg, var(--navy) 0%, #1A3A6B 100%)`,
                borderRadius:16, padding:20, cursor:"pointer",
                border:"none", display:"flex", alignItems:"center", gap:16,
              }}
            >
              <div style={{ width:48, height:48, borderRadius:12, background:"rgba(201,151,44,0.2)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, flexShrink:0 }}>
                {getSubjectIcon(lastChapter.subjectName)}
              </div>
              <div style={{ flex:1 }}>
                <p style={{ fontSize:11, color:"rgba(255,255,255,0.6)", marginBottom:4 }}>
                  {lastChapter.subjectName} · {user?.level}
                </p>
                <p style={{ fontSize:16, fontWeight:700, color:"#fff", marginBottom:6 }}>{lastChapter.title}</p>
                <ProgressBar value={lastChapter.progress || 0} max={100} color="var(--gold)" style={{ height:4 }} />
              </div>
              <span style={{ color:"var(--gold)", fontSize:22, flexShrink:0 }}>→</span>
            </div>
          </div>
        )}

        {/* Message d'encouragement parent non lu */}
        {user?.hasUnreadFamilyMessage && (
          <div style={{ background:"linear-gradient(135deg, #C9972C, #E8B84B)", borderRadius:14, padding:"14px 16px", marginBottom:16, display:"flex", alignItems:"center", gap:12 }}>
            <span style={{ fontSize:24 }}>💛</span>
            <div style={{ flex:1 }}>
              <p style={{ fontSize:13, fontWeight:700, color:"#fff" }}>Nouveau message de ta famille !</p>
              <p style={{ fontSize:11, color:"rgba(255,255,255,0.8)" }}>Ton parent t'a envoyé un encouragement</p>
            </div>
            <span style={{ color:"#fff", fontSize:13, fontWeight:600 }}>Voir →</span>
          </div>
        )}

        {/* Banner upgrade si Gratuit */}
        {!hasFullAccess(user) && (
          <div
            onClick={() => onNav("plans")}
            style={{ background:"linear-gradient(135deg,var(--navy),#1A3A6B)", borderRadius:14, padding:"14px 16px", marginBottom:16, display:"flex", alignItems:"center", gap:12, cursor:"pointer" }}
          >
            <span style={{ fontSize:24 }}>💎</span>
            <div style={{ flex:1 }}>
              <p style={{ fontSize:13, fontWeight:700, color:"var(--gold)" }}>Plan Gratuit actif</p>
              <p style={{ fontSize:11, color:"rgba(255,255,255,0.6)" }}>3 chapitres/matière · 5 questions Kodjo/jour</p>
            </div>
            <span style={{ color:"var(--gold)", fontSize:13, fontWeight:600 }}>Upgrader →</span>
          </div>
        )}

        {/* Défi du jour */}
        {!dailyChallengeDone && (
          <div style={{ marginBottom:20 }}>
            <div
              onClick={() => onNav("challenge")}
              className="card-hover"
              style={{
                background:"var(--gold-light)",
                border:"1.5px solid var(--gold)",
                borderRadius:16, padding:16,
                cursor:"pointer",
                display:"flex", alignItems:"center", gap:14,
              }}
            >
              <div style={{ fontSize:32, flexShrink:0 }}>⚡</div>
              <div style={{ flex:1 }}>
                <p style={{ fontSize:11, fontWeight:700, color:"var(--gold)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:4 }}>DÉFI DU JOUR</p>
                <p style={{ fontSize:15, fontWeight:600, color:"var(--text)" }}>10 questions · +50 XP</p>
              </div>
              <Chip color="var(--gold)">Nouveau</Chip>
            </div>
          </div>
        )}

        {/* Mes matières */}
        <div style={{ marginBottom:20 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
            <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em" }}>
              MES MATIÈRES
            </p>
            <button onClick={() => onNav("learn")} style={{ background:"none", border:"none", color:"var(--gold)", fontSize:13, fontWeight:600, cursor:"pointer" }}>
              Tout voir →
            </button>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10 }}>
            {userSubjects.slice(0,9).map(s => (
              <div
                key={s.id}
                onClick={() => onNav("learn", s.id)}
                className="card-hover"
                style={{
                  background:"var(--surface)",
                  border:"1px solid var(--border)",
                  borderRadius:12, padding:"14px 10px",
                  textAlign:"center", cursor:"pointer",
                }}
              >
                <div style={{ fontSize:24, marginBottom:6 }}>{s.isSpecialty ? s.icon : getSubjectIcon(s.name)}</div>
                <p style={{ fontSize:11, fontWeight:600, color:"var(--text)", lineHeight:1.3 }}>{s.name}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Badges récents */}
        {(user?.badges || []).length > 0 && (
          <div style={{ marginBottom:20 }}>
            <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:12 }}>
              MES BADGES
            </p>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              {(user?.badges || []).slice(0,6).map(bid => {
                const badge = BADGES.find(b => b.id === bid);
                if (!badge) return null;
                return (
                  <div key={bid} title={badge.desc} style={{ display:"flex", alignItems:"center", gap:6, background:"var(--surface)", border:"1px solid var(--border)", borderRadius:100, padding:"6px 14px" }}>
                    <span style={{ fontSize:16 }}>{badge.icon}</span>
                    <span style={{ fontSize:12, fontWeight:600, color:"var(--text)" }}>{badge.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

// ─── LISTE DES CHAPITRES ──────────────────────────────────────────────────────
const ChapterList = ({ user, subject, chapters, progress, onChapter, onBack, onNav }) => {
  const [filter, setFilter] = useState("all");
  const levelColor = getLevelColor(user?.level);

  const filtered = chapters.filter(ch => {
    if (filter === "done") return progress[ch.id]?.completed;
    if (filter === "todo") return !progress[ch.id]?.completed;
    return true;
  });

  return (
    <div className="main-content fade">
      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, var(--navy), #1A3A6B)`, padding:"24px 16px 20px" }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:12, display:"flex", alignItems:"center", gap:6 }}>
          ← Retour
        </button>
        <div style={{ display:"flex", alignItems:"center", gap:14 }}>
          <div style={{ width:52, height:52, borderRadius:14, background:"rgba(255,255,255,0.1)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:28 }}>
            {getSubjectIcon(subject?.name)}
          </div>
          <div>
            <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff" }}>{subject?.name}</h2>
            <p style={{ color:"rgba(255,255,255,0.6)", fontSize:13 }}>{user?.level} · {chapters.length} chapitres</p>
          </div>
        </div>

        {/* Progression globale */}
        <div style={{ marginTop:16 }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
            <span style={{ fontSize:12, color:"rgba(255,255,255,0.6)" }}>Progression</span>
            <span style={{ fontSize:12, color:"var(--gold)", fontWeight:600 }}>
              {Object.values(progress).filter(p => p?.completed).length}/{chapters.length} chapitres
            </span>
          </div>
          <ProgressBar
            value={Object.values(progress).filter(p => p?.completed).length}
            max={chapters.length || 1}
            style={{ height:6 }}
          />
        </div>
      </div>

      {/* Filtres */}
      <div style={{ padding:"12px 16px", display:"flex", gap:8, background:"var(--surface)", borderBottom:"1px solid var(--border)" }}>
        {[["all","Tous"],["todo","À faire"],["done","Terminés"]].map(([id,label]) => (
          <button
            key={id}
            onClick={() => setFilter(id)}
            style={{
              padding:"6px 16px", borderRadius:100, fontSize:12, fontWeight:600,
              border:`1px solid ${filter===id?"var(--gold)":"var(--border)"}`,
              background: filter===id?"var(--gold-light)":"transparent",
              color: filter===id?"var(--gold)":"var(--muted)",
              cursor:"pointer", fontFamily:"var(--font-body)",
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Liste chapitres */}
      <div style={{ padding:"12px 16px" }}>
        {filtered.length === 0 ? (
          <EmptyState icon="📭" title="Aucun chapitre" message="Aucun chapitre dans cette catégorie." />
        ) : (
          filtered.map((ch, idx) => {
            const prog = progress[ch.id];
            const done = prog?.completed;
            const score = prog?.score || 0;
            return (
              (() => {
                const locked = isChapterLocked(idx, user);
                return (
                  <div
                    key={ch.id}
                    onClick={() => !locked && onChapter(ch, subject)}
                    className={locked ? "" : "card-hover"}
                    style={{
                      background: locked ? "var(--surface2)" : "var(--surface)",
                      border:`1px solid ${locked?"var(--border2)":done?"var(--green)":"var(--border)"}`,
                      borderRadius:14, padding:16, marginBottom:10,
                      display:"flex", alignItems:"center", gap:14,
                      cursor: locked ? "not-allowed" : "pointer",
                      opacity: locked ? 0.7 : 1,
                    }}
                  >
                    <div style={{
                      width:40, height:40, borderRadius:10, flexShrink:0,
                      background: locked ? "var(--border)" : done ? "rgba(16,185,129,0.1)" : "var(--surface2)",
                      border: `1.5px solid ${locked?"var(--border)":done?"var(--green)":"var(--border)"}`,
                      display:"flex", alignItems:"center", justifyContent:"center",
                      fontSize:16, fontWeight:700, color: locked ? "var(--faint)" : done ? "var(--green)" : "var(--muted)",
                    }}>
                      {locked ? "🔒" : done ? "✓" : idx + 1}
                    </div>
                    <div style={{ flex:1 }}>
                      <p style={{ fontSize:15, fontWeight:600, color: locked ? "var(--muted)" : "var(--text)", marginBottom:4 }}>{ch.title}</p>
                      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                        {locked ? (
                          <span style={{ fontSize:11, color:"var(--gold)", fontWeight:600 }}>
                            Plan Essentiel requis
                          </span>
                        ) : (
                          <>
                            <span style={{ fontSize:11, color:"var(--muted)" }}>⏱ 5-10 min</span>
                            {score > 0 && <Chip color="var(--green)" style={{ fontSize:10 }}>Score: {score}</Chip>}
                          </>
                        )}
                      </div>
                      {!locked && prog && <ProgressBar value={score} max={10} color="var(--green)" style={{ marginTop:6, height:3 }} />}
                    </div>
                    {locked ? (
                      <Btn onClick={e => { e.stopPropagation(); onNav && onNav("upgrade"); }} color="var(--gold)" size="sm" variant="soft" style={{ flexShrink:0, fontSize:11 }}>
  Débloquer
</Btn>
                    ) : (
                      <span style={{ color:"var(--faint)", fontSize:18 }}>›</span>
                    )}
                  </div>
                );
              })()
            );
          })
        )}
      </div>
    </div>
  );
};

// ─── CONTENU D'UN CHAPITRE ────────────────────────────────────────────────────
const LessonContent = ({ content, color = "var(--gold)", onKodjo }) => {
  if (!content || content === "...") return (
    <div style={{ textAlign:"center", padding:"32px 16px" }}>
      <p style={{ fontSize:32, marginBottom:12 }}>🚧</p>
      <p style={{ color:"var(--muted)", fontSize:14 }}>Ce cours arrive bientôt.</p>
    </div>
  );

  // Détecter si le contenu est du JSON v2.0
  let parsed = null;
  try {
    const fixEncoding = (str) => {
  try {
    return decodeURIComponent(escape(str));
  } catch(e) {
    return str;
  }
};
const candidate = typeof content === "string" ? JSON.parse(fixEncoding(content)) : content;
    if (candidate?.v === "2.0" && Array.isArray(candidate?.blocs)) {
      parsed = candidate;
    }
  } catch (e) {}

  // ── Renderer JSON v2.0 ──────────────────────────────────────────────────────
  if (parsed) {
    const { meta, blocs } = parsed;
    const renderText = (text) => {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return parts.map((part, idx) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={idx} style={{ fontWeight:700, color:"var(--text)" }}>{part.slice(2,-2)}</strong>;
    }
    if (part.startsWith("*") && part.endsWith("*")) {
      return <em key={idx} style={{ fontStyle:"italic", color:"var(--text)" }}>{part.slice(1,-1)}</em>;
    }
    return part;
  });
};
    return (
      <div style={{ fontSize:15, lineHeight:1.9, color:"var(--text)", fontFamily:"var(--font-body)" }}>
        {/* Objectifs */}
        {meta?.objectifs?.length > 0 && (
          <div style={{ background:`${color}10`, border:`1px solid ${color}30`, borderRadius:10, padding:"12px 16px", marginBottom:20 }}>
            <p style={{ fontSize:11, fontWeight:700, color, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>🎯 Objectifs</p>
            {meta.objectifs.map((o, i) => (
              <div key={i} style={{ display:"flex", gap:8, alignItems:"flex-start", marginBottom:4 }}>
                <span style={{ color, flexShrink:0 }}>✓</span>
                <span style={{ fontSize:13 }}>{o}</span>
              </div>
            ))}
          </div>
        )}
        {/* Blocs */}
        {blocs.map((bloc, i) => {
          switch (bloc.t) {
            case "accroche":
              return (
                <div key={i} style={{ background:"var(--surface2)", borderLeft:`4px solid ${color}`, borderRadius:"0 10px 10px 0", padding:"14px 16px", marginBottom:20, fontStyle:"italic", fontSize:16, color:"var(--text)" }}>
                  💭 {bloc.c}
                </div>
              );
            case "kodjo":
              return (
                <div key={i} onClick={() => onKodjo && onKodjo(bloc.c)} style={{ background:"var(--surface2)", border:"1px solid var(--border)", borderRadius:12, padding:"14px 16px", marginBottom:20, display:"flex", gap:12, cursor:"pointer", transition:"all 0.2s" }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor="var(--gold)"; e.currentTarget.style.background="var(--gold-light)"; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor="var(--border)"; e.currentTarget.style.background="var(--surface2)"; }}
                >
                  <span style={{ fontSize:22, flexShrink:0 }}>🤖</span>
                  <div style={{ flex:1 }}>
                    <p style={{ fontSize:11, fontWeight:700, color:"var(--gold)", marginBottom:4, textTransform:"uppercase", letterSpacing:"0.04em" }}>Kodjo — Clique pour répondre</p>
                    <p style={{ fontSize:14, color:"var(--text)", lineHeight:1.7 }}>{bloc.c}</p>
                  </div>
                  <span style={{ fontSize:18, color:"var(--gold)", alignSelf:"center" }}>→</span>
                </div>
              );
            case "texte":
              return (
                <div key={i} style={{ marginBottom:20 }}>
                  {bloc.c.split("\n").map((line, j) => {
                    const t = line.trim();
                    if (!t) return <div key={j} style={{ height:6 }} />;
                    if (t.startsWith("•") || t.startsWith("→") || t.startsWith("-")) return (
                      <div key={j} style={{ display:"flex", gap:8, paddingLeft:8, marginBottom:4 }}>
                        <span style={{ color, flexShrink:0 }}>•</span>
                        <span>{renderText(t.replace(/^[•→\-]\s*/, ""))}</span>
                      </div>
                    );
                    if (t.startsWith("**") && t.endsWith("**")) return (
                      <p key={j} style={{ fontWeight:700, fontSize:15, color:"var(--text)", marginBottom:6, marginTop:12 }}>{t.replace(/\*\*/g, "")}</p>
                    );
                    if (t.startsWith("## ")) return (
                      <p key={j} style={{ fontWeight:700, fontSize:16, color:"var(--text)", marginTop:16, marginBottom:8, borderLeft:`3px solid ${color}`, paddingLeft:10 }}>{renderText(t.replace(/^## /, ""))}</p>
                    );
                    if (t.startsWith("# ")) return (
                      <p key={j} style={{ fontWeight:700, fontSize:18, color:"var(--text)", marginTop:20, marginBottom:10 }}>{renderText(t.replace(/^# /, ""))}</p>
                    );
                    return <p key={j} style={{ marginBottom:6 }}>{renderText(t)}</p>;
                  })}
                </div>
              );
           case "formule":
              return (
                <div key={i} style={{ background:"var(--navy)", borderRadius:12, padding:"16px 20px", marginBottom:20, textAlign:"center" }}>
                  {bloc.latex ? (
                    <div style={{ color:"var(--gold)", fontSize:20 }} className="katex-formula">
                      <InlineMath math={bloc.latex} />
                    </div>
                  ) : (
                    <p style={{ fontSize:18, fontWeight:700, color:"var(--gold)", fontFamily:"Georgia, serif", letterSpacing:"0.03em" }}>{bloc.c}</p>
                  )}
                </div>
              );
            case "exemple":
              return (
                <div key={i} style={{ background:"var(--surface)", border:`1px solid ${color}40`, borderRadius:12, padding:"16px", marginBottom:20 }}>
                  <p style={{ fontSize:12, fontWeight:700, color, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10 }}>📝 Exemple</p>
                  <p style={{ fontSize:14, color:"var(--text)", marginBottom:12, fontStyle:"italic" }}>{bloc.enonce}</p>
                  {(bloc.etapes || []).map((etape, j) => (
                    <div key={j} style={{ display:"flex", gap:10, marginBottom:6, alignItems:"flex-start" }}>
                      <span style={{ background:color, color:"#fff", borderRadius:"50%", width:20, height:20, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0, marginTop:2 }}>{j+1}</span>
                      <span style={{ fontSize:13, color:"var(--text)", lineHeight:1.6 }}>{renderText(etape)}</span>
                    </div>
                  ))}
                </div>
              );
            case "retenir":
              return (
                <div key={i} style={{ background:`linear-gradient(135deg, ${color}15, ${color}05)`, border:`2px solid ${color}`, borderRadius:12, padding:"16px", marginBottom:20 }}>
                  <p style={{ fontSize:12, fontWeight:700, color, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10 }}>⭐ À retenir</p>
                  {bloc.c.split("\n").map((line, j) => {
                    const t = line.trim();
                    if (!t) return <div key={j} style={{ height:4 }} />;
                    return <p key={j} style={{ fontSize:14, color:"var(--text)", marginBottom:4, lineHeight:1.7 }}>{renderText(t.replace(/^[①②③④⑤]/, ""))}</p>;
                  })}
                </div>
              );
            case "suite":
              return (
                <div key={i} style={{ background:"var(--surface2)", borderRadius:10, padding:"12px 16px", marginBottom:20, display:"flex", gap:10, alignItems:"center" }}>
                  <span style={{ fontSize:18 }}>→</span>
                  <div>
                    <p style={{ fontSize:11, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", marginBottom:2 }}>Prochaine leçon</p>
                    <p style={{ fontSize:13, color:"var(--text)" }}>{bloc.c}</p>
                  </div>
                </div>
              );
            default:
              return <p key={i} style={{ fontSize:14, color:"var(--text)", marginBottom:8 }}>{bloc.c}</p>;
          }
        })}
      </div>
    );
  }

  // ── Renderer texte brut (ancien format) ─────────────────────────────────────
  const format = (text) => {
    let t = text;
    t = t.split("• ").join("\n• ");
    t = t.split("-> ").join("\n-> ");
    const markers = [
      "DÉFINITION","MÉTHODE","EXEMPLES","EXEMPLE","ATTENTION","REMARQUE",
      "TABLEAU","RÈGLE","ÉTAPE 1","ÉTAPE 2","ÉTAPE 3","ÉTAPE 4","ÉTAPE 5",
      "CAS 1","CAS 2","CAS 3","TECHNIQUE","FORMATION","PROPRIÉTÉ",
    ];
    markers.forEach(m => { t = t.split(m).join("\n\n" + m); });
    while (t.includes("\n\n\n")) t = t.split("\n\n\n").join("\n\n");
    return t.trim();
  };
  const lines = format(content).split("\n");
  return (
    <div style={{ fontSize:16, lineHeight:1.9, color:"var(--text)", fontFamily:"var(--font-body)" }}>
      {lines.map((line, i) => {
        const t = line.trim();
        if (!t) return <div key={i} style={{ height:8 }} />;
        if (t.startsWith("• ")) return (
          <div key={i} style={{ display:"flex", gap:10, paddingLeft:8, marginBottom:4 }}>
            <span style={{ color, flexShrink:0, fontWeight:700 }}>•</span>
            <span>{t.substring(2)}</span>
          </div>
        );
        if (t.startsWith("-> ")) return (
          <div key={i} style={{ display:"flex", gap:10, paddingLeft:20, marginBottom:4, color:"var(--muted)" }}>
            <span style={{ color, fontWeight:700, flexShrink:0 }}>→</span>
            <span>{t.substring(3)}</span>
          </div>
        );
        const isMaj = t === t.toUpperCase() && t.length > 2 && t.length < 80 && t.split(" ").length < 12;
        if (isMaj) return (
          <div key={i} style={{ fontWeight:700, color:"var(--text)", fontSize:13, letterSpacing:"0.05em", marginTop:20, marginBottom:8, borderLeft:`3px solid ${color}`, paddingLeft:12, textTransform:"uppercase" }}>
            {t}
          </div>
        );
        if (t.endsWith(":") && t.length < 80) return (
          <div key={i} style={{ fontWeight:700, color:"var(--text)", marginTop:12, marginBottom:4, fontSize:15 }}>
            {t}
          </div>
        );
        return <div key={i} style={{ marginBottom:4 }}>{t}</div>;
      })}
    </div>
  );
};
const ChapterContent = ({ chapter, subject, user, currency, onBack, onNav, onKodjo, onSaveProgress, chapterProgress }) => {
  const [tab, setTab] = useState("cours");
  const [shown, setShown] = useState({});
  const [answered, setAnswered] = useState({});
  const [readMode, setReadMode] = useState("day"); // day, night, sepia
  const [fontSize, setFontSize] = useState(16);
  const [showXP, setShowXP] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
 const lessons = (chapter?.lessons || []).sort((a, b) => (a.order_num || 0) - (b.order_num || 0));
const exercises = chapter?.exercises || [];
const corriges = chapter?.corriges || exercises;
const objectives = chapter?.objectives || [];
const color = subject?.color || "var(--gold)";
const isEssai = !user || user?.plan === "Essai";
const isGratuit = user?.plan === "Gratuit";
const isEssentiel = user?.plan === "Essentiel";
const hasPremium = ["Premium","Famille"].includes(user?.plan);
const isAdmin = ["admin","superadmin"].includes(user?.role);
const canAccessAll = isAdmin || hasPremium || isEssentiel;
const accessibleLessons = lessons;
  useEffect(() => {
    if (user?.id && chapter?.id && onSaveProgress) {
      onSaveProgress(user.id, chapter.dbId || chapter.id, chapterProgress?.score || 0, chapterProgress?.completed || false);
    }
    // Appliquer mode lecture
    document.body.className = readMode === "night" ? "read-night" : readMode === "sepia" ? "read-sepia" : "";
    return () => {};
  }, [chapter?.id, readMode]);

  const handleShowSolution = (exoId) => {
    const already = shown[exoId];
    setShown(s => ({...s, [exoId]: !s[exoId]}));
    if (!already) {
      const newAnswered = {...answered, [exoId]: true};
      setAnswered(newAnswered);
      if (user?.id && exercises.length > 0 && onSaveProgress) {
        const score = Object.keys(newAnswered).length;
        const completed = score >= exercises.length;
        onSaveProgress(user.id, chapter.dbId || chapter.id, score, completed);
        if (completed) {
          setShowConfetti(true);
          setShowXP(true);
          setTimeout(() => setShowXP(false), 2000);
        }
      }
    }
  };

  const tabList = [
    { id:"cours",     label:"📖 Cours" },
    { id:"exercices", label:"✏️ Exercices" },
    { id:"corriges",  label:`✅ Corrigés${!hasPremium?" 🔒":""}` },
  ];

  const readModes = [
    { id:"day",   icon:"☀️", label:"Jour" },
    { id:"sepia", icon:"📜", label:"Sépia" },
    { id:"night", icon:"🌙", label:"Nuit" },
  ];

  return (
    <div className="main-content fade" style={{ maxWidth:720, margin:"0 auto" }}>
      {showConfetti && <Confetti onDone={() => setShowConfetti(false)} />}
      {showXP && <XPFloat amount={30} x="50%" y="30%" onDone={() => setShowXP(false)} />}

      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, var(--navy), #1A3A6B)`, padding:"20px 16px 16px", position:"sticky", top:0, zIndex:40 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:10, display:"flex", alignItems:"center", gap:6 }}>
          ← {subject?.name}
        </button>
        <h2 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"#fff", marginBottom:8 }}>
          {chapter?.title}
        </h2>

        {/* Tabs */}
        <div style={{ display:"flex", gap:6 }}>
          {tabList.map(t => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              style={{
                flex:1, padding:"8px 4px", borderRadius:8, fontSize:12, fontWeight:600,
                border:`1.5px solid ${tab===t.id?"var(--gold)":"rgba(255,255,255,0.2)"}`,
                background: tab===t.id?"rgba(201,151,44,0.2)":"transparent",
                color: tab===t.id?"var(--gold)":"rgba(255,255,255,0.7)",
                cursor:"pointer", fontFamily:"var(--font-body)",
              }}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding:"16px" }}>

        {/* Objectifs */}
        {objectives.length > 0 && (
          <Surface style={{ padding:16, marginBottom:16, borderLeft:`3px solid ${color}` }}>
            <p style={{ fontSize:11, fontWeight:700, color:"var(--gold)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:10 }}>
              🎯 Objectifs du chapitre
            </p>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:6 }}>
              {objectives.map((o, i) => (
                <div key={i} style={{ display:"flex", gap:8, alignItems:"flex-start", fontSize:14, color:"var(--text)" }}>
                  <span style={{ color, flexShrink:0, marginTop:2 }}>✓</span>{o}
                </div>
              ))}
            </div>
          </Surface>
        )}

   {/* COURS */}
{tab === "cours" && (
  <div className="fade">
    {lessons.length === 0 ? (
      <EmptyState icon="🚧" title="Cours en préparation" message="Ce contenu sera disponible très prochainement." />
   ) : (
      <div>
        {accessibleLessons.map((lecon, idx) => (
          <div key={lecon.id || idx} style={{ marginBottom:32 }}>
            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:14 }}>
              <div style={{ width:28, height:28, borderRadius:"50%", background:color, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:700, color:"#fff", flexShrink:0 }}>
                {idx + 1}
              </div>
              <h3 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"var(--text)" }}>
                {lecon.titre || lecon.title}
              </h3>
            </div>
            <Surface style={{ padding:20, marginBottom:12, borderLeft:`2px solid ${color}40` }}>
              <div style={{ fontSize }}>
                <LessonContent content={lecon.contenu || lecon.content} color={color} onKodjo={(question) => { onKodjo && onKodjo(question); }} />
              </div>
            </Surface>
            {lecon.exemples && lecon.exemples.length > 0 && (
              <>
                <p style={{ fontSize:11, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:10 }}>
                  Exemples résolus
                </p>
                {lecon.exemples.map((ex, i) => (
                  <Surface key={i} style={{ padding:16, marginBottom:8, borderLeft:"2px solid var(--blue)" }}>
                    <p style={{ fontSize:14, color:"var(--blue)", marginBottom:8, fontWeight:500 }}>❓ {ex.question}</p>
                    <p style={{ fontSize:14, color:"var(--green)", fontWeight:500 }}>✓ {ex.reponse}</p>
                  </Surface>
                ))}
              </>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
)}

        {/* EXERCICES */}
        {tab === "exercices" && (
          <div className="fade">
            {(() => {
              // Extraire les exercices depuis le JSON v2.0
              let exos = [];
              if (lessons.length > 0) {
                lessons.forEach(lecon => {
                  try {
                    const parsed = typeof lecon.content === "string" ? JSON.parse(lecon.content) : lecon.content;
                    if (parsed?.v === "2.0" && Array.isArray(parsed?.exercices)) {
                      parsed.exercices.forEach((ex, idx) => {
                        exos.push({ ...ex, id: `${lecon.id}_${idx}`, leconTitre: lecon.titre || lecon.title });
                      });
                    }
                  } catch(e) {}
                });
              }
              // Fallback anciens exercices
              if (exos.length === 0 && exercises.length > 0) {
                exos = exercises.map(ex => ({ ...ex, niveau: ex.niveau || "moyen" }));
              }
              if (exos.length === 0) return (
                <EmptyState icon="✏️" title="Exercices en préparation" message="Les exercices de ce chapitre arrivent bientôt." />
              );
              return (
                <>
                  <p style={{ fontSize:13, color:"var(--muted)", marginBottom:16 }}>
                    {exos.length} exercices — 3 niveaux de difficulté
                  </p>
                  {["facile","moyen","difficile"].map(niveau => {
                    const niveauExos = exos.filter(e => (e.niveau||"").toLowerCase() === niveau);
                    if (!niveauExos.length) return null;
                    const colors = { facile:"var(--green)", moyen:"var(--gold)", difficile:"var(--red)" };
                    const labels = { facile:"Facile", moyen:"Moyen", difficile:"Difficile" };
                    const col = colors[niveau];
                    return (
                      <div key={niveau} style={{ marginBottom:24 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12 }}>
                          <div style={{ width:8, height:8, borderRadius:"50%", background:col }} />
                          <p style={{ fontSize:12, fontWeight:700, color:col, textTransform:"uppercase", letterSpacing:"0.06em" }}>{labels[niveau]}</p>
                        </div>
                        {niveauExos.map((ex, i) => (
                          <Surface key={ex.id || i} style={{ padding:16, marginBottom:8 }}>
                            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12 }}>
                              <div style={{ flex:1 }}>
                                <p style={{ fontSize:15, lineHeight:1.7, color:"var(--text)" }}>{ex.enonce}</p>
                                {shown[ex.id || i] && (
                                  <div style={{ marginTop:14, padding:"12px 16px", background:"rgba(26,86,219,0.06)", borderRadius:10, borderLeft:"2px solid var(--blue)" }}>
                                    <p style={{ fontSize:11, fontWeight:700, color:"var(--blue)", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.04em" }}>SOLUTION</p>
                                    <p style={{ fontSize:14, color:"var(--text)", lineHeight:1.7, whiteSpace:"pre-wrap" }}>{ex.solution}</p>
                                  </div>
                                )}
                              </div>
                              <Btn
                                onClick={() => handleShowSolution(ex.id || i)}
                                variant="outline"
                                color={shown[ex.id || i]?"var(--muted)":"var(--gold)"}
                                size="sm"
                                style={{ flexShrink:0 }}
                              >
                                {shown[ex.id || i]?"Masquer":"Solution"}
                              </Btn>
                            </div>
                          </Surface>
                        ))}
                      </div>
                    );
                  })}
                </>
              );
            })()}
          </div>
        )}
        {/* CORRIGÉS */}
        {tab === "corriges" && (
          <div className="fade">
            {!hasPremium ? (
              <div style={{ textAlign:"center", padding:"40px 20px" }}>
                <div style={{ fontSize:48, marginBottom:16 }}>🔒</div>
                <h3 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"var(--text)", marginBottom:8 }}>
                  Corrigés Premium
                </h3>
                <p style={{ color:"var(--muted)", fontSize:14, lineHeight:1.7, marginBottom:24 }}>
                  Accède à tous les corrigés détaillés avec un abonnement Essentiel ou Premium.
                </p>
                <Btn color="var(--gold)" size="lg" onClick={() => onNav && onNav("upgrade")}>
  Passer à Essentiel →
</Btn>
              </div>
            ) : (() => {
              let corriges = [];
              if (lessons.length > 0) {
                lessons.forEach(lecon => {
                  try {
                    const parsed = typeof lecon.content === "string" ? JSON.parse(lecon.content) : lecon.content;
                    if (parsed?.v === "2.0" && Array.isArray(parsed?.exercices)) {
                      parsed.exercices.forEach((ex, idx) => {
                        corriges.push({ ...ex, id: `${lecon.id}_${idx}` });
                      });
                    }
                  } catch(e) {}
                });
              }
              if (corriges.length === 0) return (
                <EmptyState icon="✅" title="Corrigés en préparation" message="Les corrigés de ce chapitre arrivent bientôt." />
              );
              return corriges.map((ex, i) => (
                <Surface key={i} style={{ padding:18, marginBottom:12 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                    <div style={{ width:8, height:8, borderRadius:"50%", background:ex.niveau==="facile"?"var(--green)":ex.niveau==="difficile"?"var(--red)":"var(--gold)" }} />
                    <p style={{ fontSize:11, color:"var(--gold)", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.04em" }}>
                      Exercice {i + 1} — {ex.niveau}
                    </p>
                  </div>
                  <p style={{ fontSize:15, color:"var(--text)", lineHeight:1.7, marginBottom:12, fontStyle:"italic" }}>
                    {ex.enonce}
                  </p>
                  <div style={{ padding:"14px 16px", background:"rgba(16,185,129,0.06)", borderRadius:10, borderLeft:"2px solid var(--green)" }}>
                    <p style={{ fontSize:11, fontWeight:700, color:"var(--green)", marginBottom:8, textTransform:"uppercase", letterSpacing:"0.04em" }}>
                      ✅ CORRIGÉ DÉTAILLÉ
                    </p>
                    <p style={{ fontSize:14, color:"var(--text)", lineHeight:1.8, whiteSpace:"pre-wrap" }}>{ex.solution}</p>
                  </div>
                </Surface>
              ));
            })()}
          </div>
        )}
        {/* Bouton Kodjo */}
        <div style={{ marginTop:24, paddingBottom:8 }}>
          <Btn
            onClick={() => onKodjo && onKodjo(null)}
            variant="soft"
            color="var(--navy)"
            size="md"
            style={{ width:"100%", borderRadius:12 }}
          >
            🤖 Demander à Kodjo
          </Btn>
        </div>
      </div>
    </div>
  );
};

// ─── KODJO — TUTEUR IA ────────────────────────────────────────────────────────
const Kodjo = ({ user, chapter, subject, onClose, proactiveAlert, kodjoQuestion }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const firstName = (user?.name || "Élève").split(" ")[0];

  const SYSTEM_PROMPT = `Tu es Kodjo, le tuteur IA de Nunya Academy. Tu aides les élèves francophones du monde entier.

ÉLÈVE : ${firstName}, en ${user?.level || "6ème"}, pays : ${user?.country || "non renseigné"}
CHAPITRE EN COURS : ${chapter?.title || "non renseigné"} (${subject?.name || "non renseigné"})

MÉTHODE SOCRATIQUE OBLIGATOIRE :
- Ne donne JAMAIS la réponse directement
- Guide avec des questions qui amènent l'élève à réfléchir
- "Qu'est-ce que tu sais déjà sur ce sujet ?"
- "Si on applique la définition, que se passe-t-il ?"
- Maximum 3 questions avant d'expliquer

TON STYLE :
- Chaleureux, encourageant, jamais condescendant
- Utilise le prénom : "Bien ${firstName} !"
- Exemples concrets du quotidien francophone africain
- Célèbre chaque progrès : "Excellent !", "Tu progresses vite !"
- Toujours en français

RÉPONSES :
- Courtes sur mobile (max 4 paragraphes)
- Structure claire avec sauts de ligne
- Commence la 1ère réponse par : "Bonjour ${firstName} ! Je suis là pour t'aider avec ${chapter?.title || 'ce chapitre'}. Qu'est-ce qui te pose problème ?"`;

  useEffect(() => {
    // Message proactif si Kodjo a détecté quelque chose, sinon accueil standard
    if (proactiveAlert) {
      setMessages([{ role:"assistant", content: proactiveAlert.message }]);
    } else {
      const welcome = {
        role:"assistant",
        content: chapter
          ? `Bonjour ${firstName} ! 🤖\n\nJe suis Kodjo, ton tuteur IA. Je suis là pour t'aider avec **${chapter?.title || "ce chapitre"}**.\n\nQu'est-ce qui te pose problème ? N'hésite pas à me poser toutes tes questions — je suis là 24h/24 !`
          : `Bonjour ${firstName} ! 🤖\n\nJe suis Kodjo, ton tuteur IA personnel. Pose-moi une question sur n'importe quelle matière, demande-moi de t'expliquer un concept, ou dis-moi simplement ce qui te tracasse aujourd'hui !`
      };
      const messages = [welcome];
      if (kodjoQuestion) {
  messages.push({ role:"assistant", content: `💡 ${kodjoQuestion}` });
}
      setMessages(messages);
    }
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior:"smooth" });
  }, [messages]);

  const send = async () => {
    if (!input.trim() || loading) return;
    // Vérifier limite Kodjo gratuit
    if (!canUseKodjo(user)) {
      setMessages(m => [...m, { role:"assistant", content: !user ? "Tu as atteint ta limite de 3 questions en mode Essai. 😊 Inscris-toi gratuitement pour 10 questions/jour avec Kodjo !" : "Tu as atteint ta limite de 10 questions aujourd'hui avec le plan Gratuit. 😊 Passe à Essentiel pour un accès illimité à Kodjo !" }]);
      return;
    }
    incrementKodjoUsage(user?.id);
    const userMsg = { role:"user", content:input.trim() };
    setMessages(m => [...m, userMsg]);
    setInput("");
    setLoading(true);

    try {
      const { data, error } = await supabase.functions.invoke("kodjo-chat", {
        body: {
          messages: [...messages, userMsg].map(m => ({ role:m.role, content:m.content })),
          systemPrompt: SYSTEM_PROMPT,
        },
      });
      if (error || data?.error) {
        throw new Error(data?.error || error?.message || "Erreur Kodjo");
      }
      setMessages(m => [...m, { role:"assistant", content: data.reply }]);
    } catch (e) {
      setMessages(m => [...m, { role:"assistant", content:"Désolé, je n'arrive pas à répondre pour le moment. Réessaie dans un instant !" }]);
    }
    setLoading(false);
  };

  return (
    <div className="fade" style={{ display:"flex", flexDirection:"column", height:"100vh", background:"var(--bg)" }}>

      {/* Header */}
      <div style={{ background:"var(--navy)", padding:"16px", display:"flex", alignItems:"center", gap:12, flexShrink:0 }}>
        <button onClick={onClose} aria-label="Fermer" style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:22, cursor:"pointer" }}>←</button>
        <div style={{ width:40, height:40, borderRadius:"50%", background:"rgba(201,151,44,0.2)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>🤖</div>
        <div>
          <p style={{ fontSize:15, fontWeight:700, color:"#fff" }}>Kodjo</p>
          <p style={{ fontSize:12, color:"rgba(255,255,255,0.5)" }}>Tuteur IA · {chapter?.title || "Assistance générale"}</p>
        </div>
        <div style={{ marginLeft:"auto" }}>
          <div style={{ width:8, height:8, borderRadius:"50%", background:"var(--green)", display:"inline-block" }} />
          <span style={{ fontSize:11, color:"rgba(255,255,255,0.5)", marginLeft:6 }}>En ligne</span>
        </div>
      </div>

      {/* Messages */}
      <div style={{ flex:1, overflow:"auto", padding:"16px", display:"flex", flexDirection:"column", gap:12 }}>
        {messages.map((m, i) => (
          <div key={i} style={{ display:"flex", justifyContent: m.role==="user" ? "flex-end" : "flex-start" }}>
            {m.role === "assistant" && (
              <div style={{ width:32, height:32, borderRadius:"50%", background:"var(--navy)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, marginRight:8, flexShrink:0, alignSelf:"flex-end" }}>
                🤖
              </div>
            )}
            <div style={{
              maxWidth:"78%",
              padding:"12px 16px",
              borderRadius: m.role==="user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
              background: m.role==="user" ? "var(--gold)" : "var(--surface)",
              color: m.role==="user" ? "#fff" : "var(--text)",
              fontSize:14, lineHeight:1.7,
              border: m.role==="assistant" ? "1px solid var(--border)" : "none",
              boxShadow:"var(--shadow)",
              whiteSpace:"pre-wrap",
            }}>
              {m.content}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <div style={{ width:32, height:32, borderRadius:"50%", background:"var(--navy)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16 }}>🤖</div>
            <div style={{ padding:"12px 16px", background:"var(--surface)", borderRadius:"18px 18px 18px 4px", border:"1px solid var(--border)" }}>
              <Spinner size={16} />
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* Input */}
      <div style={{ padding:"12px 16px", background:"var(--surface)", borderTop:"1px solid var(--border)", display:"flex", gap:10, flexShrink:0 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === "Enter" && !e.shiftKey && send()}
          placeholder="Pose ta question à Kodjo..."
          style={{
            flex:1, padding:"12px 16px", borderRadius:100,
            border:"1.5px solid var(--border)",
            background:"var(--surface2)",
            color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14,
            outline:"none",
          }}
          onFocus={e => e.target.style.borderColor = "var(--gold)"}
          onBlur={e => e.target.style.borderColor = "var(--border)"}
        />
        <button
          onClick={send}
          disabled={!input.trim() || loading}
          style={{
            width:44, height:44, borderRadius:"50%",
            background: input.trim() ? "var(--gold)" : "var(--border)",
            border:"none", cursor: input.trim() ? "pointer" : "not-allowed",
            display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:18, transition:"all 0.18s", flexShrink:0,
          }}
        >
          {loading ? <Spinner size={18} color="#fff" /> : "→"}
        </button>
      </div>
    </div>
  );
};


// ─── PARTIE 4 — GAMIFICATION + LIGUES + ANNALES + DÉFI DU JOUR ───────────────

// ─── DONNÉES ANNALES ──────────────────────────────────────────────────────────
const ANNALES_YEARS = [2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026];

const ANNALES_SESSIONS = [
  { id:"metropole",  label:"Métropole",         flag:"🇫🇷" },
  { id:"polynesie",  label:"Polynésie",          flag:"🌺" },
  { id:"asie",       label:"Asie",               flag:"🌏" },
  { id:"amerique",   label:"Amérique du Nord",   flag:"🌎" },
  { id:"antilles",   label:"Antilles-Guyane",    flag:"🌴" },
  { id:"reunion",    label:"La Réunion",          flag:"🏝️" },
  { id:"etranger",   label:"Centres Étrangers",  flag:"🌍" },
  { id:"caledonie",  label:"Nouvelle-Calédonie", flag:"🏝️" },
];

const ANNALES_DNB = [
  { id:"francais",    label:"Français",            icon:"📝", forAll:true },
  { id:"maths",       label:"Mathématiques",        icon:"📐", forAll:true },
  { id:"histoire",    label:"Histoire-Géographie",  icon:"🌍", forAll:true },
  { id:"svt",         label:"SVT",                  icon:"🌱", forAll:true },
  { id:"physique",    label:"Physique-Chimie",       icon:"⚗️", forAll:true },
  { id:"technologie", label:"Technologie",           icon:"⚙️", forAll:true },
  { id:"anglais",     label:"Anglais",               icon:"🇬🇧", forAll:true },
];

const ANNALES_BAC_1ERE = [
  // Tronc commun
  { id:"francais",   label:"Français (écrit)",              icon:"📝", forAll:true },
  { id:"hg",         label:"Histoire-Géographie",           icon:"🌍", forAll:true },
  { id:"anglais",    label:"Anglais LVA",                   icon:"🇬🇧", forAll:true },
  { id:"es",         label:"Enseignement Scientifique",     icon:"🔬", forAll:true },
  { id:"eam", label:"Maths — Épreuve Anticipée", icon:"📐", forAll:true },
  // Spécialités
  { id:"maths",      label:"Mathématiques Spé",             icon:"📐", specId:"maths" },
  { id:"svt",        label:"SVT Spé",                       icon:"🧬", specId:"svt" },
  { id:"pc",         label:"Physique-Chimie Spé",           icon:"⚗️", specId:"pc" },
  { id:"ses",        label:"SES",                           icon:"📈", specId:"ses" },
  { id:"nsi",        label:"NSI",                           icon:"💻", specId:"nsi" },
  { id:"hggsp",      label:"HGGSP",                         icon:"🌐", specId:"hggsp" },
  { id:"hlp",        label:"HLP",                           icon:"📖", specId:"hlp" },
  { id:"llcer",      label:"LLCER",                         icon:"🗣️", specId:"llcer" },
  { id:"si",         label:"Sciences de l'Ingénieur",       icon:"⚙️", specId:"si" },
  { id:"arts",       label:"Arts Plastiques",               icon:"🎨", specId:"arts" },
];

const ANNALES_BAC_TLE = [
  // Tronc commun
  { id:"philo",      label:"Philosophie",                   icon:"🧠", forAll:true },
  { id:"hg",         label:"Histoire-Géographie",           icon:"🌍", forAll:true },
  { id:"anglais",    label:"Anglais LVA",                   icon:"🇬🇧", forAll:true },
  { id:"es",         label:"Enseignement Scientifique",     icon:"🔬", forAll:true },
  { id:"grandoral", label:"Grand Oral", icon:"🎤", forAll:true },
  // Spécialités
  { id:"maths",      label:"Mathématiques Spé",             icon:"📐", specId:"maths" },
  { id:"svt",        label:"SVT Spé",                       icon:"🧬", specId:"svt" },
  { id:"pc",         label:"Physique-Chimie Spé",           icon:"⚗️", specId:"pc" },
  { id:"ses",        label:"SES",                           icon:"📈", specId:"ses" },
  { id:"nsi",        label:"NSI",                           icon:"💻", specId:"nsi" },
  { id:"hggsp",      label:"HGGSP",                         icon:"🌐", specId:"hggsp" },
  { id:"hlp",        label:"HLP",                           icon:"📖", specId:"hlp" },
  { id:"llcer",      label:"LLCER",                         icon:"🗣️", specId:"llcer" },
  { id:"si",         label:"Sciences de l'Ingénieur",       icon:"⚙️", specId:"si" },
  { id:"arts",       label:"Arts Plastiques",               icon:"🎨", specId:"arts" },
];




// Questions défi du jour
const DAILY_QUESTIONS = [
  { q:"Combien font 15 × 8 ?", choices:["100","120","110","130"], answer:1, subject:"Maths" },
  { q:"Quel est le plus grand océan du monde ?", choices:["Atlantique","Arctique","Pacifique","Indien"], answer:2, subject:"Géographie" },
  { q:"Quelle est la formule chimique de l'eau ?", choices:["CO2","H2O","O2","NaCl"], answer:1, subject:"Chimie" },
  { q:"Qui a écrit 'Les Misérables' ?", choices:["Zola","Hugo","Balzac","Flaubert"], answer:1, subject:"Français" },
  { q:"Combien font 12² (12 au carré) ?", choices:["124","144","132","154"], answer:1, subject:"Maths" },
  { q:"Quelle est la capitale du Gabon ?", choices:["Douala","Libreville","Dakar","Abidjan"], answer:1, subject:"Géographie" },
  { q:"Quel est le symbole chimique de l'or ?", choices:["Or","Go","Au","Ag"], answer:2, subject:"Chimie" },
  { q:"Combien de côtés a un hexagone ?", choices:["5","7","6","8"], answer:2, subject:"Maths" },
  { q:"Quel continent est le plus grand ?", choices:["Amérique","Europe","Afrique","Asie"], answer:3, subject:"Géographie" },
  { q:"Quelle est la vitesse de la lumière (arrondie) ?", choices:["200 000 km/s","300 000 km/s","400 000 km/s","150 000 km/s"], answer:1, subject:"Physique" },
  { q:"Combien font 7 × 9 ?", choices:["54","63","56","72"], answer:1, subject:"Maths" },
  { q:"Quelle langue est la plus parlée au monde ?", choices:["Anglais","Espagnol","Mandarin","Français"], answer:2, subject:"Culture" },
  { q:"Quel est l'organe qui pompe le sang ?", choices:["Poumon","Foie","Cœur","Rein"], answer:2, subject:"SVT" },
  { q:"Combien font 25% de 200 ?", choices:["40","60","50","45"], answer:2, subject:"Maths" },
  { q:"Qui a peint la Joconde ?", choices:["Picasso","Michel-Ange","Léonard de Vinci","Raphaël"], answer:2, subject:"Culture" },
  { q:"Quelle planète est la plus proche du Soleil ?", choices:["Vénus","Terre","Mercure","Mars"], answer:2, subject:"Sciences" },
  { q:"Combien font 100 ÷ 4 ?", choices:["20","30","25","15"], answer:2, subject:"Maths" },
  { q:"Quel est le fleuve le plus long d'Afrique ?", choices:["Congo","Niger","Zambèze","Nil"], answer:3, subject:"Géographie" },
  { q:"Quelle est la formule du dioxyde de carbone ?", choices:["CO","CO2","C2O","O2C"], answer:1, subject:"Chimie" },
  { q:"Combien y a-t-il de lettres dans l'alphabet français ?", choices:["24","25","26","27"], answer:2, subject:"Français" },
  { q:"Quelle est la racine carrée de 144 ?", choices:["11","13","12","14"], answer:2, subject:"Maths" },
  { q:"Quel est le pays le plus grand du monde ?", choices:["Canada","Chine","États-Unis","Russie"], answer:3, subject:"Géographie" },
  { q:"Combien font 3 × 3 × 3 ?", choices:["9","27","18","21"], answer:1, subject:"Maths" },
  { q:"Qui a découvert la pénicilline ?", choices:["Pasteur","Curie","Fleming","Einstein"], answer:2, subject:"Sciences" },
  { q:"Combien de degrés dans un triangle ?", choices:["90°","180°","360°","270°"], answer:1, subject:"Maths" },
  { q:"Quel est le symbole chimique du fer ?", choices:["Fe","Fr","Fi","Fw"], answer:0, subject:"Chimie" },
  { q:"Quelle est la monnaie du Japon ?", choices:["Yuan","Won","Yen","Ringgit"], answer:2, subject:"Culture" },
  { q:"Combien font 0,5 × 400 ?", choices:["150","250","200","180"], answer:2, subject:"Maths" },
  { q:"Quelle est la capitale de la Côte d'Ivoire (siège du gouvernement) ?", choices:["Abidjan","Yamoussoukro","San-Pédro","Bouaké"], answer:1, subject:"Géographie" },
  { q:"Combien y a-t-il de jours dans une année bissextile ?", choices:["364","365","366","367"], answer:2, subject:"Culture" },
];

// ─── DÉFI DU JOUR ─────────────────────────────────────────────────────────────
const DAILY_SUBJECTS = ["Mathématiques","Français","SVT","Histoire-Géo","Physique-Chimie","Anglais","Mathématiques"];

const DailyChallenge = ({ user, onDone, onBack }) => {
  const today = new Date().toDateString();
  const storageKey = `nunya_challenge_${user?.id}_${today}`;
  const alreadyDone = localStorage.getItem(storageKey) === "done";

  const todaySubject = DAILY_SUBJECTS[new Date().getDay()];
  const [questions, setQuestions] = useState([]);
  const [currentQ, setCurrentQ] = useState(0);
  const [score, setScore] = useState(0);
  const [answered, setAnswered] = useState(null);
  const [finished, setFinished] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [loading, setLoading] = useState(true);
  const [selectedAnswer, setSelectedAnswer] = useState(null);

  useEffect(() => {
    if (!alreadyDone) loadQuestions();
  }, []);

  const loadQuestions = async () => {
    setLoading(true);
    try {
      const { data } = await supabase.functions.invoke("kodjo-chat", {
        body: {
          messages:[{
            role:"user",
            content:`Génère exactement 10 questions de QCM pour un élève de ${user?.level || "3ème"} en ${todaySubject}. 
Réponds UNIQUEMENT en JSON valide, sans texte avant ou après:
[{"question":"...","options":["A","B","C","D"],"answer":"A","explanation":"..."}]
Les questions doivent correspondre exactement au programme officiel de ${user?.level}.`
          }],
          systemPrompt:"Tu génères des QCM scolaires en JSON uniquement. Pas de texte, uniquement le tableau JSON.",
        }
      });

      if (data?.reply) {
        try {
          const parsed = JSON.parse(data.reply.replace(/```json|```/g,"").trim());
          if (Array.isArray(parsed) && parsed.length > 0) {
            setQuestions(parsed.slice(0,10));
            setLoading(false);
            return;
          }
        } catch(e) {}
      }
    } catch(e) {}

    // Fallback questions si Kodjo échoue
    setQuestions([
      {question:`Quelle est la définition d'une variable en ${todaySubject} ?`,options:["A","B","C","D"],answer:"A",explanation:"Une variable est un symbole qui peut prendre différentes valeurs."},
      {question:"Que représente π (pi) ?",options:["3.14159...","2.71828...","1.41421...","1.73205..."],answer:"3.14159...",explanation:"Pi est le rapport entre le périmètre et le diamètre d'un cercle."},
      {question:"Combien font 15 × 12 ?",options:["160","170","180","190"],answer:"180",explanation:"15 × 12 = 15 × 10 + 15 × 2 = 150 + 30 = 180"},
      {question:"√256 = ?",options:["14","15","16","17"],answer:"16",explanation:"16 × 16 = 256"},
      {question:"Quel est le PGCD de 24 et 36 ?",options:["6","8","12","18"],answer:"12",explanation:"Les diviseurs communs de 24 et 36 sont : 1,2,3,4,6,12. Le plus grand est 12."},
      {question:"25% de 80 = ?",options:["15","20","25","30"],answer:"20",explanation:"25% = 1/4. 80 ÷ 4 = 20"},
      {question:"2⁵ = ?",options:["10","16","32","64"],answer:"32",explanation:"2⁵ = 2×2×2×2×2 = 32"},
      {question:"Quel est le périmètre d'un carré de côté 7 ?",options:["21","28","35","49"],answer:"28",explanation:"Périmètre = 4 × côté = 4 × 7 = 28"},
      {question:"3/4 + 1/4 = ?",options:["1/2","3/8","1","4/8"],answer:"1",explanation:"3/4 + 1/4 = 4/4 = 1"},
      {question:"Quel est l'angle d'un triangle équilatéral ?",options:["45°","60°","90°","120°"],answer:"60°",explanation:"Triangle équilatéral : 3 angles égaux. 180° ÷ 3 = 60°"},
    ]);
    setLoading(false);
  };

  // Timer
  useEffect(() => {
    if (loading || finished || answered !== null) return;
    const timer = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          handleAnswer(null);
          return 30;
        }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [currentQ, loading, finished, answered]);

  const handleAnswer = (answer) => {
    if (answered !== null) return;
    setSelectedAnswer(answer);
    setAnswered(answer);
    const q = questions[currentQ];
    if (answer === q?.answer) setScore(s => s + 1);
  };

  const nextQuestion = () => {
    if (currentQ + 1 >= questions.length) {
      setFinished(true);
      localStorage.setItem(storageKey, "done");
      setTimeout(() => onDone(score + (selectedAnswer === questions[currentQ]?.answer ? 1 : 0)), 1500);
    } else {
      setCurrentQ(q => q + 1);
      setAnswered(null);
      setSelectedAnswer(null);
      setTimeLeft(30);
    }
  };

  if (alreadyDone) return (
    <div className="main-content fade">
      <div style={{ background:"var(--navy)", padding:"20px 16px" }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer" }}>← Retour</button>
      </div>
      <div style={{ padding:32, textAlign:"center" }}>
        <div style={{ fontSize:60, marginBottom:16 }}>✅</div>
        <h3 style={{ fontFamily:"var(--font-display)", fontSize:22, color:"var(--text)", marginBottom:8 }}>
          Défi du jour complété !
        </h3>
        <p style={{ color:"var(--muted)", fontSize:14, marginBottom:24 }}>
          Reviens demain pour un nouveau défi en <strong>{DAILY_SUBJECTS[new Date().getDay()]}</strong>.
        </p>
        <Btn onClick={onBack} color="var(--gold)" style={{ borderRadius:12 }}>← Retour</Btn>
      </div>
    </div>
  );

  if (loading) return (
    <div className="main-content fade">
      <div style={{ background:"var(--navy)", padding:"20px 16px" }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer" }}>← Retour</button>
        <h2 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"#fff", marginTop:8 }}>
          ⚡ Défi du jour
        </h2>
      </div>
      <div style={{ padding:32, textAlign:"center" }}>
        <span style={{ fontSize:40, display:"block", marginBottom:16 }}>🤖</span>
        <p style={{ fontSize:15, color:"var(--text)", marginBottom:8 }}>Kodjo prépare ton défi...</p>
        <p style={{ fontSize:13, color:"var(--muted)", marginBottom:24 }}>
          10 questions de <strong>{todaySubject}</strong> niveau <strong>{user?.level}</strong>
        </p>
        <Spinner size={32} />
      </div>
    </div>
  );

  const q = questions[currentQ];
  const progress = ((currentQ) / questions.length) * 100;

  return (
    <div className="main-content fade">
      {/* Header */}
      <div style={{ background:"var(--navy)", padding:"16px", position:"sticky", top:0, zIndex:40 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:8 }}>← Retour</button>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
          <div>
            <p style={{ fontSize:11, color:"rgba(255,255,255,0.5)" }}>DÉFI DU JOUR · {todaySubject}</p>
            <p style={{ fontSize:13, fontWeight:700, color:"#fff" }}>
              Question {currentQ+1}/{questions.length} · {user?.level}
            </p>
          </div>
          <div style={{ textAlign:"right" }}>
            <p style={{ fontSize:11, color:"rgba(255,255,255,0.5)" }}>Score</p>
            <p style={{ fontSize:18, fontWeight:700, color:"var(--gold)" }}>{score}/{questions.length}</p>
          </div>
        </div>
        <ProgressBar value={progress} max={100} color="var(--gold)" />
        {/* Timer */}
        <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:8 }}>
          <div style={{ flex:1, height:4, background:"rgba(255,255,255,0.1)", borderRadius:2 }}>
            <div style={{ width:`${(timeLeft/30)*100}%`, height:"100%", background:timeLeft<=10?"var(--red)":"var(--green)", borderRadius:2, transition:"width 1s linear" }} />
          </div>
          <span style={{ fontSize:13, fontWeight:700, color:timeLeft<=10?"var(--red)":"rgba(255,255,255,0.7)", minWidth:28 }}>
            {timeLeft}s
          </span>
        </div>
      </div>

      <div style={{ padding:16 }}>
        {/* Question */}
        <Surface style={{ padding:20, marginBottom:16 }}>
          <p style={{ fontSize:16, fontWeight:600, color:"var(--text)", lineHeight:1.6 }}>
            {q?.question}
          </p>
        </Surface>

        {/* Options */}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
          {(q?.options||[]).map((opt, i) => {
            const isCorrect = opt === q?.answer;
            const isSelected = opt === selectedAnswer;
            let bg = "var(--surface)";
            let border = "var(--border)";
            let color = "var(--text)";
            if (answered !== null) {
              if (isCorrect) { bg="rgba(16,185,129,0.1)"; border="var(--green)"; color="var(--green)"; }
              else if (isSelected && !isCorrect) { bg="rgba(239,68,68,0.1)"; border="var(--red)"; color="var(--red)"; }
            }
            return (
              <button key={i} onClick={() => handleAnswer(opt)} disabled={answered !== null}
                style={{ padding:"14px 10px", borderRadius:12, border:`1.5px solid ${border}`, background:bg,
                  color, fontFamily:"var(--font-body)", fontSize:14, fontWeight:500, cursor:answered!==null?"not-allowed":"pointer",
                  textAlign:"left", transition:"all 0.2s" }}>
                <span style={{ fontWeight:700, marginRight:6 }}>{["A","B","C","D"][i]}.</span> {opt}
              </button>
            );
          })}
        </div>

        {/* Explication après réponse */}
        {answered !== null && (
          <Surface style={{ padding:16, marginBottom:16, background:"rgba(26,86,219,0.06)", borderColor:"var(--blue)" }}>
            <p style={{ fontSize:12, fontWeight:700, color:"var(--blue)", marginBottom:4 }}>🤖 Kodjo explique</p>
            <p style={{ fontSize:13, color:"var(--text)", lineHeight:1.6 }}>
              {answered === q?.answer ? "✅ Bravo ! " : "❌ Pas tout à fait. "}
              {q?.explanation}
            </p>
          </Surface>
        )}

        {answered !== null && (
          <Btn onClick={nextQuestion} color="var(--gold)" size="lg" style={{ width:"100%", borderRadius:12 }}>
            {currentQ + 1 >= questions.length ? "Voir mon score 🏆" : "Question suivante →"}
          </Btn>
        )}
      </div>
    </div>
  );
};


const Leagues = ({ user, onNav }) => {
  const [tab, setTab] = useState("ma-ligue");
  const [subTab, setSubTab] = useState("classement"); // classement, battle, equipe, tournoi
  const [rankType, setRankType] = useState("xp");
  const [leagueData, setLeagueData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [battleTarget, setBattleTarget] = useState(null);
  const [battleState, setBattleState] = useState(null); // null, "waiting", "active", "finished"
  const [battleQuestions, setBattleQuestions] = useState([]);
  const [battleAnswers, setBattleAnswers] = useState({});
  const [battleScore, setBattleScore] = useState({ me:0, opponent:0 });
  const [currentBattleQ, setCurrentBattleQ] = useState(0);
  const [battleTimer, setBattleTimer] = useState(30);
  const [team, setTeam] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamChat, setTeamChat] = useState([]);
  const [teamMessage, setTeamMessage] = useState("");
  const [teamLoading, setTeamLoading] = useState(false);
  const [showProtection, setShowProtection] = useState(false);
  const [weeklyChallenge, setWeeklyChallenge] = useState(null);
  const [kodjoCoachMsg, setKodjoCoachMsg] = useState("");

  const userXP = user?.xp || 0;
  const userLeague = [...LEAGUES].reverse().find(l => userXP >= l.minXP) || LEAGUES[0];
  const nextLeague = LEAGUES[LEAGUES.findIndex(l => l.id === userLeague.id) + 1];
  const xpToNext = nextLeague ? nextLeague.minXP - userXP : 0;

  const TABS = [
    { id:"ma-ligue",   icon:"🏆", label:"Ma ligue" },
    { id:"ma-classe",  icon:"🎓", label:"Ma classe" },
    { id:"mon-pays",   icon:"🌍", label:"Mon pays" },
    { id:"continent",  icon:"🌐", label:"Continent" },
    { id:"specialite", icon:"📚", label:"Spécialité" },
    { id:"mondial",    icon:"👑", label:"Mondial" },
  ];

  const CONTINENTS = {
    // Afrique
    "Gabon":"Afrique","Cameroun":"Afrique","Côte d'Ivoire":"Afrique","Sénégal":"Afrique",
    "Mali":"Afrique","Congo":"Afrique","RDC":"Afrique","Madagascar":"Afrique",
    "Maroc":"Afrique","Tunisie":"Afrique","Algérie":"Afrique","Burkina Faso":"Afrique",
    "Niger":"Afrique","Tchad":"Afrique","Bénin":"Afrique","Togo":"Afrique",
    "Guinée":"Afrique","Mauritanie":"Afrique","Djibouti":"Afrique","Comores":"Afrique",
    "Centrafrique":"Afrique","Rwanda":"Afrique","Burundi":"Afrique","Afrique du Sud":"Afrique",
    "Égypte":"Afrique","Éthiopie":"Afrique","Ghana":"Afrique","Nigeria":"Afrique",
    "Mozambique":"Afrique","Namibie":"Afrique","Cabo Verde":"Afrique",
    "Guinée équatoriale":"Afrique","Érythrée":"Afrique","Eswatini":"Afrique",
    // Europe
    "France":"Europe","Belgique":"Europe","Suisse":"Europe","Luxembourg":"Europe",
    "Monaco":"Europe","Andorre":"Europe","Allemagne":"Europe","Espagne":"Europe",
    "Italie":"Europe","Portugal":"Europe","Pays-Bas":"Europe","Royaume-Uni":"Europe",
    // Amérique
    "Canada":"Amérique","États-Unis":"Amérique","Haïti":"Amérique",
    "Martinique":"Amérique","Guadeloupe":"Amérique","Guyane":"Amérique",
    "Nouvelle-Calédonie":"Océanie","Polynésie française":"Océanie",
    // Asie & Moyen-Orient
    "Liban":"Asie","Vietnam":"Asie","Cambodge":"Asie","Laos":"Asie",
    "Syrie":"Asie","Émirats arabes unis":"Asie","Qatar":"Asie",
    "Arabie Saoudite":"Asie","Jordanie":"Asie",
  };

  const getUserContinent = () => CONTINENTS[user?.country] || "Afrique";

  const getWeekCountdown = () => {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const daysUntilMonday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek;
    const nextMonday = new Date(now);
    nextMonday.setDate(now.getDate() + daysUntilMonday);
    nextMonday.setHours(0,0,0,0);
    const diff = nextMonday.getTime() - now.getTime();
    return { days:Math.floor(diff/86400000), hours:Math.floor((diff%86400000)/3600000) };
  };

  useEffect(() => { loadLeagueData(); }, [tab, rankType]);
  useEffect(() => { loadWeeklyChallenge(); loadTeam(); }, []);

  const loadLeagueData = async () => {
    setLoading(true);
    try {
      let query = supabase.from("profiles")
        .select("id,name,country,level,xp,streak,specialties,badges")
        .eq("level", user?.level || "6ème"); // Ligues par niveau scolaire !

      if (tab === "ma-ligue") {
        query = query.gte("xp", userLeague.minXP);
        if (nextLeague) query = query.lt("xp", nextLeague.minXP);
      } else if (tab === "ma-classe") {
        // déjà filtré par level
      } else if (tab === "mon-pays") {
        query = query.eq("country", user?.country || "");
      } else if (tab === "continent") {
        const userContinent = getUserContinent();
        const countries = Object.entries(CONTINENTS).filter(([,c])=>c===userContinent).map(([c])=>c);
        query = query.in("country", countries);
      } else if (tab === "specialite") {
        const specs = user?.specialties || [];
        if (specs.length) {
          // Chercher des élèves ayant au moins une spécialité en commun
          query = supabase.from("profiles")
            .select("id,name,country,level,xp,streak,specialties,badges")
            .not("specialties", "eq", "{}");
        }
      } else if (tab === "mondial") {
        query = supabase.from("profiles").select("id,name,country,level,xp,streak,specialties,badges");
      }

      const { data } = await query.order("xp", { ascending:false }).limit(50);
      setLeagueData(data || []);
    } catch(e) { console.warn(e); }
    setLoading(false);
  };

  const loadWeeklyChallenge = async () => {
    // Défi hebdomadaire Kodjo — généré dynamiquement
    const subjects = ["Mathématiques","Français","SVT","Histoire-Géo","Physique-Chimie","Anglais"];
    const randomSubject = subjects[new Date().getDay() % subjects.length];
    setWeeklyChallenge({ subject:randomSubject, xpReward:100, endDate: getWeekCountdown() });
  };

  const loadTeam = async () => {
    try {
      const { data } = await supabase.from("league_teams")
        .select("*")
        .contains("member_ids", [user.id])
        .single();
      if (data) {
        setTeam(data);
        const { data: members } = await supabase.from("profiles")
          .select("id,name,xp,streak").in("id", data.member_ids);
        setTeamMembers(members || []);
        loadKodjoCoach(members || []);
      }
    } catch(e) {}
  };

  const loadKodjoCoach = async (members) => {
    if (!members.length) return;
    try {
      const teamContext = members.map(m => `${m.name}: ${m.xp} XP, streak ${m.streak}j`).join(", ");
      const { data } = await supabase.functions.invoke("kodjo-chat", {
        body: {
          messages:[{ role:"user", content:`Analyse cette équipe et donne un conseil collectif court (2 phrases max): ${teamContext}` }],
          systemPrompt:"Tu es Kodjo, coach IA d'une équipe d'élèves. Donne un conseil motivant et précis en français.",
        }
      });
      if (data?.reply) setKodjoCoachMsg(data.reply);
    } catch(e) {}
  };

  const startBattle = async (opponent) => {
    setBattleTarget(opponent);
    setBattleState("waiting");
    // Générer 10 questions via Kodjo
    try {
      const { data } = await supabase.functions.invoke("kodjo-chat", {
        body: {
          messages:[{ role:"user", content:`Génère 5 questions de QCM pour le niveau ${user?.level} en format JSON strict: [{"question":"...","options":["A","B","C","D"],"answer":"A"}]. Matière: Mathématiques.` }],
          systemPrompt:"Tu génères des QCM scolaires en JSON uniquement, sans texte autour.",
        }
      });
      if (data?.reply) {
        try {
          const questions = JSON.parse(data.reply.replace(/```json|```/g,"").trim());
          setBattleQuestions(questions);
          setBattleState("active");
          setCurrentBattleQ(0);
          setBattleTimer(30);
        } catch(e) {
          setBattleQuestions([
            {question:"Combien font 7 × 8 ?", options:["54","56","48","64"], answer:"56"},
            {question:"√144 = ?", options:["11","12","13","14"], answer:"12"},
            {question:"2³ = ?", options:["6","8","9","16"], answer:"8"},
            {question:"15% de 200 = ?", options:["25","30","35","40"], answer:"30"},
            {question:"PGCD(12,18) = ?", options:["3","4","6","9"], answer:"6"},
          ]);
          setBattleState("active");
        }
      }
    } catch(e) { setBattleState(null); }
  };

  const answerBattle = (answer) => {
    const q = battleQuestions[currentBattleQ];
    const isCorrect = answer === q?.answer;
    if (isCorrect) setBattleScore(s => ({...s, me:s.me+1}));
    // Simuler réponse adversaire
    const opponentCorrect = Math.random() > 0.4;
    if (opponentCorrect) setBattleScore(s => ({...s, opponent:s.opponent+1}));

    if (currentBattleQ + 1 >= battleQuestions.length) {
      setBattleState("finished");
    } else {
      setCurrentBattleQ(q => q+1);
      setBattleTimer(30);
    }
  };

  const createTeam = async () => {
    if (team) return;
    setTeamLoading(true);
    try {
      const { data } = await supabase.from("league_teams").insert({
        name:`Équipe de ${user.name}`,
        leader_id: user.id,
        member_ids: [user.id],
        total_xp: userXP,
        level: user?.level,
      }).select().single();
      if (data) { setTeam(data); setTeamMembers([user]); }
    } catch(e) {}
    setTeamLoading(false);
  };

  const sendTeamMessage = async () => {
    if (!teamMessage.trim()) return;
    const msg = { sender: user.name, content: teamMessage, time: new Date().toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"}) };
    setTeamChat(c => [...c, msg]);
    setTeamMessage("");
  };

  const useProtection = async () => {
    if (userXP < 2000) return;
    setShowProtection(false);
    // Dépenser 2000 XP pour protection anti-relégation
    await supabase.from("profiles").update({ xp: userXP - 2000 }).eq("id", user.id);
  };

  const countdown = getWeekCountdown();
  const myRank = leagueData.findIndex(p => p.id === user?.id) + 1;
  const isInRelegation = myRank > leagueData.length - 5 && leagueData.length > 5;

  const renderPlayer = (player, rank, totalCount) => {
    const isMe = player.id === user?.id;
    const rankIcons = { 1:"🥇", 2:"🥈", 3:"🥉" };
    const isPromotion = rank <= 10;
    const isRelegationZone = rank > totalCount - 5 && totalCount > 5;
    const playerLeague = [...LEAGUES].reverse().find(l => (player.xp||0) >= l.minXP) || LEAGUES[0];

    return (
      <div key={player.id} style={{
        display:"flex", alignItems:"center", gap:12, padding:"12px 16px",
        background: isMe ? "var(--gold-light)" : "var(--surface)",
        border:`1px solid ${isMe?"var(--gold)":"var(--border)"}`,
        borderLeft:`3px solid ${isPromotion?"var(--green)":isRelegationZone?"var(--red)":"transparent"}`,
        borderRadius:12, marginBottom:8,
      }}>
        <span style={{ fontSize:rank<=3?22:14, fontWeight:700, color:"var(--muted)", width:28, textAlign:"center", flexShrink:0 }}>
          {rankIcons[rank] || rank}
        </span>
        <div style={{ width:36, height:36, borderRadius:"50%", background:"var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:15, fontWeight:700, color:"#fff", flexShrink:0 }}>
          {(player.name||"?").charAt(0).toUpperCase()}
        </div>
        <div style={{ flex:1 }}>
          <p style={{ fontSize:14, fontWeight:isMe?700:600, color:"var(--text)", display:"flex", alignItems:"center", gap:4 }}>
            {player.name||"Élève"} {isMe&&<span style={{color:"var(--gold)",fontSize:11}}>(moi)</span>}
            <span style={{fontSize:11}}>{playerLeague.icon}</span>
          </p>
          <p style={{ fontSize:11, color:"var(--muted)" }}>{player.country} · {player.level}</p>
        </div>
        <div style={{ textAlign:"right" }}>
          <p style={{ fontSize:13, fontWeight:700, color:"var(--gold)" }}>⚡{formatNumber(player.xp||0)}</p>
          {(player.streak||0) > 0 && <StreakBadge streak={player.streak} size="sm" />}
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
          {isPromotion && <span style={{fontSize:12}}>⬆️</span>}
          {isRelegationZone && <span style={{fontSize:12}}>⬇️</span>}
          {!isMe && subTab==="classement" && (
            <button onClick={()=>{setBattleTarget(player);setSubTab("battle");}}
              style={{fontSize:10,padding:"3px 6px",borderRadius:6,background:"var(--navy)",border:"none",color:"#fff",cursor:"pointer"}}>
              ⚔️
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="main-content fade">
      <TopBar user={user} screen="leagues" onNav={onNav||(() => {})} title="Ligues" />

      {/* Header ligue */}
      <div style={{ background:"linear-gradient(135deg, var(--navy), #1A3A6B)", padding:16 }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:12 }}>
          <span style={{ fontSize:36 }}>{userLeague.icon}</span>
          <div style={{ flex:1 }}>
            <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"#fff" }}>
              Ligue {userLeague.label}
            </h3>
            <p style={{ color:"rgba(255,255,255,0.6)", fontSize:12 }}>
              {user?.level} · {myRank > 0 ? `#${myRank} dans ce classement` : "Calcul..."}
            </p>
          </div>
          {isInRelegation && userXP >= 2000 && (
            <button onClick={() => setShowProtection(true)}
              style={{ padding:"6px 12px", borderRadius:100, background:"rgba(201,151,44,0.3)", border:"1px solid var(--gold)", color:"var(--gold)", cursor:"pointer", fontSize:11, fontWeight:700 }}>
              🛡️ Protéger
            </button>
          )}
        </div>

        {nextLeague && (
          <>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
              <span style={{ fontSize:12, color:"rgba(255,255,255,0.6)" }}>→ {nextLeague.label} {nextLeague.icon}</span>
              <span style={{ fontSize:12, color:"var(--gold)" }}>{xpToNext} XP</span>
            </div>
            <ProgressBar value={userXP - userLeague.minXP} max={nextLeague.minXP - userLeague.minXP} color="var(--gold)" />
          </>
        )}

        <div style={{ marginTop:12, paddingTop:12, borderTop:"1px solid rgba(255,255,255,0.1)", display:"flex", justifyContent:"space-between" }}>
          <span style={{ fontSize:12, color:"rgba(255,255,255,0.5)" }}>🔄 Reset lundi</span>
          <span style={{ fontSize:13, fontWeight:700, color:"var(--gold)" }}>{countdown.days}j {countdown.hours}h</span>
        </div>
      </div>

      {/* Sous-menus */}
      <div style={{ display:"flex", overflowX:"auto", background:"var(--surface)", borderBottom:"1px solid var(--border)" }}>
        {[
          { id:"classement", icon:"📊", label:"Classement" },
          { id:"battle",     icon:"⚔️", label:"Battle" },
          { id:"equipe",     icon:"👥", label:"Mon équipe" },
          { id:"tournoi",    icon:"🏆", label:"Coupe Nunya" },
          { id:"defi",       icon:"🎯", label:"Défi Kodjo" },
        ].map(s => (
          <button key={s.id} onClick={() => setSubTab(s.id)}
            style={{ flexShrink:0, padding:"12px 14px", border:"none",
              borderBottom:`2px solid ${subTab===s.id?"var(--gold)":"transparent"}`,
              background:"transparent", color:subTab===s.id?"var(--gold)":"var(--muted)",
              fontFamily:"var(--font-body)", fontSize:12, fontWeight:subTab===s.id?700:500, cursor:"pointer",
              display:"flex", alignItems:"center", gap:4 }}>
            {s.icon} {s.label}
          </button>
        ))}
      </div>

      <div style={{ padding:16 }}>

        {/* ── CLASSEMENT ────────────────────────────────────────────────── */}
        {subTab === "classement" && (
          <>
            {/* Type */}
            <div style={{ display:"flex", gap:8, marginBottom:14 }}>
              <button onClick={()=>setRankType("xp")}
                style={{ flex:1, padding:8, borderRadius:8, fontSize:12, fontWeight:700,
                  border:`1.5px solid ${rankType==="xp"?"var(--gold)":"var(--border)"}`,
                  background:rankType==="xp"?"var(--gold-light)":"transparent",
                  color:rankType==="xp"?"var(--gold)":"var(--muted)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
                ⚡ XP Total
              </button>
              <button onClick={()=>setRankType("progres")}
                style={{ flex:1, padding:8, borderRadius:8, fontSize:12, fontWeight:700,
                  border:`1.5px solid ${rankType==="progres"?"var(--green)":"var(--border)"}`,
                  background:rankType==="progres"?"rgba(16,185,129,0.1)":"transparent",
                  color:rankType==="progres"?"var(--green)":"var(--muted)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
                📈 Progrès semaine
              </button>
            </div>

            {/* Onglets */}
            <div style={{ overflowX:"auto", marginBottom:14 }}>
              <div style={{ display:"flex", gap:6 }}>
                {TABS.map(t => (
                  <button key={t.id} onClick={()=>setTab(t.id)}
                    style={{ flexShrink:0, padding:"6px 12px", borderRadius:100, fontSize:11, fontWeight:600,
                      border:`1.5px solid ${tab===t.id?"var(--gold)":"var(--border)"}`,
                      background:tab===t.id?"var(--gold-light)":"var(--surface)",
                      color:tab===t.id?"var(--gold)":"var(--text)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
                    {t.icon} {t.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Légende */}
            <div style={{ display:"flex", gap:12, marginBottom:12, fontSize:11, color:"var(--muted)" }}>
              <span><span style={{background:"var(--green)",width:8,height:8,borderRadius:2,display:"inline-block",marginRight:4}}/>Top 10 ⬆️</span>
              <span><span style={{background:"var(--red)",width:8,height:8,borderRadius:2,display:"inline-block",marginRight:4}}/>5 derniers ⬇️</span>
              <span style={{marginLeft:"auto"}}>{leagueData.length} élèves</span>
            </div>

            {loading ? (
              <><SkeletonCard height={60}/><SkeletonCard height={60}/><SkeletonCard height={60}/></>
            ) : leagueData.length === 0 ? (
              <EmptyState icon="🏆" title="Classement vide" message="Sois le premier de ce classement !" />
            ) : (
              leagueData.map((p,i) => renderPlayer(p, i+1, leagueData.length))
            )}
          </>
        )}

        {/* ── BATTLE 1v1 ───────────────────────────────────────────────── */}
        {subTab === "battle" && (
          <div>
            {!battleTarget && !battleState && (
              <>
                <Surface style={{ padding:20, marginBottom:16, background:"linear-gradient(135deg,var(--navy),#1A3A6B)", border:"none" }}>
                  <h3 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"#fff", marginBottom:8 }}>
                    ⚔️ Battle 1v1
                  </h3>
                  <p style={{ color:"rgba(255,255,255,0.7)", fontSize:13, lineHeight:1.6, marginBottom:12 }}>
                    Défie un élève de ta ligue ! Kodjo génère les questions et arbitre le match. Le meilleur score gagne. Les deux élèves gagnent des XP.
                  </p>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
                    {[{label:"Questions",value:"5"},{label:"Temps/question",value:"30s"},{label:"XP gagnés",value:"+50"},{label:"Matière",value:"Auto"},{label:"Niveau",value:user?.level},{label:"Arbitre",value:"Kodjo 🤖"}].map(s => (
                      <div key={s.label} style={{ background:"rgba(255,255,255,0.1)", borderRadius:8, padding:10, textAlign:"center" }}>
                        <p style={{ fontSize:15, fontWeight:700, color:"var(--gold)" }}>{s.value}</p>
                        <p style={{ fontSize:10, color:"rgba(255,255,255,0.5)" }}>{s.label}</p>
                      </div>
                    ))}
                  </div>
                </Surface>

                <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", marginBottom:12 }}>
                  CHOISIR UN ADVERSAIRE
                </p>
                {leagueData.filter(p=>p.id!==user?.id).slice(0,10).map(player => (
                  <Surface key={player.id} className="card-hover" style={{ padding:14, marginBottom:8, cursor:"pointer" }}
                    onClick={()=>startBattle(player)}>
                    <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                      <div style={{ width:36, height:36, borderRadius:"50%", background:"var(--blue)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:15, fontWeight:700, color:"#fff" }}>
                        {(player.name||"?").charAt(0)}
                      </div>
                      <div style={{ flex:1 }}>
                        <p style={{ fontSize:14, fontWeight:600, color:"var(--text)" }}>{player.name}</p>
                        <p style={{ fontSize:11, color:"var(--muted)" }}>{player.country} · ⚡{formatNumber(player.xp||0)}</p>
                      </div>
                      <Btn color="var(--red)" size="sm">⚔️ Défier</Btn>
                    </div>
                  </Surface>
                ))}
                {leagueData.filter(p=>p.id!==user?.id).length === 0 && (
                  <EmptyState icon="⚔️" title="Pas encore d'adversaires" message="Rejoins le classement pour trouver des adversaires !" />
                )}
              </>
            )}

            {/* En attente */}
            {battleState === "waiting" && (
              <div style={{ textAlign:"center", padding:40 }}>
                <div style={{ fontSize:48, marginBottom:16 }}>⚔️</div>
                <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, color:"var(--text)", marginBottom:8 }}>
                  Kodjo prépare le battle...
                </h3>
                <p style={{ color:"var(--muted)", fontSize:14, marginBottom:24 }}>
                  Contre <strong>{battleTarget?.name}</strong>
                </p>
                <Spinner size={32} />
              </div>
            )}

            {/* Battle actif */}
            {battleState === "active" && battleQuestions.length > 0 && (
              <div>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
                  <div style={{ textAlign:"center" }}>
                    <p style={{ fontSize:12, color:"var(--muted)" }}>Moi</p>
                    <p style={{ fontSize:28, fontWeight:700, color:"var(--gold)" }}>{battleScore.me}</p>
                  </div>
                  <div style={{ fontSize:24, fontWeight:700, color:"var(--text)" }}>vs</div>
                  <div style={{ textAlign:"center" }}>
                    <p style={{ fontSize:12, color:"var(--muted)" }}>{battleTarget?.name}</p>
                    <p style={{ fontSize:28, fontWeight:700, color:"var(--red)" }}>{battleScore.opponent}</p>
                  </div>
                </div>

                <Surface style={{ padding:20, marginBottom:16 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:12 }}>
                    <span style={{ fontSize:12, color:"var(--muted)" }}>Q{currentBattleQ+1}/{battleQuestions.length}</span>
                    <span style={{ fontSize:14, fontWeight:700, color:battleTimer<=10?"var(--red)":"var(--gold)" }}>⏱️ {battleTimer}s</span>
                  </div>
                  <p style={{ fontSize:16, fontWeight:600, color:"var(--text)", marginBottom:16, lineHeight:1.5 }}>
                    {battleQuestions[currentBattleQ]?.question}
                  </p>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
                    {(battleQuestions[currentBattleQ]?.options||[]).map((opt,i) => (
                      <button key={i} onClick={()=>answerBattle(opt)}
                        style={{ padding:"14px 10px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, fontWeight:500, cursor:"pointer", textAlign:"left" }}>
                        {["A","B","C","D"][i]}. {opt}
                      </button>
                    ))}
                  </div>
                </Surface>
              </div>
            )}

            {/* Résultat battle */}
            {battleState === "finished" && (
              <div style={{ textAlign:"center", padding:20 }}>
                <div style={{ fontSize:60, marginBottom:16 }}>
                  {battleScore.me > battleScore.opponent ? "🏆" : battleScore.me === battleScore.opponent ? "🤝" : "💪"}
                </div>
                <h3 style={{ fontFamily:"var(--font-display)", fontSize:24, color:"var(--text)", marginBottom:8 }}>
                  {battleScore.me > battleScore.opponent ? "Tu as gagné !" : battleScore.me === battleScore.opponent ? "Égalité !" : "Bien essayé !"}
                </h3>
                <p style={{ fontSize:16, color:"var(--muted)", marginBottom:20 }}>
                  {battleScore.me} - {battleScore.opponent} contre {battleTarget?.name}
                </p>
                <Surface style={{ padding:16, marginBottom:16, background:"rgba(201,151,44,0.08)", borderColor:"var(--gold)" }}>
                  <p style={{ fontSize:13, fontWeight:700, color:"var(--gold)", marginBottom:4 }}>🤖 Kodjo dit</p>
                  <p style={{ fontSize:13, color:"var(--text)", lineHeight:1.6 }}>
                    {battleScore.me > battleScore.opponent
                      ? "Excellent travail ! Tu maîtrises bien ces notions. Continue comme ça !"
                      : "Ne te décourage pas — chaque bataille est une leçon. Revois les questions que tu as manquées."}
                  </p>
                </Surface>
                <p style={{ fontSize:14, fontWeight:700, color:"var(--green)", marginBottom:20 }}>
                  +{battleScore.me > battleScore.opponent ? 50 : 20} XP gagnés !
                </p>
                <Btn onClick={()=>{setBattleState(null);setBattleTarget(null);setBattleScore({me:0,opponent:0});setCurrentBattleQ(0);}}
                  color="var(--gold)" size="lg" style={{width:"100%",borderRadius:12}}>
                  Rejouer ⚔️
                </Btn>
              </div>
            )}
          </div>
        )}

        {/* ── ÉQUIPE ───────────────────────────────────────────────────── */}
        {subTab === "equipe" && (
          <div>
            {!team ? (
              <>
                <Surface style={{ padding:24, marginBottom:16, textAlign:"center" }}>
                  <div style={{ fontSize:48, marginBottom:12 }}>👥</div>
                  <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, color:"var(--text)", marginBottom:8 }}>
                    Rejoins ou crée une équipe
                  </h3>
                  <p style={{ color:"var(--muted)", fontSize:13, lineHeight:1.6, marginBottom:20 }}>
                    3 élèves · 1 équipe · Kodjo vous coach collectivement. Combinez vos forces pour grimper dans les classements d'équipe !
                  </p>
                  <Btn onClick={createTeam} color="var(--gold)" size="lg" loading={teamLoading} style={{width:"100%",borderRadius:12}}>
                    Créer mon équipe 🚀
                  </Btn>
                </Surface>
              </>
            ) : (
              <>
                <Surface style={{ padding:20, marginBottom:16, background:"linear-gradient(135deg,var(--navy),#1A3A6B)", border:"none" }}>
                  <h3 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"#fff", marginBottom:12 }}>
                    👥 {team.name}
                  </h3>
                  <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                    {teamMembers.map(m => (
                      <div key={m.id} style={{ display:"flex", alignItems:"center", gap:8, background:"rgba(255,255,255,0.1)", borderRadius:100, padding:"6px 14px" }}>
                        <div style={{ width:24, height:24, borderRadius:"50%", background:"var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, color:"#fff" }}>
                          {(m.name||"?").charAt(0)}
                        </div>
                        <span style={{ fontSize:12, color:"#fff" }}>{m.name}</span>
                        <span style={{ fontSize:11, color:"var(--gold)" }}>⚡{formatNumber(m.xp||0)}</span>
                      </div>
                    ))}
                    {teamMembers.length < 3 && (
                      <div style={{ display:"flex", alignItems:"center", gap:6, background:"rgba(255,255,255,0.05)", borderRadius:100, padding:"6px 14px", border:"1px dashed rgba(255,255,255,0.2)" }}>
                        <span style={{ fontSize:12, color:"rgba(255,255,255,0.4)" }}>+ Inviter un membre</span>
                      </div>
                    )}
                  </div>
                </Surface>

                {/* Coach Kodjo */}
                {kodjoCoachMsg && (
                  <Surface style={{ padding:16, marginBottom:16, background:"rgba(26,86,219,0.06)", borderColor:"var(--blue)" }}>
                    <p style={{ fontSize:12, fontWeight:700, color:"var(--blue)", marginBottom:6 }}>🤖 Kodjo coach dit</p>
                    <p style={{ fontSize:13, color:"var(--text)", lineHeight:1.6 }}>{kodjoCoachMsg}</p>
                  </Surface>
                )}

                {/* Chat d'équipe */}
                <Surface style={{ padding:16 }}>
                  <h3 style={{ fontSize:14, fontWeight:700, color:"var(--text)", marginBottom:12 }}>💬 Chat équipe</h3>
                  <div style={{ maxHeight:200, overflowY:"auto", marginBottom:10 }}>
                    {teamChat.length === 0 && (
                      <p style={{ fontSize:13, color:"var(--faint)", textAlign:"center", padding:16 }}>Commencez à discuter !</p>
                    )}
                    {teamChat.map((m,i) => (
                      <div key={i} style={{ marginBottom:8 }}>
                        <span style={{ fontSize:11, fontWeight:700, color:"var(--gold)" }}>{m.sender} · {m.time}</span>
                        <p style={{ fontSize:13, color:"var(--text)", marginTop:2 }}>{m.content}</p>
                      </div>
                    ))}
                  </div>
                  <div style={{ display:"flex", gap:8 }}>
                    <input value={teamMessage} onChange={e=>setTeamMessage(e.target.value)}
                      onKeyDown={e=>e.key==="Enter"&&sendTeamMessage()}
                      placeholder="Message à l'équipe..."
                      style={{ flex:1, padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }} />
                    <button onClick={sendTeamMessage} aria-label="Envoyer"
                      style={{ padding:"10px 16px", borderRadius:10, background:"var(--navy)", border:"none", color:"#fff", cursor:"pointer", fontSize:18 }}>→</button>
                  </div>
                </Surface>
              </>
            )}
          </div>
        )}

        {/* ── TOURNOI ──────────────────────────────────────────────────── */}
        {subTab === "tournoi" && (
          <div>
            <Surface style={{ padding:24, marginBottom:16, background:"linear-gradient(135deg, #C9972C, #E8B84B)", border:"none", textAlign:"center" }}>
              <div style={{ fontSize:48, marginBottom:8 }}>🏆</div>
              <h3 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff", marginBottom:4 }}>
                Coupe Nunya
              </h3>
              <p style={{ color:"rgba(255,255,255,0.8)", fontSize:13, marginBottom:16 }}>
                Tournoi mensuel · Top 10 de chaque ligue s'affrontent
              </p>
              <Chip color="rgba(255,255,255,0.3)" style={{ color:"#fff", fontSize:12 }}>
                🔜 Prochain tournoi : 1er {new Date().toLocaleDateString("fr-FR",{month:"long"})}
              </Chip>
            </Surface>

            <Surface style={{ padding:20, marginBottom:16 }}>
              <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:12 }}>Comment ça marche</h3>
              {[
                { icon:"1️⃣", text:"Finir dans le Top 10 de ta ligue cette semaine" },
                { icon:"2️⃣", text:"Tu es automatiquement qualifié pour la Coupe Nunya" },
                { icon:"3️⃣", text:"Battle 1v1 contre les meilleurs de toutes les ligues" },
                { icon:"4️⃣", text:"Le champion reçoit le badge 🏆 Champion Nunya" },
              ].map(s => (
                <div key={s.icon} style={{ display:"flex", gap:12, alignItems:"flex-start", marginBottom:12 }}>
                  <span style={{ fontSize:20, flexShrink:0 }}>{s.icon}</span>
                  <p style={{ fontSize:14, color:"var(--text)", lineHeight:1.5 }}>{s.text}</p>
                </div>
              ))}
            </Surface>

            {myRank > 0 && myRank <= 10 ? (
              <Surface style={{ padding:16, background:"rgba(16,185,129,0.08)", borderColor:"var(--green)" }}>
                <p style={{ fontSize:14, fontWeight:700, color:"var(--green)", marginBottom:4 }}>
                  ✅ Tu es qualifié pour la Coupe Nunya !
                </p>
                <p style={{ fontSize:12, color:"var(--muted)" }}>
                  Tu es #{myRank} dans ta ligue. Continue comme ça pour maintenir ta place !
                </p>
              </Surface>
            ) : (
              <Surface style={{ padding:16, background:"rgba(201,151,44,0.06)", borderColor:"var(--gold)" }}>
                <p style={{ fontSize:14, fontWeight:700, color:"var(--gold)", marginBottom:4 }}>
                  🎯 {10 - (myRank||10)} places à remonter
                </p>
                <p style={{ fontSize:12, color:"var(--muted)" }}>
                  Tu es #{myRank||"?"} — entre dans le Top 10 pour te qualifier pour la Coupe !
                </p>
              </Surface>
            )}
          </div>
        )}

        {/* ── DÉFI KODJO ───────────────────────────────────────────────── */}
        {subTab === "defi" && weeklyChallenge && (
          <div>
            <Surface style={{ padding:24, marginBottom:16, background:"linear-gradient(135deg,var(--navy),#1A3A6B)", border:"none" }}>
              <div style={{ display:"flex", gap:12, alignItems:"center", marginBottom:12 }}>
                <span style={{ fontSize:36 }}>🤖</span>
                <div>
                  <p style={{ fontSize:12, color:"rgba(255,255,255,0.5)", marginBottom:2 }}>DÉFI HEBDOMADAIRE KODJO</p>
                  <h3 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"#fff" }}>
                    Semaine {weeklyChallenge.subject}
                  </h3>
                </div>
              </div>
              <p style={{ color:"rgba(255,255,255,0.7)", fontSize:13, lineHeight:1.6, marginBottom:14 }}>
                Cette semaine, Kodjo défie tous les élèves sur <strong style={{color:"var(--gold)"}}>{weeklyChallenge.subject}</strong>. 
                Fais le maximum d'exercices pour grimper dans le classement spécial !
              </p>
              <div style={{ display:"flex", justifyContent:"space-between" }}>
                <Chip color="var(--gold)">🏆 +{weeklyChallenge.xpReward} XP</Chip>
                <span style={{ fontSize:12, color:"rgba(255,255,255,0.5)" }}>
                  Fin dans {countdown.days}j {countdown.hours}h
                </span>
              </div>
            </Surface>

            <Surface style={{ padding:20, marginBottom:16 }}>
              <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:12 }}>
                🏅 Récompenses
              </h3>
              {[
                { place:"🥇 1er", reward:"Badge Champion + 200 XP" },
                { place:"🥈 2ème", reward:"Badge Finaliste + 150 XP" },
                { place:"🥉 3ème", reward:"Badge Médaillé + 100 XP" },
                { place:"Top 10", reward:"+50 XP bonus" },
              ].map(r => (
                <div key={r.place} style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid var(--border2)" }}>
                  <span style={{ fontSize:14, fontWeight:600, color:"var(--text)" }}>{r.place}</span>
                  <span style={{ fontSize:13, color:"var(--gold)" }}>{r.reward}</span>
                </div>
              ))}
            </Surface>

            <Btn color="var(--gold)" size="lg" style={{ width:"100%", borderRadius:12 }}
              onClick={() => onNav && onNav("learn")}>
              Commencer le défi → {weeklyChallenge.subject}
            </Btn>
          </div>
        )}

        {/* Protection anti-relégation */}
        {showProtection && (
          <Modal onClose={()=>setShowProtection(false)} title="🛡️ Protection anti-relégation">
            <p style={{ fontSize:14, color:"var(--text)", lineHeight:1.6, marginBottom:20 }}>
              Tu es dans la zone de relégation. Dépense <strong>2 000 XP</strong> pour protéger ton rang cette semaine.
            </p>
            <p style={{ fontSize:13, color:"var(--muted)", marginBottom:20 }}>
              Ton solde actuel : <strong>{formatNumber(userXP)} XP</strong>
            </p>
            {userXP >= 2000 ? (
              <div style={{ display:"flex", gap:10 }}>
                <Btn onClick={()=>setShowProtection(false)} variant="outline" color="var(--muted)" style={{flex:1}}>Annuler</Btn>
                <Btn onClick={useProtection} color="var(--gold)" style={{flex:1}}>Utiliser 2 000 XP</Btn>
              </div>
            ) : (
              <>
                <p style={{ fontSize:13, color:"var(--red)", marginBottom:16 }}>
                  Tu n'as pas assez d'XP. Il te faut {formatNumber(2000 - userXP)} XP de plus.
                </p>
                <Btn onClick={()=>setShowProtection(false)} color="var(--gold)" style={{width:"100%"}}>Continuer à apprendre</Btn>
              </>
            )}
          </Modal>
        )}

      </div>
    </div>
  );
};
const ChangePasswordScreen = ({ user, onDone }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");
    if (newPassword.length < 8) { setError("Le mot de passe doit contenir au moins 8 caractères."); return; }
    if (!/[A-Z]/.test(newPassword)) { setError("Le mot de passe doit contenir au moins une majuscule."); return; }
    if (!/[0-9]/.test(newPassword)) { setError("Le mot de passe doit contenir au moins un chiffre."); return; }
    if (newPassword !== confirm) { setError("Les mots de passe ne correspondent pas."); return; }
    setLoading(true);
    try {
      const { error: updateError } = await supabase.auth.updateUser({ password: newPassword });
      if (updateError) { setError(updateError.message); setLoading(false); return; }
      await supabase.from("profiles").update({ must_change_password: false }).eq("id", user.id);
      onDone();
    } catch(e) {
      setError("Une erreur est survenue.");
    }
    setLoading(false);
  };

  return (
    <div className="main-content fade" style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", background:"var(--bg)" }}>
      <div style={{ width:"100%", maxWidth:400, padding:24 }}>
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <p style={{ fontSize:48, marginBottom:8 }}>🔐</p>
          <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, color:"var(--text)", marginBottom:8 }}>
            Change ton mot de passe
          </h2>
          <p style={{ fontSize:13, color:"var(--muted)", lineHeight:1.6 }}>
            Pour ta sécurité, tu dois créer un nouveau mot de passe avant d'accéder à la plateforme.
          </p>
        </div>
        <Surface style={{ padding:24 }}>
          <div style={{ marginBottom:14 }}>
            <label htmlFor="new-password" style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>
              Nouveau mot de passe
            </label>
            <input
              id="new-password"
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Min. 8 car. + majuscule + chiffre"
              style={{ width:"100%", padding:"12px 16px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none", boxSizing:"border-box" }}
            />
          </div>
          <div style={{ marginBottom:14 }}>
            <label htmlFor="confirm-password" style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>
              Confirmer le mot de passe
            </label>
            <input
              id="confirm-password"
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="Répète ton mot de passe"
              style={{ width:"100%", padding:"12px 16px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none", boxSizing:"border-box" }}
            />
          </div>
          {error && <p style={{ color:"var(--red)", fontSize:12, marginBottom:12, background:"rgba(239,68,68,0.08)", padding:"10px 14px", borderRadius:8 }}>{error}</p>}
          <Btn onClick={handleSubmit} color="var(--gold)" size="lg" loading={loading} style={{ width:"100%" }}>
            Enregistrer mon mot de passe 🔐
          </Btn>
        </Surface>
        <p style={{ textAlign:"center", fontSize:11, color:"var(--muted)", marginTop:16 }}>
          Besoin d'aide ? support@nunya.academy
        </p>
      </div>
    </div>
  );
};

const UpgradeScreen = ({ user, onBack, onUpgrade }) => {
  const [billing, setBilling] = React.useState("monthly");
  const [loading, setLoading] = React.useState(null);

  const handleUpgrade = async (planId) => {
    if (!onUpgrade) return;
    setLoading(planId);
    await onUpgrade(planId, billing);
    setLoading(null);
  };
  const plans = [
    { id:"Essentiel", price:"1 999 FCFA", priceEur:"2,99€", priceAnnualFcfa:"17 991 FCFA", priceAnnualEur:"29,90€", period:"/mois", color:"var(--green)", icon:"⭐", features:["Toutes les leçons (6ème→Terminale)", "Exercices corrigés complets", "Annales DNB + BAC officielles", "Kodjo illimité"] },
    { id:"Premium", price:"3 499 FCFA", priceEur:"4,99€", priceAnnualFcfa:"31 491 FCFA", priceAnnualEur:"49,90€", period:"/mois", color:"var(--gold)", icon:"💎", features:["Tout Essentiel", "Toutes les spécialités (Maths, SVT, PC...)", "Rapport parents hebdomadaire Kodjo", "Statistiques avancées de progression"], recommended:true },
    { id:"Famille", price:"6 499 FCFA", priceEur:"9,99€", priceAnnualFcfa:"58 491 FCFA", priceAnnualEur:"99,90€", period:"/mois", color:"var(--blue)", icon:"👨‍👩‍👧", features:["Tout Premium", "Jusqu'à 4 enfants", "Dashboard parents centralisé", "Rapports individuels par enfant"] },
  ];
  return (
    <div className="main-content fade">
      <div style={{ background:"var(--navy)", padding:"16px" }}>
        <button onClick={onBack} aria-label="Retour" style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:8 }}>← Retour</button>
        <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff", marginBottom:4 }}>
          🚀 Passe à la vitesse supérieure
        </h2>
        <p style={{ color:"rgba(255,255,255,0.5)", fontSize:12 }}>Débloque tout le potentiel de Nunya Academy</p>
      </div>
      <div style={{ padding:16 }}>
        {plans.filter(p => {
  if (user?.plan === "Essentiel") return p.id !== "Essentiel";
  if (user?.plan === "Premium") return p.id === "Famille";
  return true;
}).map(plan => (
          <Surface key={plan.id} style={{ padding:20, marginBottom:12, border: plan.recommended ? "2px solid var(--gold)" : "1.5px solid var(--border)", position:"relative" }}>
            {plan.recommended && (
              <div style={{ position:"absolute", top:-10, left:"50%", transform:"translateX(-50%)", background:"var(--gold)", color:"#fff", fontSize:10, fontWeight:700, padding:"3px 12px", borderRadius:100 }}>
                RECOMMANDÉ
              </div>
            )}
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:12 }}>
              <span style={{ fontSize:28 }}>{plan.icon}</span>
              <div style={{ flex:1 }}>
                <p style={{ fontSize:16, fontWeight:700, color:"var(--text)" }}>{plan.id}</p>
                <p style={{ fontSize:13, color:"var(--muted)" }}>{plan.price} <span style={{ fontSize:11 }}>({plan.priceEur})</span> {plan.period}</p>
              </div>
            </div>
            {plan.features.map((f, i) => (
              <div key={i} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6 }}>
                <span style={{ color:"var(--green)", fontSize:14 }}>✓</span>
                <p style={{ fontSize:13, color:"var(--text)" }}>{f}</p>
              </div>
            ))}
            <div style={{ marginTop:12 }}>
              <div style={{ display:"flex", gap:8, marginBottom:8 }}>
                <button
                  onClick={() => setBilling("monthly")}
                  style={{ flex:1, padding:"6px", borderRadius:8, border:`1.5px solid ${billing==="monthly"?"var(--gold)":"var(--border)"}`, background:billing==="monthly"?"var(--gold-light)":"transparent", color:billing==="monthly"?"var(--gold)":"var(--muted)", fontSize:12, fontWeight:600, cursor:"pointer" }}>
                  Mensuel · {plan.price}
                </button>
                <button
                  onClick={() => setBilling("annual")}
                  style={{ flex:1, padding:"6px", borderRadius:8, border:`1.5px solid ${billing==="annual"?"var(--gold)":"var(--border)"}`, background:billing==="annual"?"var(--gold-light)":"transparent", color:billing==="annual"?"var(--gold)":"var(--muted)", fontSize:12, fontWeight:600, cursor:"pointer" }}>
                  Annuel · {plan.priceAnnualFcfa} 🎁
                </button>
              </div>
              <Btn
                color={plan.color}
                style={{ width:"100%" }}
                onClick={() => handleUpgrade(plan.id)}
                disabled={loading === plan.id}>
                {loading === plan.id ? "Chargement..." : `Choisir ${plan.id}`}
              </Btn>
            </div>
          </Surface>
        ))}
        <p style={{ fontSize:11, color:"var(--muted)", textAlign:"center", marginTop:8 }}>
          Paiement sécurisé · Résiliation à tout moment · Support : support@nunya.academy
        </p>
      </div>
    </div>
  );
};
const Annales = ({ user, onBack, onNav }) => {
  const isAdmin = ["superadmin","admin"].includes(user?.role);
  const userLevel = user?.level;

const defaultTab = isAdmin ? "dnb"
    : userLevel === "3ème"          ? "dnb"
    : userLevel === "1ère Générale" ? "bac1"
    : userLevel === "Terminale Générale" ? "bac"
    : "dnb";
  const [tab, setTab] = useState(defaultTab);
  const [pdfViewer, setPdfViewer] = useState(null); // { url, title }
  const pdfCanvasRef = useRef(null);
const [pdfLoading, setPdfLoading] = useState(false);
const [pdfPage, setPdfPage] = useState(1);
const [pdfTotalPages, setPdfTotalPages] = useState(1);

useEffect(() => {
  if (!pdfViewer || !window.pdfjsLib) return;
  setPdfLoading(true);
  setPdfPage(1);
  // Nettoyer le container précédent
  const container = document.getElementById('pdf-container');
  if (container) container.innerHTML = '';
  const loadPdf = async () => {
    try {
      const pdf = await window.pdfjsLib.getDocument(pdfViewer.url).promise;
      setPdfTotalPages(pdf.numPages);
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = document.createElement('canvas');
        canvas.style.maxWidth = '100%';
        canvas.style.display = 'block';
        canvas.style.marginBottom = '16px';
        canvas.style.borderRadius = '8px';
        const ctx = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: ctx, viewport }).promise;
        if (user?.name && user?.email) {
          ctx.save();
          ctx.globalAlpha = 0.12;
          ctx.fillStyle = '#000000';
          ctx.font = 'bold 22px Arial';
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(-Math.PI / 6);
          const watermark = `${user.name} • ${user.email} • ${new Date().toLocaleDateString('fr-FR')}`;
          ctx.fillText(watermark, -ctx.measureText(watermark).width / 2, 0);
          ctx.restore();
        }
        canvas.oncontextmenu = (e) => e.preventDefault();
        const cont = document.getElementById('pdf-container');
        if (cont) cont.appendChild(canvas);
      }
      setPdfLoading(false);
    } catch(e) {
      console.error('PDF error:', e);
      setPdfLoading(false);
    }
  };
  loadPdf();
}, [pdfViewer]);
  const [selectedYear, setSelectedYear] = useState(2026);
  const [selectedSession, setSelectedSession] = useState("metropole");
  // Spécialités de l'élève normalisées
  const userSpecIds = (user?.specialties || []).map(sid => {
    const sp = SPECIALTIES.find(s => s.id === sid);
    if (!sp) return "";
    const label = sp.label.toLowerCase();
    if (label.includes("math")) return "maths";
    if (label.includes("svt") || label.includes("biologie")) return "svt";
    if (label.includes("physique") || label.includes("pc")) return "pc";
    if (label.includes("ses") || label.includes("économi")) return "ses";
    if (label.includes("nsi") || label.includes("informatique")) return "nsi";
    if (label.includes("hggsp") || label.includes("géopolitique")) return "hggsp";
    if (label.includes("hlp") || label.includes("humanités")) return "hlp";
    if (label.includes("art")) return "arts";
   if (label.includes("langue") || label.includes("llcer")) return "llcer";
    if (label.includes("ingénieur") || label.includes("si")) return "si";
    return "";
  }).filter(Boolean);

  const filterEpreuves = (list) => {
    if (isAdmin) return list;
    const hasPremiumAccess = ["Premium","Famille"].includes(user?.plan);
    return list.filter(e => {
      if (e.forAll) return true;
      if (e.specId) return hasPremiumAccess && userSpecIds.includes(e.specId);
      return true;
    });
  };
  const TAB_CONFIG = {
    dnb:  { label:"Brevet (DNB)", icon:"📋", epreuves: ANNALES_DNB, niveaux:["3ème"] },
    bac1: { label:"BAC 1ère",    icon:"📗", epreuves: filterEpreuves(ANNALES_BAC_1ERE), niveaux:["1ère"] },
    bac:  { label:"BAC Terminale",icon:"🎓",epreuves: filterEpreuves(ANNALES_BAC_TLE),  niveaux:["Terminale"] },
  };

 const visibleTabs = isAdmin ? ["dnb","bac1","bac"]
    : userLevel === "3ème"          ? ["dnb"]
    : userLevel === "1ère Générale" ? ["bac1"]
    : userLevel === "Terminale Générale" ? ["bac"]
    : [];

  const currentEpreuves = TAB_CONFIG[tab]?.epreuves || [];
  const currentSession = ANNALES_SESSIONS.find(s => s.id === selectedSession);

  const getAnnaleUrl = async (epreuve, type) => {
    const filePath = `${tab}/${selectedSession}/${selectedYear}/${epreuve.id}${type === "corrige" ? "_corrige" : "_sujet"}.pdf`;
    const { data, error } = await supabase.storage
      .from('annales')
      .createSignedUrl(filePath, 86400); // 24 heures
    if (error || !data?.signedUrl) return null;
    return data.signedUrl;
  };
  if (visibleTabs.length === 0) {
  const anticipationData = {
    "6ème": { emoji:"🎯", years:3, exam:"Brevet (DNB)", concepts:["Fractions et calculs","Grammaire et conjugaison","Repères historiques","Cellule vivante"] },
    "5ème": { emoji:"🎯", years:2, exam:"Brevet (DNB)", concepts:["Équations du 1er degré","Figures géométriques","Moyen-Âge et Révolutions","Écosystèmes"] },
    "4ème": { emoji:"🔥", years:1, exam:"Brevet (DNB)", concepts:["Théorème de Pythagore","Argumentation écrite","XIXème siècle","Réactions chimiques"] },
    "2nde": { emoji:"🚀", years:2, exam:"Baccalauréat", concepts:["Fonctions et variations","Analyse littéraire","Géopolitique mondiale","Génétique et ADN"] },
  };
  const data = anticipationData[userLevel];
  return (
    <div className="main-content fade">
      <div style={{ background:"var(--navy)", padding:"20px 16px" }}>
        <button onClick={onBack} aria-label="Retour" style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer" }}>← Retour</button>
      </div>
      <div style={{ padding:24 }}>
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <p style={{ fontSize:48, marginBottom:8 }}>{data?.emoji || "📄"}</p>
          <h3 style={{ fontFamily:"var(--font-display)", fontSize:22, color:"var(--text)", marginBottom:8 }}>
            Ton {data?.exam} dans {data?.years} an{data?.years > 1 ? "s" : ""}
          </h3>
          <p style={{ fontSize:14, color:"var(--muted)", lineHeight:1.6 }}>
            Les annales seront disponibles en 3ème et au lycée.<br/>
            En attendant, voici les notions clés à maîtriser dès maintenant.
          </p>
        </div>
        {data?.concepts && (
          <Surface style={{ padding:20, marginBottom:16 }}>
            <p style={{ fontSize:13, fontWeight:700, color:"var(--text)", marginBottom:12 }}>
              📚 Notions clés pour ton {data.exam}
            </p>
            {data.concepts.map((c, i) => (
              <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 0", borderBottom: i < data.concepts.length-1 ? "1px solid var(--border2)" : "none" }}>
                <div style={{ width:28, height:28, borderRadius:"50%", background:"var(--gold-light)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, color:"var(--gold)", flexShrink:0 }}>
                  {i+1}
                </div>
                <p style={{ fontSize:14, color:"var(--text)" }}>{c}</p>
                <Chip color="var(--green)" style={{ marginLeft:"auto", fontSize:10 }}>Clé examen</Chip>
              </div>
            ))}
          </Surface>
        )}
        <Surface style={{ padding:16, background:"rgba(201,151,44,0.06)", border:"1px solid var(--gold)" }}>
          <p style={{ fontSize:13, color:"var(--text)", fontWeight:600, marginBottom:4 }}>
            💡 Le savais-tu ?
          </p>
          <p style={{ fontSize:13, color:"var(--muted)", lineHeight:1.6 }}>
            Les élèves qui commencent à préparer leur {data?.exam} {data?.years} an{data?.years > 1 ? "s" : ""} à l'avance obtiennent en moyenne <strong style={{ color:"var(--gold)" }}>3 points de plus</strong> que les autres.
          </p>
        </Surface>
      </div>
    </div>
  );
}
return (
    <div className="main-content fade">
      {pdfViewer && (
  <div style={{
    position:"fixed", top:0, left:0, right:0, bottom:0, zIndex:9999,
    background:"#1a1a1a", display:"flex", flexDirection:"column"
  }}>
    {/* Header */}
    <div style={{
      display:"flex", alignItems:"center", justifyContent:"space-between",
      padding:"12px 16px", background:"var(--navy)", flexShrink:0
    }}>
      <p style={{ fontSize:13, fontWeight:700, color:"#fff", flex:1 }}>{pdfViewer.title}</p>
     <div style={{ display:"flex", gap:8, alignItems:"center" }}>
  {pdfTotalPages > 1 && (
    <>
      <button onClick={async () => {
        if (pdfPage <= 1) return;
        const newPage = pdfPage - 1;
        setPdfPage(newPage);
        const pdf = await window.pdfjsLib.getDocument(pdfViewer.url).promise;
        const page = await pdf.getPage(newPage);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = pdfCanvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: ctx, viewport }).promise;
      }} style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:8, padding:"6px 10px", color:"#fff", fontSize:14, cursor:"pointer" }} disabled={pdfPage <= 1}>‹</button>
      <span style={{ fontSize:11, color:"rgba(255,255,255,0.6)" }}>
        Page {pdfPage}/{pdfTotalPages}
      </span>
      <button onClick={async () => {
        if (pdfPage >= pdfTotalPages) return;
        const newPage = pdfPage + 1;
        setPdfPage(newPage);
        const pdf = await window.pdfjsLib.getDocument(pdfViewer.url).promise;
        const page = await pdf.getPage(newPage);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = pdfCanvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: ctx, viewport }).promise;
      }} style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:8, padding:"6px 10px", color:"#fff", fontSize:14, cursor:"pointer" }} disabled={pdfPage >= pdfTotalPages}>›</button>
    </>
  )}
  <button onClick={() => setPdfViewer(null)} style={{
    background:"rgba(255,255,255,0.1)", border:"none", borderRadius:8,
    padding:"6px 12px", color:"#fff", fontSize:12, cursor:"pointer", fontWeight:600
  }}>✕ Fermer</button>
</div>
    </div>
    {/* Canvas PDF */}
    <div style={{ flex:1, overflow:"auto", display:"flex", justifyContent:"center", padding:16 }}>
      {pdfLoading && (
        <div style={{ display:"flex", alignItems:"center", justifyContent:"center", flex:1 }}>
          <p style={{ color:"rgba(255,255,255,0.6)", fontSize:14 }}>⏳ Chargement du PDF...</p>
        </div>
      )}
      <div id="pdf-container" style={{ width:"100%", display:"flex", flexDirection:"column", alignItems:"center" }} />
    </div>
  </div>
)}
      {/* Header */}
      <div style={{ background:"var(--navy)", padding:"16px", position:"sticky", top:0, zIndex:40 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:10 }}>← Retour</button>
        <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff", marginBottom:4 }}>
          📄 Annales officielles
        </h2>
        <p style={{ color:"rgba(255,255,255,0.5)", fontSize:12 }}>
          {tab === "dnb"
            ? "Brevet (DNB)"
            : tab === "bac1"
            ? "BAC 1ère — Épreuves anticipées"
            : "BAC Terminale"
          } · 11 ans · 6 sessions mondiales
        </p>
        {/* Tabs */}
        <div style={{ display:"flex", gap:6, marginTop:12, overflowX:"auto", paddingBottom:2 }}>
          {visibleTabs.map(t => (
            <button key={t} onClick={() => setTab(t)}
              style={{ flexShrink:0, padding:"6px 14px", borderRadius:100, fontSize:12, fontWeight:700,
                border:`1.5px solid ${tab===t?"var(--gold)":"rgba(255,255,255,0.2)"}`,
                background: tab===t?"rgba(201,151,44,0.2)":"transparent",
                color: tab===t?"var(--gold)":"rgba(255,255,255,0.6)",
                cursor:"pointer", fontFamily:"var(--font-body)" }}>
              {TAB_CONFIG[t].icon} {TAB_CONFIG[t].label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding:"16px" }}>

        {/* Filtre Année */}
        <div style={{ marginBottom:14 }}>
          <p style={{ fontSize:11, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>ANNÉE</p>
          <div style={{ display:"flex", gap:6, overflowX:"auto", paddingBottom:4 }}>
            {ANNALES_YEARS.slice().reverse().map(y => (
              <button key={y} onClick={() => setSelectedYear(y)}
                style={{ flexShrink:0, padding:"6px 12px", borderRadius:100, fontSize:12, fontWeight:600,
                  border:`1.5px solid ${selectedYear===y?"var(--gold)":"var(--border)"}`,
                  background: selectedYear===y?"var(--gold-light)":"var(--surface)",
                  color: selectedYear===y?"var(--gold)":"var(--text)",
                  cursor:"pointer", fontFamily:"var(--font-body)" }}>
                {y}
              </button>
            ))}
          </div>
        </div>

        {/* Filtre Session */}
        <div style={{ marginBottom:20 }}>
          <p style={{ fontSize:11, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>SESSION MONDIALE</p>
          <div style={{ display:"flex", gap:6, overflowX:"auto", paddingBottom:4 }}>
            {ANNALES_SESSIONS.map(s => (
              <button key={s.id} onClick={() => setSelectedSession(s.id)}
                style={{ flexShrink:0, padding:"6px 12px", borderRadius:100, fontSize:11, fontWeight:600,
                  border:`1.5px solid ${selectedSession===s.id?"var(--gold)":"var(--border)"}`,
                  background: selectedSession===s.id?"var(--gold-light)":"var(--surface)",
                  color: selectedSession===s.id?"var(--gold)":"var(--text)",
                  cursor:"pointer", fontFamily:"var(--font-body)",
                  display:"flex", alignItems:"center", gap:4 }}>
                {s.flag} {s.label}
              </button>
            ))}
          </div>
        </div>

        {/* Épreuves */}
        <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:12 }}>
          {currentEpreuves.length} ÉPREUVE{currentEpreuves.length > 1 ? "S" : ""} — {selectedYear} · {currentSession?.label}
        </p>

        {currentEpreuves.length === 0 && (
          <EmptyState icon="📄" title="Aucune épreuve" message="Aucune annale disponible pour ta sélection." />
        )}

        {currentEpreuves.map(e => (
          <Surface key={e.id} style={{ padding:16, marginBottom:10 }}>
            <div style={{ display:"flex", alignItems:"center", gap:12 }}>
              <div style={{ width:44, height:44, borderRadius:12, background:"var(--gold-light)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, flexShrink:0 }}>
                {e.icon}
              </div>
              <div style={{ flex:1 }}>
                <p style={{ fontSize:14, fontWeight:700, color:"var(--text)", marginBottom:4 }}>{e.label}</p>
                <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                  <Chip color="var(--navy)" style={{ fontSize:10 }}>{selectedYear}</Chip>
                  <Chip color="var(--blue)" style={{ fontSize:10 }}>{currentSession?.flag} {currentSession?.label}</Chip>
                  {e.forAll && <Chip color="var(--green)" style={{ fontSize:10 }}>Toutes filières</Chip>}
                  {!e.forAll && <Chip color="var(--gold)" style={{ fontSize:10 }}>Ta spécialité</Chip>}
                </div>
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:6, flexShrink:0 }}>
  {["Essentiel","Premium","Famille"].includes(user?.plan) ? (
    <>
      <Btn color="var(--navy)" size="sm" style={{ fontSize:11, padding:"6px 12px" }}
        onClick={async () => {
          const url = await getAnnaleUrl(e, "sujet");
          if (url) setPdfViewer({ url, title: e.label + " — Sujet " + selectedYear });
          else alert("Cette annale n'est pas encore disponible.");
        }}>
        📄 Sujet
      </Btn>
      <Btn color="var(--green)" size="sm" style={{ fontSize:11, padding:"6px 12px" }}
        onClick={async () => {
          const url = await getAnnaleUrl(e, "corrige");
          if (url) setPdfViewer({ url, title: e.label + " — Corrige " + selectedYear });
          else alert("Cette annale n'est pas encore disponible.");
        }}>
        ✅ Corrigé
      </Btn>
      </>
    ) : (
    <Btn color="var(--gold)" size="sm" style={{ fontSize:11, padding:"6px 12px" }}
  onClick={() => onNav("upgrade")}>
  🔒 Essentiel
</Btn>
  )}
</div>
            </div>
          </Surface>
        ))}
        {/* Message admin */}
        {isAdmin && (
          <Surface style={{ padding:14, marginTop:12, background:"rgba(201,151,44,0.08)", borderColor:"var(--gold)" }}>
            <p style={{ fontSize:12, color:"var(--text)", lineHeight:1.7 }}>
              💡 <strong>Upload des PDFs :</strong> Supabase Storage → bucket <code>annales</code><br/>
              Structure : <code>{tab} / {selectedSession} / {selectedYear} / [epreuve].pdf</code><br/>
              Exemple : <code>dnb/metropole/2024/francais.pdf</code>
            </p>
          </Surface>
        )}

      </div>
    </div>
  );
};


// ─── ÉCRAN APPRENDRE ──────────────────────────────────────────────────────────
const LearnScreen = ({ user, subjects, levels, onSubject, onNav }) => {
  const selectedLevel = user?.level || "6ème";
  const isAdmin = ["superadmin","admin"].includes(user?.role);

  const is1ereOrTle = ["1ère","1ère Générale","1ère Techno","1ère Pro","Terminale","Terminale Générale","Terminale Techno","Terminale Pro"].includes(selectedLevel);
const levelSubjects = subjects.filter(s => {
   if (s.id > 7 && !(s.id === 22 && ["1ère","1ère Générale","Terminale","Terminale Générale"].includes(selectedLevel))) return false;
    if (s.name === "Philosophie") return ["Terminale Générale","Terminale Techno","Terminale Pro"].includes(selectedLevel);
  if (s.name === "Français") return !["Terminale Générale","Terminale Techno","Terminale Pro"].includes(selectedLevel);
    if (s.name === "Économie") return false;
    if (s.name === "Éducation Civique") return false;
    if (s.name === "Espagnol") return false;
    if (is1ereOrTle && ["Mathématiques","SVT","Physique-Chimie"].includes(s.name)) return false;
    if (["1ère","1ère Générale","1ère Techno","1ère Pro"].includes(selectedLevel) && s.name === "Philosophie") return false;
    return true;
  });

 const hasPremiumPlan = ["Premium","Famille"].includes(user?.plan) || isAdmin;
const specialtySubjects = (user?.specialties || []).map(sid => {
    const sp = SPECIALTIES.find(s => s.id === sid);
    return sp ? { 
      id: "spec_"+sp.id, 
      name: sp.label, 
      icon: sp.icon, 
      isSpecialty: true,
      locked: !hasPremiumPlan
    } : null;
  }).filter(Boolean);

  return (
    <div className="main-content fade">
      <TopBar user={user} screen="learn" onNav={onNav} title="Apprendre" />

      <div style={{ padding:"16px" }}>

        {/* Cycle secondaire — 3 onglets */}
        <div style={{ marginBottom:20 }}>
          <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10 }}>
            CYCLE SECONDAIRE
          </p>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}>
            {/* Générale — actif */}
            <div style={{ padding:"10px 8px", borderRadius:12, border:"1.5px solid var(--gold)", background:"var(--gold-light)", textAlign:"center" }}>
              <p style={{ fontSize:12, fontWeight:700, color:"var(--gold)", marginBottom:2 }}>Générale</p>
              <p style={{ fontSize:10, color:"var(--gold)" }}>{selectedLevel}</p>
            </div>
            {/* Techno — grisé */}
            <div style={{ padding:"10px 8px", borderRadius:12, border:"1.5px dashed var(--border)", background:"var(--surface2)", textAlign:"center", opacity:0.5 }}>
              <p style={{ fontSize:12, fontWeight:700, color:"var(--faint)", marginBottom:2 }}>Techno</p>
              <p style={{ fontSize:10, color:"var(--faint)" }}>🔒 Bientôt</p>
            </div>
            {/* Pro — grisé */}
            <div style={{ padding:"10px 8px", borderRadius:12, border:"1.5px dashed var(--border)", background:"var(--surface2)", textAlign:"center", opacity:0.5 }}>
              <p style={{ fontSize:12, fontWeight:700, color:"var(--faint)", marginBottom:2 }}>Pro</p>
              <p style={{ fontSize:10, color:"var(--faint)" }}>🔒 Bientôt</p>
            </div>
          </div>
        </div>

        {/* Matières fondamentales */}
        <div style={{ marginBottom:20 }}>
          <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:12 }}>
            MATIÈRES — {selectedLevel}
          </p>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:12 }}>
            {levelSubjects.map(s => (
              <div
                key={s.id}
                onClick={() => onSubject(s, selectedLevel)}
                className="card-hover"
                style={{
                  background:"var(--surface)", border:"1px solid var(--border)",
                  borderRadius:16, padding:20, cursor:"pointer",
                }}
              >
                <div style={{ fontSize:32, marginBottom:12 }}>{getSubjectIcon(s.name)}</div>
                <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:4 }}>{s.name}</h3>
                <p style={{ fontSize:12, color:"var(--muted)" }}>{selectedLevel}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Spécialités */}
        {specialtySubjects.length > 0 && (
          <div style={{ marginBottom:20 }}>
            <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:12 }}>
              MES SPÉCIALITÉS
            </p>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:12 }}>
              {specialtySubjects.map(s => (
                <div
  key={s.id}
  onClick={() => !s.locked && onSubject(s, selectedLevel)}
  className={s.locked ? "" : "card-hover"}
  style={{
    background: s.locked ? "var(--surface2)" : "var(--surface)", 
    border: `1px solid ${s.locked ? "var(--border)" : "var(--blue)"}`,
    borderRadius:16, padding:20, cursor: s.locked ? "not-allowed" : "pointer",
    opacity: s.locked ? 0.7 : 1,
  }}
>
  <div style={{ fontSize:32, marginBottom:12 }}>{s.locked ? "🔒" : s.icon}</div>
  <h3 style={{ fontSize:15, fontWeight:700, color: s.locked ? "var(--muted)" : "var(--text)", marginBottom:4 }}>{s.name}</h3>
  <p style={{ fontSize:12, color: s.locked ? "var(--gold)" : "var(--blue)" }}>
    {s.locked ? "Plan Premium requis" : "Spécialité"}
  </p>
  {s.locked && (
    <button onClick={(e) => { e.stopPropagation(); onNav("upgrade"); }} style={{
      marginTop:8, background:"var(--gold)", color:"#fff", border:"none",
      borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer"
    }}>Débloquer</button>
  )}
</div>
              ))}
            </div>
          </div>
        )}

       {/* Annales — visibles seulement 3ème, 1ère, Terminale */}
        {(["3ème","1ère","1ère Générale","1ère Techno","1ère Pro","Terminale","Terminale Générale","Terminale Techno","Terminale Pro"].includes(selectedLevel) || isAdmin) && (
          <Surface
            className="card-hover"
            onClick={() => onNav("annales")}
            style={{ padding:20, display:"flex", alignItems:"center", gap:16, cursor:"pointer", marginTop:16, background:"linear-gradient(135deg, var(--navy), #1A3A6B)", border:"none" }}
          >
            <div style={{ fontSize:36 }}>📄</div>
            <div style={{ flex:1 }}>
              <h3 style={{ fontSize:15, fontWeight:700, color:"#fff", marginBottom:4 }}>Annales officielles</h3>
              <p style={{ fontSize:12, color:"rgba(255,255,255,0.6)" }}>
                {selectedLevel === "3ème"
                  ? "Brevet (DNB) · 11 ans · 6 sessions mondiales"
                  : ["1ère","1ère Générale","1ère Techno","1ère Pro"].includes(selectedLevel)
                  ? "BAC 1ère · 11 ans · 6 sessions mondiales"
                  : "BAC Terminale · 11 ans · 6 sessions mondiales"}
              </p>
            </div>
            <span style={{ color:"var(--gold)", fontSize:20 }}>›</span>
          </Surface>
        )}
      </div>
    </div>
  );
};


// ─── PARTIE 5 — PROFIL + PARENTS + SUPERADMIN + APP PRINCIPALE ───────────────


// ─── INVITATION PARENT (dans Paramètres) ─────────────────────────────────────
const PARENTE_OPTIONS = ["Papa","Maman","Tuteur","Tutrice","Grand-père","Grand-mère","Autre"];

const InviteParentSection = ({ user }) => {
  const [email, setEmail] = useState("");
  const [parente, setParente] = useState("Papa");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [linkedParents, setLinkedParents] = useState([]);

  useEffect(() => {
    loadLinkedParents();
  }, []);

  const loadLinkedParents = async () => {
    try {
      const { data } = await supabase
        .from("family_links")
        .select("*")
        .eq("child_id", user.id)
        .eq("status", "active");
      setLinkedParents(data || []);
    } catch(e) {}
  };

  const handleInvite = async () => {
    if (!email.trim()) { setError("Entre l'email du parent."); return; }
    if (linkedParents.length >= 2) { setError("Tu as déjà 2 parents liés (maximum)."); return; }
    setLoading(true); setError(""); setSuccess("");
    try {
      // Créer le lien dans family_links
      const token = Math.random().toString(36).substring(2) + Date.now().toString(36);
      const { error: linkError } = await supabase.from("family_links").insert({
        child_id: user.id,
        child_name: user.name,
        parent_email: email.trim(),
        parente,
        token,
        status: "pending",
        plan: user.plan,
      });
      if (linkError) { setError("Erreur lors de l'invitation."); setLoading(false); return; }

      // Envoyer email d'invitation via Edge Function
      await supabase.functions.invoke("send-email", {
        body: {
          type: "parent_invitation",
          to: email.trim(),
          variables: {
            parenteName: parente,
            childName: user.name,
            inviteUrl: `https://app.nunya.academy/famille/${token}`,
          }
        }
      });

      setSuccess(`✅ Invitation envoyée à ${email} ! ${parente} recevra un email pour rejoindre Nunya.`);
      setEmail("");
      loadLinkedParents();
    } catch(e) {
      setError("Une erreur est survenue.");
    }
    setLoading(false);
  };

  const handleRemoveParent = async (linkId, parentEmail) => {
    if (!window.confirm(`Retirer ${parentEmail} de tes parents liés ?`)) return;
    try {
      await supabase.from("family_links").update({ status:"removed" }).eq("id", linkId);
      setSuccess(`Lien retiré avec succès.`);
      loadLinkedParents();
    } catch(e) {}
  };

  return (
    <Surface style={{ padding:20, marginBottom:16 }}>
      <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:4 }}>
        👨‍👩‍👧 Inviter un parent
      </h3>
      <p style={{ fontSize:12, color:"var(--muted)", marginBottom:16, lineHeight:1.6 }}>
        {user?.plan === "Premium"
          ? "Plan Premium : tu peux inviter 1 parent."
          : "Plan Famille : tu peux inviter jusqu'à 2 parents."}
      </p>

      {/* Parents déjà liés */}
      {linkedParents.length > 0 && (
        <div style={{ marginBottom:16 }}>
          <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", marginBottom:8, textTransform:"uppercase" }}>
            PARENTS LIÉS
          </p>
          {linkedParents.map(link => (
            <div key={link.id} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", background:"var(--surface2)", borderRadius:10, marginBottom:6 }}>
              <span style={{ fontSize:20 }}>
                {link.parente==="Papa"?"👨":link.parente==="Maman"?"👩":"👤"}
              </span>
              <div style={{ flex:1 }}>
                <p style={{ fontSize:13, fontWeight:600, color:"var(--text)" }}>{link.parente}</p>
                <p style={{ fontSize:11, color:"var(--muted)" }}>{link.parent_email}</p>
              </div>
              <Chip color={link.status==="active"?"var(--green)":"var(--gold)"} style={{ fontSize:10 }}>
                {link.status==="active"?"Connecté":"En attente"}
              </Chip>
              <button onClick={() => handleRemoveParent(link.id, link.parent_email)}
                style={{ background:"none", border:"none", color:"var(--red)", cursor:"pointer", fontSize:18 }}>
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Formulaire invitation */}
      {(linkedParents.length < (user?.plan==="Famille"?2:1)) && (
        <>
          <div style={{ marginBottom:10 }}>
            <label style={{ fontSize:12, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>
              Lien de parenté
            </label>
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              {PARENTE_OPTIONS.map(p => (
                <button key={p} onClick={() => setParente(p)}
                  style={{ padding:"6px 12px", borderRadius:100, fontSize:12, fontWeight:600,
                    border:`1.5px solid ${parente===p?"var(--gold)":"var(--border)"}`,
                    background:parente===p?"var(--gold-light)":"var(--surface2)",
                    color:parente===p?"var(--gold)":"var(--text)",
                    cursor:"pointer", fontFamily:"var(--font-body)" }}>
                  {p}
                </button>
              ))}
            </div>
          </div>

          <div style={{ display:"flex", gap:8, marginBottom:10 }}>
            <input value={email} onChange={e => setEmail(e.target.value)}
              placeholder={`Email de ${parente}...`}
              style={{ flex:1, padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}
              onFocus={e => e.target.style.borderColor="var(--gold)"}
              onBlur={e => e.target.style.borderColor="var(--border)"} />
            <Btn onClick={handleInvite} color="var(--gold)" loading={loading} style={{ padding:"10px 16px", borderRadius:10, flexShrink:0 }}>
              Inviter
            </Btn>
          </div>
        </>
      )}

      {error && <p style={{ color:"var(--red)", fontSize:12, marginTop:8 }}>{error}</p>}
      {success && <p style={{ color:"var(--green)", fontSize:12, marginTop:8 }}>{success}</p>}
    </Surface>
  );
};


// ─── MESSAGES FAMILLE ─────────────────────────────────────────────────────────
const FamilyMessages = ({ user, familyLinks }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const isParent = user?.profileType === "parent" || user?.role === "parent";

  useEffect(() => {
    loadMessages();
    // Écouter les nouveaux messages en temps réel
    const channel = supabase
      .channel("family_messages")
      .on("postgres_changes", {
        event:"INSERT", schema:"public", table:"family_messages",
        filter:`recipient_id=eq.${user.id}`,
      }, () => loadMessages())
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, []);

  const loadMessages = async () => {
    try {
      const { data } = await supabase
        .from("family_messages")
        .select("*")
        .or(`sender_id.eq.${user.id},recipient_id.eq.${user.id}`)
        .order("created_at", { ascending:true })
        .limit(50);
      setMessages(data || []);
    } catch(e) {}
  };

  const handleSend = async () => {
    if (!newMessage.trim() || !familyLinks?.length) return;
    setLoading(true);
    try {
      // Envoyer à tous les membres liés
      const recipients = familyLinks.map(l => isParent ? l.child_id : l.parent_id).filter(Boolean);
      for (const recipientId of recipients) {
        await supabase.from("family_messages").insert({
          sender_id: user.id,
          sender_name: user.name,
          recipient_id: recipientId,
          content: newMessage.trim(),
          is_encouragement: true,
        });
      }
      setNewMessage("");
      loadMessages();
    } catch(e) {}
    setLoading(false);
  };

  return (
    <Surface style={{ padding:20, marginBottom:16 }}>
      <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:12 }}>
        💬 Messages famille
      </h3>

      {/* Liste messages */}
      <div style={{ maxHeight:240, overflowY:"auto", marginBottom:12 }}>
        {messages.length === 0 && (
          <p style={{ fontSize:13, color:"var(--faint)", textAlign:"center", padding:16 }}>
            Aucun message pour le moment.<br/>
            {isParent ? "Encourage ton enfant ! 💪" : "Tes parents peuvent t'envoyer des encouragements ici."}
          </p>
        )}
        {messages.map(msg => {
          const isMe = msg.sender_id === user.id;
          return (
            <div key={msg.id} style={{
              display:"flex", justifyContent:isMe?"flex-end":"flex-start",
              marginBottom:8,
            }}>
              <div style={{
                maxWidth:"80%", padding:"10px 14px", borderRadius:14,
                background:isMe?"var(--gold-light)":"var(--surface2)",
                border:`1px solid ${isMe?"var(--gold)":"var(--border)"}`,
              }}>
                {!isMe && (
                  <p style={{ fontSize:11, fontWeight:700, color:"var(--gold)", marginBottom:4 }}>
                    {msg.sender_name} 💛
                  </p>
                )}
                <p style={{ fontSize:14, color:"var(--text)", lineHeight:1.5 }}>{msg.content}</p>
                <p style={{ fontSize:10, color:"var(--faint)", marginTop:4, textAlign:"right" }}>
                  {new Date(msg.created_at).toLocaleDateString("fr-FR", { day:"numeric", month:"short", hour:"2-digit", minute:"2-digit" })}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Envoi message */}
      <div style={{ display:"flex", gap:8 }}>
        <input
          value={newMessage}
          onChange={e => setNewMessage(e.target.value)}
          onKeyDown={e => e.key==="Enter" && !e.shiftKey && handleSend()}
          placeholder={isParent ? "Envoie un encouragement... 💪" : "Réponds à ton parent..."}
          style={{ flex:1, padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}
          onFocus={e=>e.target.style.borderColor="var(--gold)"}
          onBlur={e=>e.target.style.borderColor="var(--border)"} />
        <button
          onClick={handleSend}
          disabled={!newMessage.trim() || loading}
          style={{ padding:"10px 16px", borderRadius:10, background:newMessage.trim()?"var(--gold)":"var(--border)", border:"none", color:"#fff", cursor:newMessage.trim()?"pointer":"not-allowed", fontSize:18 }}>
          {loading ? "..." : "→"}
        </button>
      </div>
    </Surface>
  );
};

// ─── ÉCRAN FAMILLE (dashboard parent/famille) ─────────────────────────────────
const FamilleScreen = ({ user, onBack }) => {
  const isParent = user?.profileType === "parent" || user?.role === "parent";
  const [children, setChildren] = useState([]);
  const [coParent, setCoParent] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteParente, setInviteParente] = useState("Maman");
  const [inviteType, setInviteType] = useState("child"); // "child" ou "coparent"
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [childData, setChildData] = useState({});
  const [childProgress, setChildProgress] = useState({});

  useEffect(() => {
    loadFamilyLinks();
  }, []);

  const loadFamilyLinks = async () => {
    try {
      if (isParent) {
        // Charger les enfants liés à ce parent
        const { data: links } = await supabase
          .from("family_links")
          .select("*")
          .eq("parent_id", user.id)
          .eq("status", "active");

        if (links?.length) {
          setChildren(links.filter(l => l.type === "child"));
          setCoParent(links.find(l => l.type === "coparent") || null);

          // Charger les données de chaque enfant
          const childIds = links.filter(l=>l.type==="child").map(l=>l.child_id);
          if (childIds.length) {
            const { data: profiles } = await supabase
              .from("profiles").select("*").in("id", childIds);
            const dataMap = {};
            (profiles||[]).forEach(p => { dataMap[p.id] = p; });
            setChildData(dataMap);
            if (profiles?.length) setSelectedChild(profiles[0]);
            const { data: progressData } = await supabase
  .from("progress")
  .select("*")
  .in("user_id", childIds);

const progressMap = {};
childIds.forEach(id => {
  const childProgress = (progressData || []).filter(p => p.user_id === id);
  const completed = childProgress.filter(p => p.completed).length;
  const totalScore = childProgress.reduce((acc, p) => acc + (p.score || 0), 0);
  const avgScore = completed > 0 ? Math.round(totalScore / completed) : 0;
  progressMap[id] = { completed, avgScore };
});
setChildProgress(progressMap);
          }
        }
      }
    } catch(e) {
      console.warn("Family load error:", e);
    }
  };

  const handleInvite = async () => {
    if (!inviteEmail.trim()) { setError("Entre un email."); return; }
    setLoading(true); setError(""); setSuccess("");
    try {
      const token = Math.random().toString(36).substring(2) + Date.now().toString(36);
      await supabase.from("family_links").insert({
        parent_id: user.id,
        parent_name: user.name,
        invite_email: inviteEmail.trim(),
        parente: inviteType === "child" ? inviteParente : (user.name === "Papa" ? "Maman" : "Papa"),
        type: inviteType,
        token,
        status: "pending",
        plan: user.plan,
      });

      await supabase.functions.invoke("send-email", {
        body: {
          type: "family_invitation",
          to: inviteEmail.trim(),
          variables: {
            inviterName: user.name,
            inviteType,
            inviteUrl: `https://app.nunya.academy/famille/${token}`,
          }
        }
      });

      setSuccess(`✅ Invitation envoyée à ${inviteEmail} !`);
      setInviteEmail("");
      loadFamilyLinks();
    } catch(e) {
      setError("Une erreur est survenue.");
    }
    setLoading(false);
  };

  const maxChildren = user?.plan === "Famille" ? 4 : 1;
  const canInviteCoParent = user?.plan === "Famille" && !coParent && isParent;

  // ── Vue Élève (non-parent) ─────────────────────────────────────────────────
  if (!isParent) {
    return (
      <div className="main-content fade">
        <div style={{ background:"var(--navy)", padding:"20px 16px", position:"sticky", top:0, zIndex:40 }}>
          <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:12 }}>← Retour</button>
          <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff" }}>
            👨‍👩‍👧 Espace famille
          </h2>
        </div>
        <div style={{ padding:16 }}>
          {/* Inviter un parent */}
          {["Premium","Famille"].includes(user?.plan) ? (
            <InviteParentSection user={user} />
          ) : (
            <Surface style={{ padding:20, marginBottom:16, background:"rgba(201,151,44,0.06)", borderColor:"var(--gold)" }}>
              <p style={{ fontSize:13, fontWeight:700, color:"var(--gold)", marginBottom:4 }}>
                👨‍👩‍👧 Inviter un parent
              </p>
              <p style={{ fontSize:12, color:"var(--muted)", marginBottom:10 }}>
                Disponible à partir du plan Premium. Ton parent pourra suivre ta progression et recevoir les alertes de Kodjo.
              </p>
              <Btn color="var(--gold)" size="sm" onClick={() => {}}>
                Upgrader vers Premium →
              </Btn>
            </Surface>
          )}
          {/* Messages famille */}
          <FamilyMessages user={user} familyLinks={[]} />
        </div>
      </div>
    );
  }

  // ── Vue Parent ─────────────────────────────────────────────────────────────
  return (
    <div className="main-content fade">
      <div style={{ background:"var(--navy)", padding:"20px 16px", position:"sticky", top:0, zIndex:40 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:12 }}>← Retour</button>
        <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff", marginBottom:4 }}>
          👨‍👩‍👧 Espace famille
        </h2>
        <p style={{ color:"rgba(255,255,255,0.5)", fontSize:12 }}>
          Plan {user?.plan} · {children.length}/{maxChildren} enfant{children.length > 1?"s":""} lié{children.length > 1?"s":""}
        </p>
      </div>

      <div style={{ padding:16 }}>

        {/* Sélecteur enfant */}
        {children.length > 1 && (
          <div style={{ display:"flex", gap:8, marginBottom:16, overflowX:"auto" }}>
            {children.map(link => {
              const child = childData[link.child_id];
              return (
                <button key={link.id}
                  onClick={() => setSelectedChild(child)}
                  style={{ flexShrink:0, padding:"8px 16px", borderRadius:100, fontSize:13, fontWeight:600,
                    border:`1.5px solid ${selectedChild?.id===child?.id?"var(--gold)":"var(--border)"}`,
                    background:selectedChild?.id===child?.id?"var(--gold-light)":"var(--surface)",
                    color:selectedChild?.id===child?.id?"var(--gold)":"var(--text)",
                    cursor:"pointer", fontFamily:"var(--font-body)" }}>
                  {child?.name || "Enfant"}
                </button>
              );
            })}
          </div>
        )}

        {/* Dashboard de l'enfant sélectionné */}
        {selectedChild && (
          <>
            <div style={{ background:"linear-gradient(135deg, var(--navy), #1A3A6B)", borderRadius:16, padding:20, marginBottom:16 }}>
              <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16 }}>
                <div style={{ width:48, height:48, borderRadius:"50%", background:"var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, fontWeight:700, color:"#fff" }}>
                  {(selectedChild.name||"?").charAt(0).toUpperCase()}
                </div>
                <div>
                  <h3 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"#fff" }}>{selectedChild.name}</h3>
                  <p style={{ color:"rgba(255,255,255,0.6)", fontSize:12 }}>{selectedChild.level} · {selectedChild.country}</p>
                </div>
                <Chip color={selectedChild.plan==="Premium"?"var(--green)":"var(--muted)"} style={{ marginLeft:"auto", fontSize:10 }}>
                  {selectedChild.plan}
                </Chip>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12 }}>
                {[
                 { label:"XP Total", value:`⚡${formatNumber(selectedChild.xp||0)}`, color:"var(--gold)" },
{ label:"Streak", value:`🔥${selectedChild.streak||0}j`, color:"#FF6B35" },
{ label:"Badges", value:`🏆${(selectedChild.badges||[]).length}`, color:"var(--blue)" },
{ label:"Leçons OK", value:`📚${childProgress[selectedChild.id]?.completed||0}`, color:"var(--green)" },
{ label:"Score moyen", value:`⭐${childProgress[selectedChild.id]?.avgScore||0}/10`, color:"var(--purple)" },
                ].map(s => (
                  <div key={s.label} style={{ background:"rgba(255,255,255,0.08)", borderRadius:10, padding:12, textAlign:"center" }}>
                    <p style={{ fontSize:16, fontWeight:700, color:s.color }}>{s.value}</p>
                    <p style={{ fontSize:10, color:"rgba(255,255,255,0.5)", marginTop:3 }}>{s.label}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Dernière activité */}
          {/* Dernière activité */}
{(() => {
  const lastActivity = selectedChild.last_activity;
  const daysSince = lastActivity ? Math.floor((Date.now() - new Date(lastActivity)) / 86400000) : 999;
  const inactive = daysSince >= 3;
  return (
    <Surface style={{ padding:16, marginBottom:16, borderColor: inactive ? "var(--red)" : "var(--border)", background: inactive ? "rgba(239,68,68,0.05)" : "var(--surface)" }}>
      <p style={{ fontSize:12, fontWeight:700, color: inactive ? "var(--red)" : "var(--muted)", textTransform:"uppercase", marginBottom:8 }}>
        {inactive ? "⚠️ INACTIVITÉ DÉTECTÉE" : "DERNIÈRE ACTIVITÉ"}
      </p>
      <p style={{ fontSize:14, color: inactive ? "var(--red)" : "var(--text)" }}>
        {lastActivity ? timeAgo(lastActivity) : "Aucune activité récente"}
      </p>
      {inactive && (
        <p style={{ fontSize:12, color:"var(--muted)", marginTop:6 }}>
          {selectedChild.name} n'a pas travaillé depuis {daysSince >= 999 ? "longtemps" : `${daysSince} jours`}. Pensez à l'encourager !
        </p>
      )}
    </Surface>
  );
})()}
          </>
        )}

        {/* Inviter enfant */}
        {children.length < maxChildren && (
          <Surface style={{ padding:20, marginBottom:16 }}>
            <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:8 }}>
              + Inviter un enfant
            </h3>
            <div style={{ display:"flex", gap:8 }}>
              <input value={inviteEmail} onChange={e => setInviteEmail(e.target.value)}
                placeholder="Email de l'enfant..."
                style={{ flex:1, padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}
                onFocus={e=>e.target.style.borderColor="var(--gold)"}
                onBlur={e=>e.target.style.borderColor="var(--border)"} />
              <Btn onClick={() => { setInviteType("child"); handleInvite(); }}
                color="var(--gold)" loading={loading} style={{ padding:"10px 16px", borderRadius:10, flexShrink:0 }}>
                Inviter
              </Btn>
            </div>
          </Surface>
        )}

        {/* Inviter co-parent */}
        {canInviteCoParent && (
          <Surface style={{ padding:20, marginBottom:16 }}>
            <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:8 }}>
              + Inviter le co-parent
            </h3>
            <p style={{ fontSize:12, color:"var(--muted)", marginBottom:12 }}>
              Il/elle pourra voir la progression de tous les enfants du foyer.
            </p>
            <div style={{ display:"flex", gap:8 }}>
              <input value={inviteEmail} onChange={e => setInviteEmail(e.target.value)}
                placeholder="Email du co-parent..."
                style={{ flex:1, padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}
                onFocus={e=>e.target.style.borderColor="var(--blue)"}
                onBlur={e=>e.target.style.borderColor="var(--border)"} />
              <Btn onClick={() => { setInviteType("coparent"); handleInvite(); }}
                color="var(--blue)" loading={loading} style={{ padding:"10px 16px", borderRadius:10, flexShrink:0 }}>
                Inviter
              </Btn>
            </div>
          </Surface>
        )}

        {coParent && (
          <Surface style={{ padding:14, marginBottom:16 }}>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <span style={{ fontSize:20 }}>👤</span>
              <div style={{ flex:1 }}>
                <p style={{ fontSize:13, fontWeight:600, color:"var(--text)" }}>Co-parent</p>
                <p style={{ fontSize:11, color:"var(--muted)" }}>{coParent.invite_email}</p>
              </div>
              <Chip color="var(--green)" style={{ fontSize:10 }}>Lié</Chip>
            </div>
          </Surface>
        )}

        {error && <p style={{ color:"var(--red)", fontSize:13, marginTop:8 }}>{error}</p>}
        {success && <p style={{ color:"var(--green)", fontSize:13, marginTop:8 }}>{success}</p>}

        {/* Messages famille */}
        <FamilyMessages user={user} familyLinks={children} />

      </div>
    </div>
  );
};

// ─── PROFIL ÉLÈVE ─────────────────────────────────────────────────────────────
const Profile = ({ user, onLogout, onNav }) => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const league = [...LEAGUES].reverse().find(l => (user?.xp || 0) >= l.minXP) || LEAGUES[0];

  const menuItems = [
    { icon:"💎", label:"Nos plans & tarifs", action:() => onNav("plans") },
    { icon:"👨‍👩‍👧", label:"Espace famille", action:() => onNav("famille") },
    { icon:"⚙️", label:"Paramètres", action:() => onNav("settings") },
  ];

  return (
    <div className="main-content fade">
      <TopBar user={user} screen="me" onNav={onNav} title="Mon profil" />

      <div style={{ padding:"16px" }}>

        {/* Carte profil */}
        <div style={{ background:`linear-gradient(135deg, var(--navy), #1A3A6B)`, borderRadius:20, padding:24, marginBottom:20, textAlign:"center" }}>
          <div style={{ width:72, height:72, borderRadius:"50%", background:"var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:30, fontWeight:700, color:"#fff", margin:"0 auto 14px", border:"3px solid rgba(255,255,255,0.2)" }}>
            {(user?.name || "E").charAt(0).toUpperCase()}
          </div>
          <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff", marginBottom:4 }}>{user?.name || "Élève"}</h2>
          <p style={{ color:"rgba(255,255,255,0.6)", fontSize:13, marginBottom:14 }}>{user?.level} · {user?.country}</p>
          <div style={{ display:"flex", justifyContent:"center", gap:20 }}>
            <div style={{ textAlign:"center" }}>
              <p style={{ fontSize:20, fontWeight:700, color:"var(--gold)" }}>⚡ {formatNumber(user?.xp || 0)}</p>
              <p style={{ fontSize:11, color:"rgba(255,255,255,0.5)" }}>XP Total</p>
            </div>
            <div style={{ width:1, background:"rgba(255,255,255,0.15)" }} />
            <div style={{ textAlign:"center" }}>
              <StreakBadge streak={user?.streak || 0} size="lg" />
              <p style={{ fontSize:11, color:"rgba(255,255,255,0.5)", marginTop:2 }}>Streak</p>
            </div>
            <div style={{ width:1, background:"rgba(255,255,255,0.15)" }} />
            <div style={{ textAlign:"center" }}>
              <p style={{ fontSize:20 }}>{league.icon}</p>
              <p style={{ fontSize:11, color:"rgba(255,255,255,0.5)" }}>{league.label}</p>
            </div>
          </div>
        </div>

        {/* Plan actuel */}
        <Surface style={{ padding:16, marginBottom:20, display:"flex", alignItems:"center", gap:14 }}>
          <div style={{ width:40, height:40, borderRadius:10, background:"var(--gold-light)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>
            {user?.plan === "Premium" ? "💎" : user?.plan === "Essentiel" ? "⭐" : user?.plan === "Famille" ? "👨‍👩‍👧" : "🎓"}
          </div>
          <div style={{ flex:1 }}>
            <p style={{ fontSize:14, fontWeight:700, color:"var(--text)" }}>Plan {user?.plan || "Gratuit"}</p>
            {user?.plan === "Gratuit" && <p style={{ fontSize:12, color:"var(--muted)" }}>Passe à Premium pour tout débloquer</p>}
          </div>
          {user?.plan === "Gratuit" && (
            <Btn color="var(--gold)" size="sm" onClick={() => onNav("upgrade")}>
              Upgrader
            </Btn>
          )}
        </Surface>

        {/* Badges */}
        {(user?.badges || []).length > 0 && (
          <div style={{ marginBottom:20 }}>
            <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:12 }}>
              MES BADGES ({(user?.badges || []).length})
            </p>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }}>
              {(user?.badges || []).map(bid => {
                const badge = BADGES.find(b => b.id === bid);
                if (!badge) return null;
                return (
                  <div key={bid} style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:12, padding:12, textAlign:"center" }}>
                    <div style={{ fontSize:24, marginBottom:6 }}>{badge.icon}</div>
                    <p style={{ fontSize:11, fontWeight:600, color:"var(--text)", lineHeight:1.3 }}>{badge.label}</p>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Spécialités si 1ère/Terminale */}
        {(user?.specialties || []).length > 0 && (
          <div style={{ marginBottom:20 }}>
            <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:12 }}>
              MES SPÉCIALITÉS
            </p>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              {(user?.specialties || []).map(sid => {
                const sp = SPECIALTIES.find(s => s.id === sid);
                if (!sp) return null;
                return (
                  <Chip key={sid} color="var(--blue)">
                    {sp.icon} {sp.label}
                  </Chip>
                );
              })}
            </div>
          </div>
        )}

        {/* Menu */}
        <div style={{ marginBottom:20 }}>
          {menuItems.map((item, i) => (
            <div key={i}>
              <div
                onClick={item.action}
                className="card-hover"
                style={{ display:"flex", alignItems:"center", gap:14, padding:"14px 16px", background:"var(--surface)", borderRadius:12, marginBottom:8, cursor:"pointer", border:"1px solid var(--border)" }}
              >
                <span style={{ fontSize:20, width:32, textAlign:"center" }}>{item.icon}</span>
                <span style={{ fontSize:15, fontWeight:500, color:"var(--text)", flex:1 }}>{item.label}</span>
                <span style={{ color:"var(--faint)", fontSize:18 }}>›</span>
              </div>
            </div>
          ))}
        </div>

        {/* Messages famille si Premium/Famille */}
        {["Premium","Famille"].includes(user?.plan) && (
          <FamilyMessages user={user} familyLinks={[]} />
        )}

        {/* Déconnexion */}
        {!showLogoutConfirm ? (
          <Btn onClick={() => setShowLogoutConfirm(true)} variant="outline" color="var(--red)" style={{ width:"100%" }}>
            Se déconnecter
          </Btn>
        ) : (
          <Surface style={{ padding:16 }}>
            <p style={{ fontSize:14, color:"var(--text)", marginBottom:14, textAlign:"center" }}>
              Tu veux vraiment te déconnecter ?
            </p>
            <div style={{ display:"flex", gap:10 }}>
              <Btn onClick={() => setShowLogoutConfirm(false)} variant="outline" color="var(--muted)" style={{ flex:1 }}>
                Annuler
              </Btn>
              <Btn onClick={onLogout} color="var(--red)" style={{ flex:1 }}>
                Déconnecter
              </Btn>
            </div>
          </Surface>
        )}
        {/* Suppression compte */}
        <div style={{ marginTop:16 }}>
          {!showDeleteConfirm ? (
            <Btn onClick={() => setShowDeleteConfirm(true)} variant="outline" color="var(--red)" style={{ width:"100%", opacity:0.7 }}>
              🗑️ Supprimer mon compte
            </Btn>
          ) : (
            <Surface style={{ padding:16, border:"1.5px solid var(--red)" }}>
              <p style={{ fontSize:14, color:"var(--red)", fontWeight:700, marginBottom:8, textAlign:"center" }}>
                ⚠️ Suppression définitive
              </p>
              <p style={{ fontSize:13, color:"var(--muted)", marginBottom:14, textAlign:"center", lineHeight:1.6 }}>
                Toutes tes données seront supprimées. Cette action est irréversible.
              </p>
              <div style={{ display:"flex", gap:10 }}>
                <Btn onClick={() => setShowDeleteConfirm(false)} variant="outline" color="var(--muted)" style={{ flex:1 }}>
                  Annuler
                </Btn>
                <Btn onClick={async () => {
                  const { error } = await supabase.functions.invoke('delete-account', {
                    body: { userId: user.id }
                  });
                  if (!error) {
                    onLogout();
                  } else {
                    alert('Erreur lors de la suppression. Contacte support@nunya.academy');
                  }
                }} color="var(--red)" style={{ flex:1 }}>
                  Supprimer
                </Btn>
              </div>
            </Surface>
          )}
        </div>

        <p style={{ textAlign:"center", fontSize:11, color:"var(--faint)", marginTop:20 }}>
          Nunya Academy · Le savoir, pour tous · v2.0
        </p>

      </div>
    </div>
  );
};

// ─── DASHBOARD PARENTS ────────────────────────────────────────────────────────
const ParentDashboard = ({ user, onBack }) => {
  const [childEmail, setChildEmail] = useState("");
  const [childData, setChildData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (user?.parent_email || user?.child_email) {
      loadChildData(user.child_email || user.email);
    }
  }, []);

  const loadChildData = async (email) => {
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await supabase.from("profiles").select("*").eq("email", email).single();
      if (data) setChildData(data);
    } catch (e) {
      console.warn("Child data load error:", e);
    }
    setLoading(false);
  };

  const linkChild = async () => {
    if (!childEmail.trim()) { setError("Entre l'email de ton enfant."); return; }
    setLoading(true);
    setError("");
    try {
      const { data: child } = await supabase.from("profiles").select("*").eq("email", childEmail.trim()).single();
      if (!child) { setError("Aucun compte trouvé avec cet email."); setLoading(false); return; }
      await supabase.from("profiles").update({ parent_email: user.email }).eq("email", childEmail.trim());
      setChildData(child);
      setSuccess(`✅ Compte de ${child.name} lié avec succès !`);
      setChildEmail("");
    } catch (e) {
      setError("Une erreur est survenue.");
    }
    setLoading(false);
  };

  const league = childData ? ([...LEAGUES].reverse().find(l => (childData.xp || 0) >= l.minXP) || LEAGUES[0]) : null;

  return (
    <div className="main-content fade">
      <div style={{ background:"var(--navy)", padding:"20px 16px 16px", position:"sticky", top:0, zIndex:40 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:12 }}>← Retour</button>
        <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff" }}>
          👨‍👩‍👧 Espace parents
        </h2>
        <p style={{ color:"rgba(255,255,255,0.5)", fontSize:12, marginTop:4 }}>
          Suivez la progression de votre enfant
        </p>
      </div>

      <div style={{ padding:"16px" }}>

        {!childData && (
          <Surface style={{ padding:20, marginBottom:20 }}>
            <h3 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"var(--text)", marginBottom:8 }}>
              Lier le compte de votre enfant
            </h3>
            <p style={{ color:"var(--muted)", fontSize:13, lineHeight:1.6, marginBottom:16 }}>
              Entrez l'adresse email avec laquelle votre enfant s'est inscrit sur Nunya Academy.
            </p>
            <div style={{ display:"flex", gap:8 }}>
              <input
                value={childEmail}
                onChange={e => setChildEmail(e.target.value)}
                placeholder="email@enfant.com"
                style={{ flex:1, padding:"12px 16px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}
                onFocus={e => e.target.style.borderColor = "var(--gold)"}
                onBlur={e => e.target.style.borderColor = "var(--border)"}
              />
              <Btn onClick={linkChild} color="var(--gold)" loading={loading} style={{ padding:"12px 20px", borderRadius:10 }}>
                Lier
              </Btn>
            </div>
            {error && <p style={{ color:"var(--red)", fontSize:13, marginTop:10 }}>{error}</p>}
            {success && <p style={{ color:"var(--green)", fontSize:13, marginTop:10 }}>{success}</p>}
          </Surface>
        )}

        {loading && !childData && (
          <>
            <SkeletonCard height={120} />
            <SkeletonCard height={80} />
          </>
        )}

        {childData && (
          <>
            {/* Profil enfant */}
            <div style={{ background:`linear-gradient(135deg, var(--navy), #1A3A6B)`, borderRadius:16, padding:20, marginBottom:16 }}>
              <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:16 }}>
                <div style={{ width:52, height:52, borderRadius:"50%", background:"var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, fontWeight:700, color:"#fff" }}>
                  {(childData.name || "E").charAt(0).toUpperCase()}
                </div>
                <div>
                  <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"#fff" }}>{childData.name}</h3>
                  <p style={{ color:"rgba(255,255,255,0.6)", fontSize:13 }}>{childData.level} · {childData.country}</p>
                </div>
                <Chip color={childData.plan==="Premium"?"var(--green)":childData.plan==="Essentiel"?"var(--gold)":"var(--muted)"} style={{ marginLeft:"auto" }}>
                  {childData.plan || "Gratuit"}
                </Chip>
              </div>

              <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12 }}>
                {[
                  { label:"XP Total", value:`⚡ ${formatNumber(childData.xp || 0)}`, color:"var(--gold)" },
                  { label:"Streak", value:`🔥 ${childData.streak || 0}j`, color:"#FF6B35" },
                  { label:"Ligue", value:`${league?.icon} ${league?.label}`, color:league?.color || "var(--gold)" },
                ].map(s => (
                  <div key={s.label} style={{ background:"rgba(255,255,255,0.08)", borderRadius:10, padding:12, textAlign:"center" }}>
                    <p style={{ fontSize:16, fontWeight:700, color:s.color }}>{s.value}</p>
                    <p style={{ fontSize:10, color:"rgba(255,255,255,0.5)", marginTop:3 }}>{s.label}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Badges */}
            {(childData.badges || []).length > 0 && (
              <Surface style={{ padding:16, marginBottom:16 }}>
                <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:12 }}>
                  Badges obtenus ({(childData.badges || []).length})
                </p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  {(childData.badges || []).map(bid => {
                    const badge = BADGES.find(b => b.id === bid);
                    if (!badge) return null;
                    return (
                      <div key={bid} style={{ display:"flex", alignItems:"center", gap:6, background:"var(--surface2)", borderRadius:100, padding:"5px 12px" }}>
                        <span style={{ fontSize:14 }}>{badge.icon}</span>
                        <span style={{ fontSize:11, fontWeight:600, color:"var(--text)" }}>{badge.label}</span>
                      </div>
                    );
                  })}
                </div>
              </Surface>
            )}

            {/* Dernière activité */}
            <Surface style={{ padding:16, marginBottom:16 }}>
              <p style={{ fontSize:12, fontWeight:700, color:"var(--muted)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>
                Dernière activité
              </p>
              <p style={{ fontSize:14, color:"var(--text)" }}>
                {childData.last_activity ? timeAgo(childData.last_activity) : "Aucune activité récente"}
              </p>
            </Surface>

            {/* Délier */}
            <Btn
              onClick={() => { setChildData(null); setChildEmail(""); }}
              variant="outline"
              color="var(--muted)"
              style={{ width:"100%", marginTop:8 }}
            >
              Délier ce compte
            </Btn>
          </>
        )}

      </div>
    </div>
  );
};

// ─── SETTINGS ─────────────────────────────────────────────────────────────────
const Settings = ({ user, onBack, onLogout, onUserUpdate, readingMode, setReadingMode }) => {
  const [notifications, setNotifications] = useState(true);
  const [saved, setSaved] = useState(false);
  const [specialties, setSpecialties] = useState(user?.specialties || []);
  const [savingSpec, setSavingSpec] = useState(false);
  const needsSpecialties = ["1ère Générale","Terminale Générale"].includes(user?.level);

  const maxSpec = ["Terminale Générale","Terminale Techno","Terminale Pro"].includes(user?.level) ? 2 : 3;
  const requiredSpec = ["Terminale Générale","Terminale Techno","Terminale Pro"].includes(user?.level) ? 2 : 3;
  const toggleSpecialty = (id) => {
    const selected = specialties.includes(id);
    if (specialties.length >= maxSpec && !selected) return;
    setSpecialties(s => selected ? s.filter(x=>x!==id) : [...s, id]);
  };

  const saveSpecialties = async () => {
    if (specialties.length !== requiredSpec) return;
    setSavingSpec(true);
    try {
      await supabase.from("profiles").update({ specialties }).eq("id", user.id);
      onUserUpdate && onUserUpdate({ ...user, specialties });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (e) {}
    setSavingSpec(false);
  };

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="main-content fade">
      <div style={{ background:"var(--navy)", padding:"20px 16px", position:"sticky", top:0, zIndex:40 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:12 }}>← Retour</button>
        <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff" }}>⚙️ Paramètres</h2>
      </div>
      <div style={{ padding:"16px" }}>

        <Surface style={{ padding:20, marginBottom:16 }}>
          <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:16 }}>Mon compte</h3>
          <div style={{ marginBottom:12 }}>
            <p style={{ fontSize:12, color:"var(--muted)", marginBottom:4 }}>Nom</p>
            <p style={{ fontSize:15, fontWeight:600, color:"var(--text)" }}>{user?.name}</p>
          </div>
          <div style={{ marginBottom:12 }}>
            <p style={{ fontSize:12, color:"var(--muted)", marginBottom:4 }}>Email</p>
            <p style={{ fontSize:15, fontWeight:600, color:"var(--text)" }}>{user?.email}</p>
          </div>
          <div style={{ marginBottom:12 }}>
            <p style={{ fontSize:12, color:"var(--muted)", marginBottom:4 }}>Classe</p>
            <p style={{ fontSize:15, fontWeight:600, color:"var(--text)" }}>{user?.level}</p>
          </div>
          <div>
            <p style={{ fontSize:12, color:"var(--muted)", marginBottom:4 }}>Pays</p>
            <p style={{ fontSize:15, fontWeight:600, color:"var(--text)" }}>{user?.country}</p>
          </div>
        </Surface>

        {needsSpecialties && (
          <Surface style={{ padding:20, marginBottom:16 }}>
            <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:6 }}>Mes spécialités</h3>
            <p style={{ fontSize:12, color:"var(--muted)", marginBottom:14 }}>
              {user?.level==="Terminale" ? `Choisis exactement 2 spécialités (${specialties.length}/2)` : `Choisis exactement 3 spécialités (${specialties.length}/3)`}
            </p>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:14 }}>
              {SPECIALTIES.map(sp => {
                const selected = specialties.includes(sp.id);
                const maxReached = specialties.length >= 3 && !selected;
                return (
                  <button key={sp.id} onClick={() => toggleSpecialty(sp.id)} disabled={maxReached}
                    style={{ padding:"10px 12px", borderRadius:10, fontSize:13, fontWeight:500, border:`1.5px solid ${selected?"var(--gold)":"var(--border)"}`, background:selected?"var(--gold-light)":"var(--surface2)", color:selected?"var(--gold)":maxReached?"var(--faint)":"var(--text)", cursor:maxReached?"not-allowed":"pointer", fontFamily:"var(--font-body)", textAlign:"left", display:"flex", alignItems:"center", gap:8, opacity:maxReached?0.5:1 }}>
                    <span>{sp.icon}</span> {sp.label}
                  </button>
                );
              })}
            </div>
            <Btn
              onClick={saveSpecialties}
              color={specialties.length === requiredSpec ? "var(--gold)" : "var(--border)"}
              loading={savingSpec}
              style={{ width:"100%", borderRadius:10, opacity: specialties.length === requiredSpec ? 1 : 0.6, cursor: specialties.length === requiredSpec ? "pointer" : "not-allowed" }}
            >
              {specialties.length === requiredSpec
                ? "Enregistrer mes spécialités ✅"
                : `Encore ${requiredSpec - specialties.length} spécialité${requiredSpec - specialties.length > 1 ? "s" : ""} à choisir`}
            </Btn>
          </Surface>
        )}

        <Surface style={{ padding:20, marginBottom:16 }}>
          <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:16 }}>Notifications</h3>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <p style={{ fontSize:14, fontWeight:500, color:"var(--text)" }}>Rappels quotidiens</p>
              <p style={{ fontSize:12, color:"var(--muted)" }}>🔥 Ne perds pas ton streak !</p>
            </div>
            <div
              onClick={() => setNotifications(n => !n)}
              style={{
                width:48, height:26, borderRadius:13,
                background: notifications ? "var(--green)" : "var(--border)",
                cursor:"pointer", position:"relative", transition:"background 0.2s",
              }}
            >
              <div style={{
                width:20, height:20, borderRadius:"50%", background:"#fff",
                position:"absolute", top:3,
                left: notifications ? 24 : 4,
                transition:"left 0.2s",
                boxShadow:"0 1px 4px rgba(0,0,0,0.2)",
              }} />
            </div>
          </div>
        </Surface>



        <Surface style={{ padding:20, marginBottom:16 }}>
          <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:8 }}>Support</h3>
          <a href="mailto:support@nunya.academy" style={{ color:"var(--gold)", fontSize:14, textDecoration:"none" }}>
            📧 support@nunya.academy
          </a>
        </Surface>

        {saved && (
          <div className="fade" style={{ background:"rgba(16,185,129,0.1)", border:"1px solid var(--green)", borderRadius:10, padding:"10px 14px", marginBottom:16, textAlign:"center" }}>
            <p style={{ fontSize:13, color:"var(--green)", fontWeight:600 }}>✅ Enregistré !</p>
          </div>
        )}



        <p style={{ textAlign:"center", fontSize:11, color:"var(--faint)", marginTop:12 }}>
          © {new Date().getFullYear()} Nunya Academy — Le savoir, pour tous.
        </p>
      </div>
    </div>
  );
};



// ─── MODAL CRÉER UN ÉLÈVE (SuperAdmin) ───────────────────────────────────────
const CreateUserModal = ({ onClose, onCreated, onSuccess }) => {
  const generatePassword = () => Math.random().toString(36).slice(-8) + Math.random().toString(36).slice(-4).toUpperCase();
const [form, setForm] = useState({ name:"", email:"", password:generatePassword(), country:"", level:"6ème", plan:"Gratuit", specialties:[] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const needsSpecialties = ["1ère Générale","Terminale Générale"].includes(form.level);

  const maxSpecialties = ["Terminale Générale"].includes(form.level) ? 2 : 3;
  const toggleSpecialty = (id) => {
    const curr = form.specialties || [];
    const selected = curr.includes(id);
    if (curr.length >= maxSpecialties && !selected) return;
    setForm(f => ({ ...f, specialties: selected ? curr.filter(s=>s!==id) : [...curr, id] }));
  };

  const handleCreate = async () => {
    setError("");
    if (!form.name || !form.email || !form.password) { setError("Prénom, email et mot de passe requis."); return; }
    if (form.password.length < 8 || !/[A-Z]/.test(form.password) || !/[0-9]/.test(form.password)) {
      setError("Mot de passe : min 8 car., 1 majuscule, 1 chiffre."); return;
    }
    setLoading(true);
    try {
      const { data: sessionData } = await supabase.auth.getSession();
      const { data, error: fnError } = await supabase.functions.invoke("Create-user", {
        body: form,
        headers: { Authorization: `Bearer ${sessionData?.session?.access_token}` },
      });
      if (fnError || data?.error) {
        setError(data?.error || fnError?.message || "Erreur lors de la création.");
        setLoading(false);
        return;
      }
      onCreated();
      onClose();
      onSuccess && onSuccess(form.name, form.email);
    } catch (e) {
      setError("Une erreur est survenue.");
    }
    setLoading(false);
  };

  return (
    <Modal onClose={onClose} title="Créer un compte" style={{ maxWidth:480 }}>
      <div style={{ marginBottom:14 }}>
        <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Prénom *</label>
        <input value={form.name} onChange={e => setForm(f => ({...f, name:e.target.value}))} placeholder="Prénom de l'élève"
          style={{ width:"100%", padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }} />
      </div>
     <div style={{ marginBottom:14 }}>
  <label htmlFor="email-field" style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Email *</label>
  <input id="email-field" type="email" value={form.email} onChange={e => setForm(f => ({...f, email:e.target.value}))} placeholder="email@exemple.com"
    style={{ width:"100%", padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }} />
</div>
     <div style={{ marginBottom:14 }}>
  <label htmlFor="temp-password" style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Mot de passe temporaire *</label>
  <div style={{ display:"flex", gap:8, alignItems:"center" }}>
    <input id="temp-password" type="text" value={form.password} onChange={e => setForm(f => ({...f, password:e.target.value}))}
      style={{ flex:1, padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }} />
    <button aria-label="Générer un nouveau mot de passe" onClick={() => setForm(f=>({...f,password:generatePassword()}))}
      style={{ padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontSize:12, cursor:"pointer", whiteSpace:"nowrap" }}>
      🔄
    </button>
  </div>
  <p style={{ fontSize:11, color:"var(--muted)", marginTop:4 }}>Transmets ce mot de passe à l'élève — il pourra le changer ensuite.</p>
</div>
      <div style={{ marginBottom:14 }}>
        <label htmlFor="country-2" style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Pays</label>
<select id="country-2" value={form.country} onChange={e => setForm(f => ({...f, country:e.target.value}))}
          style={{ width:"100%", padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}>
          <option value="">Sélectionner...</option>
          {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div style={{ marginBottom:14 }}>
        <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:8 }}>Classe *</label>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:6 }}>
          {LEVELS.map(l => (
            <button key={l} onClick={() => setForm(f => ({...f, level:l, specialties:[]}))}
              style={{ padding:"8px 4px", borderRadius:8, fontSize:11, fontWeight:600, border:`1.5px solid ${form.level===l?"var(--gold)":"var(--border)"}`, background:form.level===l?"var(--gold-light)":"var(--surface2)", color:form.level===l?"var(--gold)":"var(--text)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
              {l}
            </button>
          ))}
        </div>
      </div>
      {needsSpecialties && (
        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Spécialités ({maxSpecialties} max)</label>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:6 }}>
            {SPECIALTIES.map(sp => {
              const selected = (form.specialties||[]).includes(sp.id);
              return (
                <button key={sp.id} onClick={() => toggleSpecialty(sp.id)}
                  style={{ padding:"8px 10px", borderRadius:8, fontSize:12, fontWeight:500, border:`1.5px solid ${selected?"var(--gold)":"var(--border)"}`, background:selected?"var(--gold-light)":"var(--surface2)", color:selected?"var(--gold)":"var(--text)", cursor:"pointer", fontFamily:"var(--font-body)", textAlign:"left" }}>
                  {sp.icon} {sp.label}
                </button>
              );
            })}
          </div>
        </div>
      )}
      <div style={{ marginBottom:20 }}>
        <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:8 }}>Plan tarifaire</label>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:6 }}>
          {["Gratuit","Essentiel","Premium","Famille"].map(p => (
            <button key={p} onClick={() => setForm(f => ({...f, plan:p}))}
              style={{ padding:"10px 6px", borderRadius:8, fontSize:12, fontWeight:700, border:`1.5px solid ${form.plan===p?"var(--gold)":"var(--border)"}`, background:form.plan===p?"var(--gold-light)":"var(--surface2)", color:form.plan===p?"var(--gold)":"var(--text)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
              {p}
            </button>
          ))}
        </div>
      </div>
      {error && <p style={{ color:"var(--red)", fontSize:13, marginBottom:12, background:"rgba(239,68,68,0.08)", padding:"10px 14px", borderRadius:8 }}>{error}</p>}
      <Btn onClick={handleCreate} color="var(--gold)" size="lg" loading={loading} style={{ width:"100%", borderRadius:10 }}>
        Créer le compte 🚀
      </Btn>
    </Modal>
  );
};

// ─── MODAL GESTION UTILISATEUR (SuperAdmin) ──────────────────────────────────
const UserDetailModal = ({ user: targetUser, onClose, onSaved }) => {
  const [form, setForm] = useState({
    name: targetUser.name || "",
    level: targetUser.level || "6ème",
    country: targetUser.country || "",
    plan: targetUser.plan || "Gratuit",
    status: targetUser.status || "active",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      const { error: updErr } = await supabase
        .from("profiles")
        .update({
          name: form.name,
          level: form.level,
          country: form.country,
          plan: form.plan,
          status: form.status,
        })
        .eq("id", targetUser.id);
      if (updErr) { setError(updErr.message); setSaving(false); return; }
      onSaved();
      onClose();
    } catch (e) {
      setError("Une erreur est survenue.");
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    setSaving(true);
    try {
      await supabase.from("profiles").delete().eq("id", targetUser.id);
      onSaved();
      onClose();
    } catch (e) {
      setError("Suppression impossible.");
    }
    setSaving(false);
  };

  const STATUS_OPTIONS = [
    { id:"active",    label:"✅ Actif",     color:"var(--green)" },
    { id:"suspended", label:"⏸️ Suspendu",  color:"var(--gold)" },
    { id:"banned",    label:"🚫 Banni",     color:"var(--red)" },
  ];

  return (
    <Modal onClose={onClose} title="Gestion de l'élève" style={{ maxWidth:480 }}>
      <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:20 }}>
        <div style={{ width:48, height:48, borderRadius:"50%", background:"var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, fontWeight:700, color:"#fff" }}>
          {(form.name || "?").charAt(0).toUpperCase()}
        </div>
        <div>
          <p style={{ fontSize:11, color:"var(--muted)" }}>ID: {targetUser.id?.substring(0,8)}...</p>
          <p style={{ fontSize:11, color:"var(--muted)" }}>⚡ {targetUser.xp || 0} XP · 🔥 {targetUser.streak || 0}j</p>
        </div>
      </div>

      {/* Nom */}
      <div style={{ marginBottom:14 }}>
        <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Nom</label>
        <input value={form.name} onChange={e => setForm(f => ({...f, name:e.target.value}))}
          style={{ width:"100%", padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }} />
      </div>

      {/* Classe */}
      <div style={{ marginBottom:14 }}>
        <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Classe</label>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:6 }}>
          {LEVELS.map(l => (
            <button key={l} onClick={() => setForm(f => ({...f, level:l}))}
              style={{ padding:"8px 4px", borderRadius:8, fontSize:11, fontWeight:600, border:`1.5px solid ${form.level===l?"var(--gold)":"var(--border)"}`, background:form.level===l?"var(--gold-light)":"var(--surface2)", color:form.level===l?"var(--gold)":"var(--text)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
              {l}
            </button>
          ))}
        </div>
      </div>

      {/* Pays */}
      <div style={{ marginBottom:14 }}>
        <label htmlFor="country-3" style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Pays</label>
<select id="country-3" value={form.country} onChange={e => setForm(f => ({...f, country:e.target.value}))}
          style={{ width:"100%", padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none" }}>
        </select>
      </div>

      {/* Plan */}
      <div style={{ marginBottom:14 }}>
        <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Plan tarifaire</label>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:6 }}>
          {["Gratuit","Essentiel","Premium","Famille"].map(p => (
            <button key={p} onClick={() => setForm(f => ({...f, plan:p}))}
              style={{ padding:"10px 6px", borderRadius:8, fontSize:12, fontWeight:700, border:`1.5px solid ${form.plan===p?"var(--gold)":"var(--border)"}`, background:form.plan===p?"var(--gold-light)":"var(--surface2)", color:form.plan===p?"var(--gold)":"var(--text)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
              {p}
            </button>
          ))}
        </div>
      </div>

      {/* Statut */}
      <div style={{ marginBottom:20 }}>
        <label style={{ fontSize:13, fontWeight:600, color:"var(--text)", display:"block", marginBottom:6 }}>Statut du compte</label>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:6 }}>
          {STATUS_OPTIONS.map(s => (
            <button key={s.id} onClick={() => setForm(f => ({...f, status:s.id}))}
              style={{ padding:"10px 6px", borderRadius:8, fontSize:12, fontWeight:700, border:`1.5px solid ${form.status===s.id?s.color:"var(--border)"}`, background:form.status===s.id?`${s.color}15`:"var(--surface2)", color:form.status===s.id?s.color:"var(--text)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
              {s.label}
            </button>
          ))}
        </div>
        {form.status !== "active" && (
          <p style={{ fontSize:11, color:"var(--gold)", marginTop:6 }}>
            ⚠️ {form.status==="suspended" ? "L'élève ne pourra plus se connecter (temporaire)." : "L'élève ne pourra plus jamais se connecter."}
          </p>
        )}
      </div>

      {error && <p style={{ color:"var(--red)", fontSize:13, marginBottom:12, background:"rgba(239,68,68,0.08)", padding:"10px 14px", borderRadius:8 }}>{error}</p>}

      {/* Actions */}
      {!showDeleteConfirm ? (
        <>
          <Btn onClick={handleSave} color="var(--gold)" size="lg" loading={saving} style={{ width:"100%", borderRadius:10, marginBottom:10 }}>
            Enregistrer les modifications
          </Btn>
          <Btn onClick={() => setShowDeleteConfirm(true)} variant="outline" color="var(--red)" style={{ width:"100%", borderRadius:10 }}>
            🗑️ Supprimer ce compte définitivement
          </Btn>
        </>
      ) : (
        <Surface style={{ padding:16, background:"rgba(239,68,68,0.06)", borderColor:"var(--red)" }}>
          <p style={{ fontSize:14, color:"var(--text)", marginBottom:14, textAlign:"center" }}>
            Supprimer définitivement <strong>{form.name}</strong> ? Cette action est irréversible.
          </p>
          <div style={{ display:"flex", gap:10 }}>
            <Btn onClick={() => setShowDeleteConfirm(false)} variant="outline" color="var(--muted)" style={{ flex:1 }}>Annuler</Btn>
            <Btn onClick={handleDelete} color="var(--red)" loading={saving} style={{ flex:1 }}>Supprimer</Btn>
          </div>
        </Surface>
      )}
    </Modal>
  );
};

// ─── SUPER ADMIN ──────────────────────────────────────────────────────────────
const ContentStats = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await supabase.rpc('content_stats') || 
          await supabase.from('chapters').select(`
            levels(name),
            lessons(id)
          `);
        
        // Requête directe
        const levels = ["6ème","5ème","4ème","3ème","2nde","1ère Générale","Terminale Générale"];
        const results = await Promise.all(levels.map(async (levelName) => {
          const { data: lvl } = await supabase.from("levels").select("id").eq("name", levelName).single();
          if (!lvl) return { level: levelName, chapitres: 0, lecons: 0, vides: 0 };
          
          const { data: chaps } = await supabase
            .from("chapters")
            .select("id, lessons(id, content)")
            .eq("level_id", lvl.id);
          
          const chapitres = chaps?.length || 0;
          const lecons = chaps?.reduce((acc, ch) => acc + (ch.lessons?.length || 0), 0) || 0;
          const vides = chaps?.reduce((acc, ch) => 
            acc + (ch.lessons?.filter(l => !l.content || l.content === "...").length || 0), 0) || 0;
          const attendues = chapitres * 3;
          const manquantes = attendues - lecons;

          return { level: levelName, chapitres, lecons, attendues, manquantes, vides };
        }));
        setStats(results);
      } catch(e) {
        console.warn(e);
      }
      setLoading(false);
    };
    load();
  }, []);

  const getStatus = (s) => {
    if (s.lecons === 0) return { label:"🚧 Vide", color:"var(--red)" };
    if (s.manquantes === 0 && s.vides === 0) return { label:"✅ Complet", color:"var(--green)" };
    if (s.manquantes > 0) return { label:`⚠️ ${s.manquantes} leçons manquantes`, color:"var(--gold)" };
    return { label:"✅ Complet", color:"var(--green)" };
  };

  return (
    <Surface style={{ padding:20 }}>
      <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:4 }}>
        📊 État du contenu — temps réel
      </h3>
      <p style={{ fontSize:11, color:"var(--muted)", marginBottom:16 }}>
        Chargé depuis Supabase à chaque visite
      </p>
      {loading ? (
        <><SkeletonCard height={40}/><SkeletonCard height={40}/><SkeletonCard height={40}/></>
      ) : (
        stats.map(s => {
          const status = getStatus(s);
          return (
            <div key={s.level} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 0", borderBottom:"1px solid var(--border2)" }}>
              <div>
                <span style={{ fontSize:14, fontWeight:600, color:"var(--text)" }}>{s.level}</span>
                <span style={{ fontSize:11, color:"var(--muted)", marginLeft:10 }}>
                  {s.chapitres} chapitres · {s.lecons}/{s.attendues} leçons
                </span>
              </div>
              <span style={{ fontSize:12, fontWeight:700, color:status.color }}>{status.label}</span>
            </div>
          );
        })
      )}
    </Surface>
  );
};
const MFASetup = () => {
  const [qr, setQr] = useState(null);
  const [code, setCode] = useState("");
  const [factorId, setFactorId] = useState(null);
  const [enrolled, setEnrolled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const startEnroll = async () => {
    setLoading(true); setError("");
    const { data, error } = await supabase.auth.mfa.enroll({ factorType: "totp", friendlyName: "Nunya SuperAdmin" });
    if (error) { setError(error.message); setLoading(false); return; }
    setQr(data.totp.qr_code);
    setFactorId(data.id);
    setLoading(false);
  };

  const verifyEnroll = async () => {
    if (!code || code.length !== 6) { setError("Entre le code à 6 chiffres."); return; }
    setLoading(true); setError("");
    const { error } = await supabase.auth.mfa.challengeAndVerify({ factorId, code });
    if (error) { setError("Code incorrect. Réessaie."); setLoading(false); return; }
    setEnrolled(true); setQr(null); setSuccess("2FA activé avec succès ✅");
    setLoading(false);
  };

  if (enrolled || success) return (
    <p style={{ color:"var(--green)", fontSize:13, fontWeight:600 }}>✅ Double authentification activée</p>
  );

  return (
    <div>
      {!qr ? (
        <Btn onClick={startEnroll} color="var(--navy)" loading={loading} style={{ width:"100%" }}>
          Configurer Google Authenticator
        </Btn>
      ) : (
        <div>
          <p style={{ fontSize:12, color:"var(--muted)", marginBottom:12 }}>
            Scannez ce QR code avec Google Authenticator puis entrez le code à 6 chiffres :
          </p>
          <img src={qr} alt="QR Code 2FA" style={{ width:180, height:180, display:"block", margin:"0 auto 16px", borderRadius:8 }} />
          <input
            value={code}
            onChange={e => setCode(e.target.value.replace(/\D/g,"").slice(0,6))}
            placeholder="Code à 6 chiffres"
            style={{ width:"100%", padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontSize:16, textAlign:"center", letterSpacing:8, outline:"none", marginBottom:12 }}
          />
          {error && <p style={{ color:"var(--red)", fontSize:12, marginBottom:8 }}>{error}</p>}
          <Btn onClick={verifyEnroll} color="var(--green)" loading={loading} style={{ width:"100%" }}>
            Vérifier et activer
          </Btn>
        </div>
      )}
    </div>
  );
};
const SuperAdmin = ({ user, onLogout, onPreview, onImpersonate, currentLevelId, setCurrentLevelId, levels }) => {
  const [tab, setTab] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [stats, setStats] = useState({ total:0, premium:0, essential:0, free:0, revenue:0 });
  const [stripeRevenue, setStripeRevenue] = useState(null);

useEffect(() => {
  supabase.functions.invoke('stripe-revenue')
    .then(({ data }) => {
      if (data?.totalEur) setStripeRevenue(data.totalEur);
    })
    .catch(e => console.log('Stripe revenue error:', e));
}, []);
  const [users, setUsers] = useState([]);
  const [loadingStats, setLoadingStats] = useState(true);
  const [selectedUserDetail, setSelectedUserDetail] = useState(null);
  const [userSearch, setUserSearch] = useState("");
  const [showCreateUser, setShowCreateUser] = useState(false);
  const [genForm, setGenForm] = useState({ matiere:"Mathématiques", niveau:"6ème", chapitre:"Nombres entiers naturels", numLecon:"1", chapterId:"1373" });
  const [genResult, setGenResult] = useState(null);
  const [genError, setGenError] = useState("");
  const [genLoading, setGenLoading] = useState(false);
  const [genInserting, setGenInserting] = useState(false);
  const genererLecon = async () => {
    setGenLoading(true);
    setGenError("");
    setGenResult(null);
    try {
      const { data, error } = await supabase.functions.invoke("generate-lesson", {
        body: {
          matiere: genForm.matiere,
          niveau: genForm.niveau,
          chapitre: genForm.chapitre,
          numLecon: parseInt(genForm.numLecon),
        },
      });
      if (error || data?.error) {
        setGenError(data?.error || error?.message || "Erreur de génération");
      } else {
        setGenResult(data.lesson);
      }
    } catch (e) {
      setGenError(e.message);
    }
    setGenLoading(false);
  };
  const insererLecon = async () => {
    if (!genResult) return;
    setGenInserting(true);
    try {
      const titre = genResult?.meta?.titre || `${genForm.chapitre} — Leçon ${genForm.numLecon}`;
      const { error } = await supabase.from("lessons").insert({
        chapter_id: parseInt(genForm.chapterId),
        title: titre,
        content: JSON.stringify(genResult),
        order_num: parseInt(genForm.numLecon),
      });
      if (error) {
        setGenError("Erreur insertion : " + error.message);
      } else {
        setGenError("");
        alert("✅ Leçon insérée en base avec succès !");
        setGenResult(null);
      }
    } catch (e) {
      setGenError(e.message);
    }
    setGenInserting(false);
  };
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const tabs = [
    { id:"dashboard", icon:"📊", label:"Tableau de bord" },
    { id:"users",     icon:"👥", label:"Utilisateurs" },
    { id:"content",   icon:"📚", label:"Contenu" },
    { id:"finance",   icon:"💰", label:"Finances" },
    { id:"settings",  icon:"⚙️", label:"Paramètres" },
  ];

  const loadStats = async () => {
    setLoadingStats(true);
    try {
      const { data } = await supabase.from("profiles").select("*").order("created_at", { ascending:false });
      if (data) {
        const premium = data.filter(p => p.plan === "Premium" && !p.is_admin_created).length;
        const essential = data.filter(p => p.plan === "Essentiel" && !p.is_admin_created).length;
        const famille = data.filter(p => p.plan === "Famille" && !p.is_admin_created).length;
        setStats({
          total: data.filter(p => !p.is_admin_created).length,
          premium, essential, famille,
          free: data.filter(p => (p.plan === "Gratuit" || !p.plan) && !p.is_admin_created).length,
          revenue: data.filter(p => !p.is_admin_created && p.plan === "Premium").length * 3499 + 
         data.filter(p => !p.is_admin_created && p.plan === "Essentiel").length * 1999 + 
         data.filter(p => !p.is_admin_created && p.plan === "Famille").length * 6499,
        });
        const { data: authData } = await supabase.rpc('get_users_last_signin');
const authMap = {};
(authData || []).forEach(u => { authMap[u.id] = { last_sign_in_at: u.last_sign_in_at, email: u.email }; });
const enrichedUsers = data.map(p => ({ ...p, email: authMap[p.id]?.email || "", last_sign_in_at: authMap[p.id]?.last_sign_in_at || null }));
setUsers(enrichedUsers);
      }
    } catch (e) {
      console.warn("Stats load error:", e);
    }
    setLoadingStats(false);
  };

  useEffect(() => { loadStats(); }, []);

  const StatCard = ({ label, value, icon, color = "var(--gold)" }) => (
    <Surface style={{ padding:16, textAlign:"center" }}>
      <div style={{ fontSize:24, marginBottom:8 }}>{icon}</div>
      <p style={{ fontFamily:"var(--font-display)", fontSize:24, fontWeight:700, color }}>{value}</p>
      <p style={{ fontSize:12, color:"var(--muted)", marginTop:4 }}>{label}</p>
    </Surface>
  );

  return (
    <div style={{ display:"flex", height:"100vh", overflow:"hidden", background:"var(--bg)", position:"relative" }}>

      {/* Overlay mobile */}
      {isMobile && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:40 }}
        />
      )}

      {/* Sidebar */}
      <div style={{
        width:220, background:"var(--surface)", borderRight:"1px solid var(--border)",
        display:"flex", flexDirection:"column", flexShrink:0,
        position: isMobile ? "fixed" : "relative",
        left: isMobile ? (sidebarOpen ? "0" : "-220px") : "0",
        top:0, height:"100vh", zIndex:50,
        transition:"left 0.3s ease",
      }}>
        <div style={{ padding:"20px 16px", borderBottom:"1px solid var(--border)" }}>
          <p style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"var(--text)", marginBottom:12 }}>
            Administration
          </p>
          <div style={{ background:"rgba(201,151,44,0.1)", border:"1px solid rgba(201,151,44,0.2)", borderRadius:8, padding:"6px 10px", display:"flex", alignItems:"center", gap:6 }}>
            <div style={{ width:7, height:7, borderRadius:"50%", background:"var(--gold)", flexShrink:0 }} />
            <span style={{ fontSize:11, color:"var(--gold)", fontWeight:600 }}>
              {user?.role === "superadmin" ? "Super Admin" : "Admin"}
            </span>
          </div>
        </div>

        <nav style={{ flex:1, padding:"8px 0", overflow:"auto" }}>
          {tabs.map(t => (
            <button
              key={t.id}
              onClick={() => { setTab(t.id); if (isMobile) setSidebarOpen(false); }}
              style={{
                width:"100%", padding:"12px 16px", border:"none", textAlign:"left",
                background: tab===t.id ? "var(--gold-light)" : "transparent",
                color: tab===t.id ? "var(--gold)" : "var(--muted)",
                borderLeft:`3px solid ${tab===t.id?"var(--gold)":"transparent"}`,
                cursor:"pointer", fontFamily:"var(--font-body)", fontSize:14, fontWeight:tab===t.id?700:500,
                display:"flex", alignItems:"center", gap:10,
              }}
            >
              <span>{t.icon}</span> {t.label}
            </button>
          ))}
        </nav>

        <div style={{ padding:"12px 16px", borderTop:"1px solid var(--border)" }}>
          <Btn onClick={onLogout} variant="outline" color="var(--red)" style={{ width:"100%", fontSize:12 }}>
            Déconnexion
          </Btn>
        </div>
      </div>

      {/* Main */}
      <div style={{ flex:1, overflow:"auto" }}>

        {/* Mobile topbar */}
        <div style={{ padding:"12px 16px", borderBottom:"1px solid var(--border)", display:"flex", alignItems:"center", gap:12, background:"var(--surface)", position:"sticky", top:0, zIndex:30 }}>
          {isMobile && (
            <button onClick={() => setSidebarOpen(true)} style={{ background:"none", border:"none", fontSize:22, cursor:"pointer", color:"var(--text)", padding:4 }}>
              ☰
            </button>
          )}
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <span style={{ fontSize:16 }}>{tabs.find(t => t.id === tab)?.icon}</span>
            <h2 style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"var(--text)" }}>
              {tabs.find(t => t.id === tab)?.label}
            </h2>
          </div>
          <div style={{ marginLeft:"auto" }}>
            <Chip color="var(--green)">🟢 En ligne</Chip>
          </div>
        </div>

        <div style={{ padding:"20px" }}>

          {/* DASHBOARD */}
          {tab === "dashboard" && (
            <div className="fade">
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:12, marginBottom:24 }}>
                <StatCard label="Inscrits" value={stats.total} icon="👥" color="var(--blue)" />
                <StatCard label="Premium" value={stats.premium} icon="💎" color="var(--gold)" />
                <StatCard label="Essentiel" value={stats.essential} icon="⭐" color="var(--green)" />
                <StatCard label="Famille" value={stats.famille || 0} icon="👨‍👩‍👧" color="var(--purple)" />
                <StatCard label="Gratuit" value={stats.free} icon="🎓" color="var(--muted)" />
                <StatCard label="Revenus FCFA" value={`${formatNumber(stats.revenue)}`} icon="💰" color="var(--green)" />
              </div>

              {/* Preview mode */}
              <Surface style={{ padding:20, marginBottom:20 }}>
                <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:12 }}>
                  🔍 Mode prévisualisation
                </h3>
                <p style={{ fontSize:13, color:"var(--muted)", marginBottom:12 }}>
                  Navigue dans l'app comme un élève pour vérifier le contenu.
                </p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:12 }}>
                  {LEVELS.map(levelName => levels.find(l => l.name === levelName)).filter(Boolean).map(l => (
                    <button
                      key={l.id}
                      onClick={() => setCurrentLevelId(l.id)}
                      style={{
                        padding:"6px 14px", borderRadius:100, fontSize:12, fontWeight:600,
                        border:`1.5px solid ${currentLevelId===l.id?"var(--gold)":"var(--border)"}`,
                        background: currentLevelId===l.id?"var(--gold-light)":"transparent",
                        color: currentLevelId===l.id?"var(--gold)":"var(--muted)",
                        cursor:"pointer", fontFamily:"var(--font-body)",
                      }}
                    >
                      {l.name}
                    </button>
                  ))}
                </div>
                <Btn onClick={onPreview} color="var(--navy)" style={{ width:"100%" }}>
                  Prévisualiser l'app élève →
                </Btn>
              </Surface>
            </div>
          )}

          {/* USERS */}
          {tab === "users" && (
            <div className="fade">
              {selectedUserDetail && (
                <UserDetailModal
                  user={selectedUserDetail}
                  onClose={() => setSelectedUserDetail(null)}
                  onSaved={loadStats}
                />
              )}
              {showCreateUser && (
                <CreateUserModal
                  onClose={() => setShowCreateUser(false)}
                  onCreated={loadStats}
                  onSuccess={(name, email) => alert(`✅ Compte créé pour ${name} !\n📧 Email avec identifiants envoyé à ${email}`)}
                />
              )}

              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12, flexWrap:"wrap", gap:8 }}>
                <p style={{ fontSize:13, color:"var(--muted)" }}>
                  {stats.total} utilisateurs · {users.filter(u=>u.plan!=="Gratuit"&&u.plan).length} abonnés actifs
                </p>
                <Btn onClick={() => setShowCreateUser(true)} color="var(--gold)" size="sm">
                  + Créer un compte
                </Btn>
              </div>

             <input
                aria-label="Rechercher un utilisateur par nom ou pays"
                value={userSearch}
                onChange={e => setUserSearch(e.target.value)}
                placeholder="🔍 Rechercher par nom ou pays..."
                style={{ width:"100%", padding:"10px 14px", borderRadius:10, border:"1.5px solid var(--border)", background:"var(--surface)", color:"var(--text)", fontFamily:"var(--font-body)", fontSize:14, outline:"none", marginBottom:14 }}
              />

              {users
                .filter(u => !userSearch || (u.name||"").toLowerCase().includes(userSearch.toLowerCase()) || (u.country||"").toLowerCase().includes(userSearch.toLowerCase()))
                .map((u, i) => (
                <Surface
                  key={u.id || i}
                  onClick={() => setSelectedUserDetail(u)}
                  className="card-hover"
                  style={{ padding:14, marginBottom:8, display:"flex", alignItems:"center", gap:12, cursor:"pointer" }}
                >
                  <div style={{ width:36, height:36, borderRadius:"50%", background: u.status==="banned" ? "var(--red)" : u.status==="suspended" ? "var(--gold)" : "var(--gold)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:700, color:"#fff", flexShrink:0, opacity: u.status&&u.status!=="active" ? 0.5 : 1 }}>
                    {(u.name || "?").charAt(0).toUpperCase()}
                  </div>
                  <div style={{ flex:1 }}>
                    <p style={{ fontSize:14, fontWeight:600, color:"var(--text)", display:"flex", alignItems:"center", gap:6 }}>
                      {u.name || "Élève"}
                      {u.status === "suspended" && <span style={{ fontSize:10 }}>⏸️</span>}
                      {u.status === "banned" && <span style={{ fontSize:10 }}>🚫</span>}
                    </p>
                    <p style={{ fontSize:11, color:"var(--muted)" }}>
                      {u.country} · {u.level} · ⚡{formatNumber(u.xp||0)} · 🔥{u.streak||0}j · {u.last_sign_in_at ? timeAgo(u.last_sign_in_at) : "jamais connecté"}
                    </p>
                  </div>
                  <Chip color={u.plan==="Premium"?"var(--green)":u.plan==="Essentiel"?"var(--gold)":"var(--muted)"} style={{ fontSize:10 }}>
                    {u.plan || "Gratuit"}
                  </Chip>
                  <button
  onClick={(e) => {
    e.stopPropagation();
    onImpersonate(u);
  }}
  style={{ background:"var(--navy)", border:"none", borderRadius:8, padding:"6px 10px", fontSize:11, color:"#fff", cursor:"pointer", fontWeight:600, marginRight:4 }}
>
  👤
</button>
<span style={{ color:"var(--faint)", fontSize:16 }}>›</span>
                </Surface>
              ))}

              {users.length === 0 && (
                <EmptyState icon="👥" title="Aucun utilisateur" message="Les nouveaux inscrits apparaîtront ici." />
              )}
            </div>
          )}

        {/* CONTENT */}
{tab === "content" && (
  <div className="fade">
    <Surface style={{ padding:20, marginBottom:16 }}>
      <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:12 }}>🤖 Générateur de leçons</h3>
      <p style={{ fontSize:12, color:"var(--muted)", marginBottom:16 }}>Format JSON v2.0 — via Claude Sonnet</p>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
        <div>
          <label style={{ fontSize:12, fontWeight:600, color:"var(--text)", display:"block", marginBottom:4 }}>Matière</label>
          <input value={genForm.matiere} onChange={e=>setGenForm(f=>({...f,matiere:e.target.value}))}
            style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontSize:13 }} />
        </div>
        <div>
          <label style={{ fontSize:12, fontWeight:600, color:"var(--text)", display:"block", marginBottom:4 }}>Niveau</label>
          <input value={genForm.niveau} onChange={e=>setGenForm(f=>({...f,niveau:e.target.value}))}
            style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontSize:13 }} />
        </div>
        <div style={{ gridColumn:"1 / -1" }}>
          <label style={{ fontSize:12, fontWeight:600, color:"var(--text)", display:"block", marginBottom:4 }}>Chapitre</label>
          <input value={genForm.chapitre} onChange={e=>setGenForm(f=>({...f,chapitre:e.target.value}))}
            style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontSize:13 }} />
        </div>
<div>
  <label htmlFor="num-lecon" style={{ fontSize:12, fontWeight:600, color:"var(--text)", display:"block", marginBottom:4 }}>N° leçon</label>
  <input id="num-lecon" type="number" value={genForm.numLecon} onChange={e=>setGenForm(f=>({...f,numLecon:e.target.value}))}
    style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontSize:13 }} />
</div>
<div>
  <label htmlFor="chapter-id" style={{ fontSize:12, fontWeight:600, color:"var(--text)", display:"block", marginBottom:4 }}>Chapter ID</label>
  <input id="chapter-id" type="number" value={genForm.chapterId} onChange={e=>setGenForm(f=>({...f,chapterId:e.target.value}))}
    style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1.5px solid var(--border)", background:"var(--surface2)", color:"var(--text)", fontSize:13 }} />
</div>
      </div>
      <Btn onClick={genererLecon} color="var(--gold)" loading={genLoading} style={{ width:"100%", marginBottom:12 }}>
        Générer la leçon
      </Btn>
      {genError && <p style={{ color:"var(--red)", fontSize:13, marginBottom:12 }}>{genError}</p>}
      {genResult && (
        <>
          <pre style={{ background:"var(--surface2)", border:"1px solid var(--border)", borderRadius:8, padding:12, fontSize:11, overflow:"auto", maxHeight:300, color:"var(--text)", whiteSpace:"pre-wrap" }}>
            {JSON.stringify(genResult, null, 2)}
          </pre>
          <Btn onClick={insererLecon} color="var(--green)" loading={genInserting} style={{ width:"100%", marginTop:12 }}>
            ✅ Insérer cette leçon en base
          </Btn>
        </>
      )}
    </Surface>
    <ContentStats />
  </div>
)}
          {/* FINANCE */}
          {tab === "finance" && (
            <div className="fade">
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:20 }}>
                <StatCard label="Revenus FCFA" value={formatNumber(stats.revenue)} icon="💰" color="var(--green)" />
                <StatCard label="Revenus EUR (Stripe)" value={stripeRevenue !== null ? `${stripeRevenue.toFixed(2)}€` : `${(stats.revenue/655.957).toFixed(2)}€`} icon="💶" color="var(--blue)" />
              </div>
              <Surface style={{ padding:20 }}>
                <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:12 }}>Répartition des plans</h3>
                {[
                  { plan:"Premium",   count:stats.premium,   price:3499, color:"var(--gold)" },
                  { plan:"Essentiel", count:stats.essential, price:1999, color:"var(--blue)" },
                  { plan:"Famille",   count:stats.famille||0,price:6499, color:"var(--purple)" },
                  { plan:"Gratuit",   count:stats.free,      price:0,    color:"var(--muted)" },
                ].map(item => (
                  <div key={item.plan} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:"1px solid var(--border2)" }}>
                    <div>
                      <span style={{ fontSize:14, fontWeight:600, color:"var(--text)" }}>{item.plan}</span>
                      <span style={{ fontSize:12, color:"var(--muted)", marginLeft:8 }}>{item.count} utilisateurs</span>
                    </div>
                    <span style={{ fontSize:13, fontWeight:700, color:item.color }}>
                      {item.price > 0 ? `${formatNumber(item.count * item.price)} FCFA / ${(item.count * item.price / 655.957).toFixed(2)}€` : "Gratuit"}
                    </span>
                  </div>
                ))}
              </Surface>
            </div>
          )}

          {/* SETTINGS ADMIN */}
          {tab === "settings" && (
            <div className="fade">
              <Surface style={{ padding:20 }}>
                <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:16 }}>Informations système</h3>
                {[
                  { label:"Supabase", value:"syfckweucwdpfgtpymeg ✅" },
                  { label:"Email (Resend)", value:"nunya.academy ✅" },
                  { label:"SSL", value:"Cloudflare Full (strict) ✅" },
                  { label:"RLS", value:"10/10 tables ✅" },
                  { label:"PWA", value:"Activée ✅" },
                  { label:"SEO", value:"Google Search Console ✅" },
                  { label:"Version", value:"Nunya v2.0" },
                ].map(item => (
                  <div key={item.label} style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid var(--border2)" }}>
                    <span style={{ fontSize:13, color:"var(--muted)" }}>{item.label}</span>
                    <span style={{ fontSize:13, fontWeight:600, color:"var(--text)" }}>{item.value}</span>
                  </div>
                ))}
              </Surface>
              <Surface style={{ padding:20, marginTop:16 }}>
  <h3 style={{ fontSize:15, fontWeight:700, color:"var(--text)", marginBottom:8 }}>🔐 Double authentification (2FA)</h3>
  <p style={{ fontSize:12, color:"var(--muted)", marginBottom:16 }}>Protégez votre compte SuperAdmin avec Google Authenticator.</p>
  <MFASetup />
</Surface>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};


// ─── ÉCRAN PLANS / TARIFS ─────────────────────────────────────────────────────
const PlansScreen = ({ user, onBack }) => {
  const [currency, setCurrency] = useState("usd");

  const CURRENCIES = [
    { id:"fcfa", label:"FCFA", symbol:"FCFA" },
    { id:"eur",  label:"€ EUR", symbol:"€" },
    { id:"usd",  label:"$ USD", symbol:"$" },
    { id:"gbp",  label:"£ GBP", symbol:"£" },
    { id:"cad",  label:"CA$",   symbol:"CA$" },
    { id:"cny",  label:"¥ CNY", symbol:"¥" },
    { id:"aed",  label:"AED",   symbol:"د.إ" },
  ];

  const planList = [
    {
      id:"Gratuit", icon:"🎓", color:"var(--muted)",
      desc:"Pour découvrir Nunya sans engagement.",
      features:["3 chapitres par matière","Cours complets","Tuteur Kodjo (limité)"],
      locked:["Exercices corrigés","Compétitions","Annales"],
    },
    {
      id:"Essentiel", icon:"⭐", color:"var(--blue)", popular:false,
      desc:"Accès complet aux cours et exercices.",
      features:["Tous les chapitres","Exercices corrigés","Tuteur Kodjo illimité","Suivi de progression"],
      locked:["Compétitions mondiales"],
    },
    {
      id:"Premium", icon:"💎", color:"var(--gold)", popular:true,
      desc:"L'expérience complète pour exceller.",
      features:["Tout Essentiel","Compétitions mondiales","Classement mondial","Annales DNB & Bac","Défis quotidiens"],
      locked:[],
    },
    {
      id:"Famille", icon:"👨‍👩‍👧", color:"var(--purple)",
      desc:"Jusqu'à 4 enfants + dashboard parents.",
      features:["Tout Premium","Jusqu'à 4 enfants","Dashboard parents","Rapports hebdomadaires","Support prioritaire"],
      locked:[],
    },
  ];

  const getPrice = (planId) => {
    const p = PLANS[planId];
    if (!p) return "0";
    const cur = CURRENCIES.find(c => c.id === currency);
    const val = p[currency];
    if (val === 0 || val === "0") return "Gratuit";
    return `${cur?.symbol} ${val}`;
  };

  return (
    <div className="main-content fade">
      <div style={{ background:"var(--navy)", padding:"20px 16px", position:"sticky", top:0, zIndex:40 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:14, cursor:"pointer", marginBottom:12 }}>← Retour</button>
        <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"#fff", marginBottom:4 }}>
          Nos plans
        </h2>
        {/* Switcher devise */}
        <div style={{ display:"flex", gap:6, overflowX:"auto", paddingBottom:4, marginTop:12 }}>
          {CURRENCIES.map(c => (
            <button
              key={c.id}
              onClick={() => setCurrency(c.id)}
              style={{
                flexShrink:0, padding:"5px 12px", borderRadius:100, fontSize:11, fontWeight:700,
                border:`1.5px solid ${currency===c.id?"var(--gold)":"rgba(255,255,255,0.2)"}`,
                background: currency===c.id?"rgba(201,151,44,0.2)":"transparent",
                color: currency===c.id?"var(--gold)":"rgba(255,255,255,0.6)",
                cursor:"pointer", fontFamily:"var(--font-body)",
              }}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding:"16px" }}>
        {planList.map(plan => {
          const isCurrentPlan = user?.plan === plan.id;
          return (
            <div
              key={plan.id}
              style={{
                background:"var(--surface)",
                border:`2px solid ${isCurrentPlan?"var(--gold)":plan.popular?"var(--blue)":"var(--border)"}`,
                borderRadius:16, padding:20, marginBottom:14, position:"relative",
              }}
            >
              {plan.popular && (
                <div style={{ position:"absolute", top:-10, right:16, background:"var(--blue)", color:"#fff", fontSize:10, fontWeight:700, padding:"3px 12px", borderRadius:100 }}>
                  LE PLUS POPULAIRE
                </div>
              )}
              {isCurrentPlan && (
                <div style={{ position:"absolute", top:-10, left:16, background:"var(--gold)", color:"#fff", fontSize:10, fontWeight:700, padding:"3px 12px", borderRadius:100 }}>
                  MON PLAN ACTUEL
                </div>
              )}
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <span style={{ fontSize:28 }}>{plan.icon}</span>
                  <div>
                    <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"var(--text)" }}>{plan.id}</h3>
                    <p style={{ fontSize:12, color:"var(--muted)" }}>{plan.desc}</p>
                  </div>
                </div>
                <div style={{ textAlign:"right" }}>
                  <p style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:plan.color }}>
                    {getPrice(plan.id)}
                  </p>
                  {plan.id !== "Gratuit" && <p style={{ fontSize:11, color:"var(--muted)" }}>/mois</p>}
                </div>
              </div>
              {plan.features.map(f => (
                <div key={f} style={{ display:"flex", gap:8, alignItems:"center", fontSize:13, color:"var(--text)", marginBottom:4 }}>
                  <span style={{ color:"var(--green)", fontSize:14 }}>✓</span> {f}
                </div>
              ))}
              {plan.locked.map(f => (
                <div key={f} style={{ display:"flex", gap:8, alignItems:"center", fontSize:13, color:"var(--faint)", marginBottom:4 }}>
                  <span style={{ fontSize:14 }}>🔒</span> {f}
                </div>
              ))}
              {!isCurrentPlan && plan.id !== "Gratuit" && (
                <Btn color={plan.color} style={{ width:"100%", marginTop:14, borderRadius:10 }}>
                  Choisir {plan.id} →
                </Btn>
              )}
            </div>
          );
        })}
        <Surface style={{ padding:16, background:"var(--gold-light)", borderColor:"var(--gold)" }}>
          <p style={{ fontSize:13, color:"var(--text)", lineHeight:1.6 }}>
            🛡️ <strong>Satisfait ou remboursé — 30 jours.</strong> Aucune carte requise pour le plan Gratuit.
          </p>
        </Surface>
      </div>
    </div>
  );
};

// ─── ADMIN BAR (Preview mode) ─────────────────────────────────────────────────
const AdminBar = ({ onBack }) => (
  <div style={{
    position:"fixed", top:0, left:0, right:0, height:40, zIndex:200,
    background:"rgba(201,151,44,0.95)", backdropFilter:"blur(8px)",
    display:"flex", alignItems:"center", justifyContent:"space-between",
    padding:"0 16px",
  }}>
    <span style={{ fontSize:12, fontWeight:700, color:"#fff" }}>🔍 Mode prévisualisation admin</span>
    <button
      onClick={onBack}
      style={{ background:"rgba(255,255,255,0.2)", border:"none", color:"#fff", padding:"4px 12px", borderRadius:100, fontSize:12, fontWeight:600, cursor:"pointer" }}
    >
      ← Quitter
    </button>
  </div>
);

// ─── APPLICATION PRINCIPALE ───────────────────────────────────────────────────
const App = () => {
  const [user, setUser] = useState(null);
  const [screen, setScreen] = useState("landing");
  const [authMode, setAuthMode] = useState("login");
  const [loading, setLoading] = useState(true);
  const [subjects, setSubjects] = useState([]);
  const [levels, setLevels] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [progress, setProgress] = useState({});
  const [currentSubject, setCurrentSubject] = useState(null);
  const [currentChapter, setCurrentChapter] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const [currentLevelId, setCurrentLevelId] = useState(1);
  const [lastChapter, setLastChapter] = useState(null);
  const [dailyChallengeDone, setDailyChallengeDone] = useState(false);
  const [toast, setToast] = useState(null);
  const [prefillLevel, setPrefillLevel] = useState(null);
  const [showKodjo, setShowKodjo] = useState(false);
  const [selectedLevelName, setSelectedLevelName] = useState(null);
  const [currency, setCurrency] = useState("usd");
  const [kodjoAlert, setKodjoAlert] = useState(null);
  const [kodjoQuestion, setKodjoQuestion] = useState(null);
  const [adaptiveSuggestion, setAdaptiveSuggestion] = useState(null);
  const [readingMode, setReadingMode] = useState(() => localStorage.getItem("nunya_theme") || "day");
  // ─── DÉTECTION PARAMÈTRE URL ?action=login ──────────────────────────────
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get("action") === "login") {
    setScreen("landing");
    setAuthMode("login");
    window.history.replaceState({}, "", window.location.pathname);
  }
}, []);
  // ─── DÉTECTION PAIEMENT STRIPE ───────────────────────────────────────────
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const payment = params.get("payment");
  if (payment === "success") {
    setToast("🎉 Paiement réussi ! Ton plan a été activé. Bienvenue !");
    window.history.replaceState({}, "", window.location.pathname);
    // Recharger le profil pour avoir le nouveau plan
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        supabase.from("profiles").select("*").eq("id", session.user.id).single()
          .then(({ data }) => { if (data) setUser(data); });
      }
    });
  } else if (payment === "cancel") {
    setToast("❌ Paiement annulé. Tu peux réessayer quand tu veux.");
    window.history.replaceState({}, "", window.location.pathname);
  }
}, []);
  // ─── DÉTECTION CONFIRMATION EMAIL ────────────────────────────────────────
useEffect(() => {
  const hash = window.location.hash;
  if (hash.includes('error=')) {
    const params = new URLSearchParams(hash.substring(1));
    const error = params.get('error');
    const errorCode = params.get('error_code');
    if (errorCode === 'otp_expired') {
      setToast('❌ Le lien de confirmation a expiré. Reconnecte-toi pour en recevoir un nouveau.');
    } else if (error === 'access_denied') {
      setToast('❌ Lien invalide. Réessaie de te connecter.');
    }
    window.history.replaceState({}, '', window.location.pathname);
  } else if (hash.includes('access_token')) {
    // Confirmation réussie — recharger la session
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        supabase.from('profiles').select('*').eq('id', session.user.id).single()
          .then(({ data }) => {
            if (data) {
              setUser({...data, email: session.user.email});
              setScreen('dashboard');
            }
          });
      }
    });
    window.history.replaceState({}, '', window.location.pathname);
  }
}, []);
  // ─── TITRE DYNAMIQUE ─────────────────────────────────────────────────────
  useEffect(() => {
    const titles = {
      landing: "Nunya Academy — La plateforme éducative francophone",
      dashboard: "Tableau de bord — Nunya Academy",
      learn: "Mes cours — Nunya Academy",
      annales: "Annales officielles — Nunya Academy",
      leagues: "Ligues — Nunya Academy",
      me: "Mon profil — Nunya Academy",
      admin: "Administration — Nunya Academy",
      upgrade: "Nos offres — Nunya Academy",
      settings: "Paramètres — Nunya Academy",
      famille: "Espace famille — Nunya Academy",
      chapters: "Chapitres — Nunya Academy",
      challenge: "Défi du jour — Nunya Academy",
    };
    document.title = titles[screen] || "Nunya Academy";
  }, [screen]);
  // ─── INSTALLATION PWA ────────────────────────────────────────────────────
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      // Afficher la bannière après 30 secondes d'utilisation
      setTimeout(() => setShowInstallBanner(true), 30000);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') setShowInstallBanner(false);
    setInstallPrompt(null);
  };
  // ─── NOTIFICATIONS PUSH ──────────────────────────────────────────────────
  const requestPushPermission = async () => {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
    if (Notification.permission === 'granted') return;
    if (Notification.permission === 'denied') return;
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: process.env.REACT_APP_VAPID_PUBLIC_KEY
        });
        if (user?.id) {
          await supabase.from('push_subscriptions').upsert({
            user_id: user.id,
            subscription: JSON.stringify(subscription),
            updated_at: new Date().toISOString()
          });
        }
      } catch(e) {
        console.log('Push subscription failed:', e);
      }
    }
  };
  useEffect(() => {
    if (!user) return;
    const timer = setTimeout(() => requestPushPermission(), 120000);
    return () => clearTimeout(timer);
  }, [user]);
  // ─── BOUTON RETOUR NAVIGATEUR ────────────────────────────────────────────
 // ─── BOUTON RETOUR NAVIGATEUR ────────────────────────────────────────────
  useEffect(() => {
    const depth = {
      landing:0, auth:0, onboarding:0,
      dashboard:1, learn:1, leagues:1, me:1,
      chapters:2, annales:2, plans:2, famille:2, settings:2, challenge:2,
      "chapter-content":3,
    };
    const currentDepth = depth[screen] ?? 1;
    const prevDepth = depth[window.history.state?.screen] ?? 0;
    if (currentDepth > prevDepth) {
      window.history.pushState({ screen }, "", window.location.pathname);
    }
  }, [screen]);

  useEffect(() => {
    const handlePopState = (e) => {
      const prev = e.state?.screen;
      if (!prev || ["landing","auth","onboarding"].includes(prev)) {
        setScreen(user ? "dashboard" : "landing");
      } else {
        setScreen(prev);
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [user]);

  const showToast = useCallback((msg) => {
    setToast(msg);
    setTimeout(() => setToast(null), 3000);
  }, []);

  // Vérifier session existante
  useEffect(() => {
    const init = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          const { data: profile } = await supabase
            .from("profiles").select("*").eq("id", session.user.id).single();
          if (profile) {
            const role = profile.role || "student";
            handleAuth({
              id: session.user.id,
              name: profile.name || (role==="superadmin" ? "Super Administrateur" : role==="admin" ? "Administrateur" : "Élève"),
              email: session.user.email,
              level: profile.level || "6ème",
              country: profile.country || "Gabon",
              plan: profile.plan || "Gratuit",
              xp: profile.xp || 0,
              streak: profile.streak || 0,
              last_activity: profile.last_activity,
              badges: profile.badges || [],
              specialties: profile.specialties || [],
              parent_email: profile.parent_email,
              role,
            });
          }
        }
      } catch (e) {
        console.warn("Session init error:", e);
      }
      setLoading(false);
    };
    init();
  }, []);

  // Charger données
  useEffect(() => {
    const loadData = async () => {
      try {
        const [{ data: subs }, { data: lvls }] = await Promise.all([
          supabase.from("subjects").select("*").eq("is_active", true).order("id"),
          supabase.from("levels").select("*").order("id"),
        ]);
        setSubjects(subs || []);
        setLevels(lvls || []);
      } catch (e) {
        console.warn("Data load error:", e);
      }
    };
    loadData();
  }, []);

  // Charger progression utilisateur
  useEffect(() => {
    if (!user?.id) return;
    const loadProgress = async () => {
      try {
        const { data } = await supabase.from("progress").select("*").eq("user_id", user.id);
        const prog = {};
        (data || []).forEach(p => { prog[p.chapter_id] = { score:p.score, completed:p.completed }; });
        setProgress(prog);
      } catch (e) {
        console.warn("Progress load error:", e);
      }
    };
    loadProgress();

    // Vérifier défi du jour
    const today = new Date().toDateString();
    const key = `nunya_challenge_${user.id}_${today}`;
    setDailyChallengeDone(localStorage.getItem(key) === "done");

    // Kodjo proactif — calculer une alerte éventuelle
    computeKodjoAlert(user).then(setKodjoAlert);
  }, [user?.id]);

  // Charger chapitres pour le niveau actif
  useEffect(() => {
    if (!currentSubject || !user) return;
    const loadChapters = async () => {
      try {
        const levelName = isPreview
      ? (levels.find(l => l.id === currentLevelId)?.name || user.level)
      : (selectedLevelName || user.level);
        const level = levels.find(l => l.name === levelName);
        if (!level) return;

        // Résoudre l'ID réel pour les spécialités
        let subjectId = currentSubject.id;

        if (typeof subjectId === "string" && subjectId.startsWith("spec_")) {
          const specKey = subjectId.replace("spec_","");
          const specToSubjectId = {
            "maths":  12,
            "svt":    13,
            "pc":     14,
            "ses":    15,
            "nsi":    16,
            "hggsp":  17,
            "hlp":    18,
            "arts":   19,
            "llcer":  20,
            "si":     21,
          };
          if (specToSubjectId[specKey]) subjectId = specToSubjectId[specKey];
        }
        const { data: chaps } = await supabase
          .from("chapters")
          .select("*, lessons(*), exercises(*)")
          .eq("subject_id", subjectId)
          .eq("level_id", level.id)
          .order("order_num");

        setChapters(chaps || []);
      } catch (e) {
        console.warn("Chapters load error:", e);
      }
    };
    loadChapters();
  }, [currentSubject, currentLevelId, user?.level, isPreview]);

  const handleAuth = async (userData) => {
    console.log('handleAuth userData:', userData.plan, userData.plan_expires_at, userData.role);
    setUser(userData);
    // Email de bienvenue uniquement à la première connexion
    if (!userData.xp && !userData.streak) {
      supabase.functions.invoke('send-welcome', {
        body: {
          userId: userData.id,
          firstName: userData.name,
          email: userData.email,
        }
      }).catch(e => console.log('Email bienvenue error:', e));
    }
    if (userData.must_change_password) {
      setScreen("change_password");
    } else if (userData.role === "superadmin" || userData.role === "admin") {
      setScreen("admin");
    } else if (userData.plan && ["Essentiel","Premium","Famille"].includes(userData.plan) && !userData.plan_expires_at) {
      // Plan payant — paiement immédiat avant accès
      setUser(userData);
      try {
        const geoRes = await fetch('https://api.country.is/');
        const geo = await geoRes.json();
        console.log('Geo détecté:', geo.country, geo.country_name);
        const africaCountries = ['GA','CM','SN','CI','RW','TZ','ZM','UG','CG','GH','MZ','MG','BJ'];
        const isAfrica = africaCountries.includes(geo.country);

        if (isAfrica) {
          // Proposer choix Mobile Money ou Carte
         const amounts = {
              Essentiel: { monthly: 1999 },
              Premium: { monthly: 3499 },
              Famille: { monthly: 6499 },
            };
            const amount = amounts[userData.plan]?.monthly || 1999;
            setShowPaymentModal({
              plan: userData.plan,
              billing: userData.billing || 'monthly',
              userId: userData.id,
              userEmail: userData.email,
              amount,
              country: geo.country,
            });
            return;
          }
        // Stripe direct si pas Afrique
        const { data, error } = await supabase.functions.invoke('create-checkout-session', {
          body: {
            plan: userData.plan,
            billing: userData.billing || 'monthly',
            userId: userData.id,
            userEmail: userData.email,
            successUrl: 'https://app.nunya.academy/?payment=success',
            cancelUrl: 'https://app.nunya.academy/?payment=cancel',
          }
        });
        if (!error && data?.url) { window.location.href = data.url; return; }
      } catch(e) {
        console.error('Payment error:', e);
      }
      // Si paiement échoue — dashboard gratuit temporaire
      setScreen("dashboard");
    } else {
      setScreen("dashboard");
    }
  };
  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setScreen("landing");
    setCurrentSubject(null);
    setCurrentChapter(null);
    setChapters([]);
    setProgress({});
    setIsPreview(false);
  };

  const handleNav = (target, subjectId = null) => {
    if (target === "challenge") {
      setScreen("challenge");
    } else if (target === "annales") {
      setScreen("annales");
    } else if (target === "parents") {
      setScreen("parents");
    } else if (target === "settings") {
      setScreen("settings");
    } else if (target === "kodjo") {
      setShowKodjo(true);
    } else if (target === "plans") {
      setScreen("plans");
    } else if (target === "upgrade") {
      setScreen("upgrade");
    } else if (target === "famille") {
      setScreen("famille");
    } else {
      setScreen(target);
    }
    if (subjectId) {
      const sub = subjects.find(s => s.id === subjectId);
      if (sub) { setCurrentSubject(sub); setScreen("chapters"); }
    }
  };
  const handleSubject = (subject, level) => {
    setCurrentSubject(subject);
    setSelectedLevelName(level || user?.level);
    setScreen("chapters");
  };

  const handleChapter = (chapter, subject = null) => {
    setCurrentChapter(chapter);
    if (subject) setCurrentSubject(subject);
    setScreen("chapter-content");
    setLastChapter({ ...chapter, subjectName: subject?.name || currentSubject?.name, progress: progress[chapter.id]?.score ? Math.round((progress[chapter.id].score / 10) * 100) : 0 });
  };

  const handleSaveProgress = async (userId, chapterId, score, completed) => {
    const oldScore = progress[chapterId]?.score || 0;
    const wasCompleted = progress[chapterId]?.completed || false;
    await saveProgress(userId, chapterId, score, completed);
    setProgress(prev => ({ ...prev, [chapterId]: { score, completed } }));

    // XP intelligent : récompense le PROGRÈS, pas juste la complétion
    let xpGain = 0;
    let xpReason = "";

   if (completed && !wasCompleted) {
      xpGain += 30;
      xpReason = "Chapitre terminé";
      if (score < 6) {
        setAdaptiveSuggestion({
          chapterId,
          score,
          message: `Tu as obtenu ${score}/10 sur ce chapitre. Veux-tu réviser les points difficiles avec Kodjo avant de continuer ?`
        });
      }
    }
    // Bonus si amélioration du score (progrès réel)
    if (score > oldScore) {
      const progressBonus = (score - oldScore) * 5;
      xpGain += progressBonus;
      xpReason = xpReason ? `${xpReason} + progrès (${oldScore}→${score})` : `Progrès ! ${oldScore}/10 → ${score}/10`;
    }

    if (xpGain > 0) {
      const { newXP, newStreak, newBadges } = await updateXPAndStreak(userId, xpGain, user.streak, user.last_activity, user.badges);
      setUser(prev => ({ ...prev, xp:newXP, streak:newStreak, badges:newBadges }));
      showToast(`🎉 ${xpReason} · +${xpGain} XP`);
    }
  };

  // Injecter CSS
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // Appliquer thème global
  useEffect(() => {
    const root = document.documentElement;
    localStorage.setItem("nunya_theme", readingMode);
    if (readingMode === "night") {
      root.style.setProperty("--bg",        "#0A0F1E");
      root.style.setProperty("--surface",   "#0F1629");
      root.style.setProperty("--surface2",  "#1A2340");
      root.style.setProperty("--text",      "#E8EAF0");
      root.style.setProperty("--muted",     "#8892A4");
      root.style.setProperty("--border",    "#1E2A45");
      root.style.setProperty("--border2",   "#162038");
      root.style.setProperty("--faint",     "#3A4560");
      root.style.setProperty("--gold",      "#E8B84B");
      root.style.setProperty("--gold-light","rgba(232,184,75,0.15)");
      root.style.setProperty("--blue-light","rgba(26,86,219,0.15)");
      root.style.setProperty("--navy",      "#0A1F44");
    } else if (readingMode === "sepia") {
      root.style.setProperty("--bg",        "#F5ECD7");
      root.style.setProperty("--surface",   "#FBF5E6");
      root.style.setProperty("--surface2",  "#EDE0C8");
      root.style.setProperty("--text",      "#1A0F06");
      root.style.setProperty("--muted",     "#6B4C3B");
      root.style.setProperty("--border",    "#D4C5A9");
      root.style.setProperty("--border2",   "#E0D4BC");
      root.style.setProperty("--faint",     "#B5A898");
      root.style.setProperty("--gold",      "#A07820");
      root.style.setProperty("--gold-light","rgba(160,120,32,0.12)");
      root.style.setProperty("--blue-light","rgba(120,80,40,0.10)");
      root.style.setProperty("--navy",      "#1A0F06");
    } else {
      root.style.setProperty("--bg",        "#F7F8FA");
      root.style.setProperty("--surface",   "#FFFFFF");
      root.style.setProperty("--surface2",  "#EFF1F5");
      root.style.setProperty("--text",      "#0A1F44");
      root.style.setProperty("--muted",     "#4B5468");
      root.style.setProperty("--border",    "#DDE1EA");
      root.style.setProperty("--border2",   "#E8EBF2");
      root.style.setProperty("--faint",     "#A0A9BC");
      root.style.setProperty("--gold",      "#C9972C");
      root.style.setProperty("--gold-light","#FDF3DC");
      root.style.setProperty("--blue-light","#EBF2FF");
      root.style.setProperty("--navy",      "#0A1F44");
    }
  }, [readingMode]);

  if (loading) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"var(--bg)" }}>
      <div style={{ textAlign:"center" }}>
        <NunyaLogo size="lg" />
        <div style={{ marginTop:24 }}><Spinner size={32} /></div>
      </div>
    </div>
  );

  // Kodjo overlay
  if (showKodjo && user) return (
    <Kodjo
      user={user}
      chapter={currentChapter}
      subject={currentSubject}
      onClose={() => { setShowKodjo(false); setKodjoAlert(null); setKodjoQuestion(null); }}
      proactiveAlert={kodjoAlert}
      kodjoQuestion={kodjoQuestion}
    />
  );

  // Admin
  if (screen === "admin" && (user?.role === "superadmin" || user?.role === "admin")) return (
    <SuperAdmin
      user={user}
      onLogout={handleLogout}
      onPreview={() => { setIsPreview(true); setScreen("dashboard"); }}
      onImpersonate={(targetUser) => {
        localStorage.setItem('nunya_admin_session', JSON.stringify(user));
        setUser(targetUser);
        setIsPreview(false);
        setScreen("dashboard");
      }}
      currentLevelId={currentLevelId}
      setCurrentLevelId={setCurrentLevelId}
      levels={levels}
    />
   );
  // Landing
  if (screen === "landing") return (
    <Landing
      onEnter={(mode) => { setAuthMode(mode); setScreen("auth"); }}
      onDemo={() => setScreen("onboarding")}
    />
  );

  // Onboarding
  if (screen === "onboarding") return (
    <Onboarding
      onComplete={(mode, level) => { setPrefillLevel(level); setAuthMode(mode); setScreen("auth"); }}
      onSkip={() => { setAuthMode("login"); setScreen("auth"); }}
    />
  );

  // Auth
  if (screen === "auth") return (
    <>
      <Auth
        mode={authMode}
        onAuth={handleAuth}
        onSwitch={() => setAuthMode(m => m === "login" ? "register" : "login")}
        prefillLevel={prefillLevel}
      />
      {showPaymentModal && (
        <div style={{
          position:"fixed", top:0, left:0, right:0, bottom:0, zIndex:99999,
          background:"rgba(0,0,0,0.7)", display:"flex", alignItems:"center", justifyContent:"center", padding:24
        }}>
          <div style={{ background:"var(--surface)", borderRadius:20, padding:28, maxWidth:380, width:"100%", textAlign:"center" }}>
            <p style={{ fontSize:32, marginBottom:12 }}>💳</p>
            <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"var(--text)", marginBottom:8 }}>
              Choisir votre mode de paiement
            </h3>
            <p style={{ fontSize:13, color:"var(--muted)", marginBottom:24 }}>
              Plan {showPaymentModal.plan} — {showPaymentModal.billing === 'annual' ? 'Annuel' : 'Mensuel'}
            </p>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              <button onClick={async () => {
                const { plan, billing, userId, userEmail, amount, country } = showPaymentModal;
                setShowPaymentModal(null);
                const { data, error } = await supabase.functions.invoke('create-pawapay-checkout', {
                  body: { plan, billing, userId, userEmail, amount, country }
                });
                if (!error && data?.url) window.location.href = data.url;
                else setToast('Erreur paiement Mobile Money. Réessaie.');
              }} style={{
                background:"var(--gold)", color:"#fff", border:"none", borderRadius:12,
                padding:"14px 20px", fontSize:15, fontWeight:700, cursor:"pointer"
              }}>📱 Payer par Mobile Money</button>
              <button onClick={async () => {
                const { plan, billing, userId, userEmail } = showPaymentModal;
                setShowPaymentModal(null);
                const { data, error } = await supabase.functions.invoke('create-checkout-session', {
                  body: { plan, billing, userId, userEmail,
                    successUrl: 'https://app.nunya.academy/?payment=success',
                    cancelUrl: 'https://app.nunya.academy/?payment=cancel' }
                });
                if (!error && data?.url) window.location.href = data.url;
                else setToast('Erreur paiement carte. Réessaie.');
              }} style={{
                background:"var(--navy)", color:"#fff", border:"none", borderRadius:12,
                padding:"14px 20px", fontSize:15, fontWeight:700, cursor:"pointer"
              }}>💳 Payer par carte bancaire</button>
             <button onClick={async () => {
  const { userId } = showPaymentModal;
  setShowPaymentModal(null);
  await supabase.from('profiles').update({ plan: 'Gratuit' }).eq('id', userId);
  const { data: freshProfile } = await supabase.from('profiles').select('*').eq('id', userId).single();
  if (freshProfile) setUser({...freshProfile, email: freshProfile.email || user?.email});
  const { data: freshProfile2 } = await supabase.from('profiles').select('*').eq('id', userId).single();
  if (freshProfile2) setUser({...freshProfile2, email: freshProfile2.email || user?.email});
  else setUser(u => ({...u, plan: 'Gratuit', plan_expires_at: null}));
  setScreen("dashboard");
}} style={{
                background:"none", border:"none", color:"var(--muted)", fontSize:13, cursor:"pointer", marginTop:4
              }}>Continuer avec le plan Gratuit</button>
            </div>
          </div>
        </div>
      )}
    </>
  );

  // Écrans authentifiés
  if (!user) return (
    <Landing
      onEnter={(mode) => { setAuthMode(mode); setScreen("auth"); }}
      onDemo={() => setScreen("onboarding")}
    />
  );

 return (
    <main id="main-content" style={{ maxWidth:720, margin:"0 auto", position:"relative", background:"var(--bg)", minHeight:"100vh", paddingTop: localStorage.getItem('nunya_admin_session') && !isPreview ? 36 : isPreview ? 40 : 0 }}>
      {isPreview && <AdminBar onBack={() => { setIsPreview(false); setScreen("admin"); }} />}
      {localStorage.getItem('nunya_admin_session') && !isPreview && (
  <div style={{
    position:"fixed", top:0, left:0, right:0, zIndex:9999,
    background:"linear-gradient(135deg, #C9972C, #E8B84B)",
    padding:"8px 16px", display:"flex", alignItems:"center", justifyContent:"space-between"
  }}>
    <p style={{ fontSize:12, fontWeight:700, color:"#fff" }}>
      👤 Mode impersonation — {user?.name} ({user?.plan})
    </p>
    <button onClick={() => {
      const adminSession = JSON.parse(localStorage.getItem('nunya_admin_session'));
      localStorage.removeItem('nunya_admin_session');
      setUser(adminSession);
      setScreen("admin");
    }} style={{
      background:"rgba(0,0,0,0.2)", border:"none", borderRadius:6,
      padding:"4px 12px", fontSize:11, color:"#fff", fontWeight:700, cursor:"pointer"
    }}>
      ← Retour SuperAdmin
    </button>
  </div>
)}
      {toast && <Toast message={toast} onClose={() => setToast(null)} />}
      {showPaymentModal && (
  <div style={{
    position:"fixed", top:0, left:0, right:0, bottom:0, zIndex:99999,
    background:"rgba(0,0,0,0.7)", display:"flex", alignItems:"center", justifyContent:"center", padding:24
  }}>
    <div style={{ background:"var(--surface)", borderRadius:20, padding:28, maxWidth:380, width:"100%", textAlign:"center" }}>
      <p style={{ fontSize:32, marginBottom:12 }}>💳</p>
      <h3 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"var(--text)", marginBottom:8 }}>
        Choisir votre mode de paiement
      </h3>
      <p style={{ fontSize:13, color:"var(--muted)", marginBottom:24 }}>
        Plan {showPaymentModal.plan} — {showPaymentModal.billing === 'annual' ? 'Annuel' : 'Mensuel'}
      </p>
      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
        <button onClick={async () => {
          const { plan, billing, userId, userEmail, amount, country } = showPaymentModal;
          setShowPaymentModal(null);
          const { data, error } = await supabase.functions.invoke('create-pawapay-checkout', {
            body: { plan, billing, userId, userEmail, amount, country }
          });
          if (!error && data?.url) window.location.href = data.url;
          else setToast('Erreur paiement Mobile Money. Réessaie.');
        }} style={{
          background:"var(--gold)", color:"#fff", border:"none", borderRadius:12,
          padding:"14px 20px", fontSize:15, fontWeight:700, cursor:"pointer"
        }}>📱 Payer par Mobile Money</button>
        <button onClick={async () => {
          const { plan, billing, userId, userEmail } = showPaymentModal;
          setShowPaymentModal(null);
          const { data, error } = await supabase.functions.invoke('create-checkout-session', {
            body: { plan, billing, userId, userEmail,
              successUrl: 'https://app.nunya.academy/?payment=success',
              cancelUrl: 'https://app.nunya.academy/?payment=cancel' }
          });
          if (!error && data?.url) window.location.href = data.url;
          else setToast('Erreur paiement carte. Réessaie.');
        }} style={{
          background:"var(--navy)", color:"#fff", border:"none", borderRadius:12,
          padding:"14px 20px", fontSize:15, fontWeight:700, cursor:"pointer"
        }}>💳 Payer par carte bancaire</button>
        <button onClick={async () => {
  const { userId } = showPaymentModal;
  setShowPaymentModal(null);
  await supabase.from('profiles').update({ plan: 'Gratuit' }).eq('id', userId);
  setUser(u => ({...u, plan: 'Gratuit', plan_expires_at: null}));
  setScreen("dashboard");
}} style={{
          background:"none", border:"none", color:"var(--muted)", fontSize:13, cursor:"pointer", marginTop:4
        }}>Continuer avec le plan Gratuit</button>
      </div>
    </div>
  </div>
)}
      {showInstallBanner && installPrompt && (
  <div style={{
    position:"fixed", bottom: "calc(var(--bottom-nav-h) + 16px)", left:16, right:16,
    background:"var(--navy)", borderRadius:16, padding:"16px 20px",
    display:"flex", alignItems:"center", gap:12, zIndex:999,
    boxShadow:"0 4px 24px rgba(0,0,0,0.3)", border:"1px solid var(--gold)"
  }}>
    <span style={{fontSize:28}}>📱</span>
    <div style={{flex:1}}>
      <p style={{fontSize:13, fontWeight:700, color:"#fff", marginBottom:2}}>Installer Nunya Academy</p>
      <p style={{fontSize:11, color:"rgba(255,255,255,0.6)"}}>Accès rapide depuis ton écran d'accueil</p>
    </div>
    <button onClick={handleInstall} style={{
      background:"var(--gold)", color:"#fff", border:"none", borderRadius:8,
      padding:"8px 14px", fontSize:12, fontWeight:700, cursor:"pointer"
    }}>Installer</button>
    <button onClick={() => setShowInstallBanner(false)} style={{
      background:"none", border:"none", color:"rgba(255,255,255,0.5)",
      fontSize:18, cursor:"pointer", padding:4
    }}>×</button>
  </div>
)}
{adaptiveSuggestion && (
  <div style={{
    position:"fixed", bottom:20, left:"50%", transform:"translateX(-50%)",
    background:"var(--surface)", border:"2px solid var(--gold)", borderRadius:16,
    padding:20, maxWidth:380, width:"90%", zIndex:9999, boxShadow:"0 8px 32px rgba(0,0,0,0.25)"
  }}>
    <p style={{ fontSize:14, color:"var(--text)", marginBottom:16, lineHeight:1.5 }}>
      🤖 {adaptiveSuggestion.message}
    </p>
    <div style={{ display:"flex", gap:10 }}>
      <button
        onClick={() => { setAdaptiveSuggestion(null); setShowKodjo(true); }}
        style={{ flex:1, padding:"10px 16px", borderRadius:10, border:"none", background:"var(--gold)", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer" }}
      >
        Réviser avec Kodjo
      </button>
      <button
        onClick={() => setAdaptiveSuggestion(null)}
        style={{ flex:1, padding:"10px 16px", borderRadius:10, border:"1.5px solid var(--border)", background:"transparent", color:"var(--text)", fontWeight:600, fontSize:13, cursor:"pointer" }}
      >
        Continuer
      </button>
    </div>
  </div>
)}

      {/* Défi du jour */}
      {screen === "challenge" && (
        <DailyChallenge
          user={user}
          onDone={(score) => {
            setDailyChallengeDone(true);
            showToast(`🏆 Défi terminé ! Score: ${score}/10 · +50 XP`);
            setTimeout(() => setScreen("dashboard"), 3000);
          }}
          onBack={() => setScreen("dashboard")}
        />
      )}

     {screen === "annales" && (
        <Annales
          user={isPreview ? {
            ...user,
            role: "student",
            level: levels.find(l => l.id === currentLevelId)?.name || "6ème",
            specialties: ["maths","svt","pc","ses","nsi","hggsp","hlp","llcer","si","arts"],
          } : user}
          onBack={() => setScreen("learn")}
          onNav={(s) => setScreen(s)}
        />
      )}
{/* Upgrade */}
      {screen === "upgrade" && (
        <UpgradeScreen
          user={user}
          onBack={() => setScreen("learn")}
          onUpgrade={async (plan, billing) => {
            try {
              const geoRes = await fetch('https://api.country.is/');
              const geo = await geoRes.json();
              const africaCountries = ['GA','CM','SN','CI','RW','TZ','ZM','UG','CG','GH','MZ','MG','BJ'];
              const isAfrica = africaCountries.includes(geo.country);
              if (isAfrica) {
                const amounts = {
                  Essentiel: { monthly: 1999, annual: 17991 },
                  Premium: { monthly: 3499, annual: 31491 },
                  Famille: { monthly: 6499, annual: 58491 },
                };
                const amount = amounts[plan]?.[billing === 'annual' ? 'annual' : 'monthly'] || 1999;
                setShowPaymentModal({
                  plan, billing,
                  userId: user.id,
                  userEmail: user.email,
                  amount,
                  country: geo.country,
                });
                return;
              }
              const { data, error } = await supabase.functions.invoke('create-checkout-session', {
                body: {
                  plan, billing,
                  userId: user.id,
                  userEmail: user.email,
                  successUrl: 'https://app.nunya.academy/?payment=success',
                  cancelUrl: 'https://app.nunya.academy/?payment=cancel',
                }
              });
              if (error) throw error;
              if (data?.url) window.location.href = data.url;
            } catch(e) {
              alert('Erreur lors du paiement. Réessaie.');
            }
          }}
        />
      )}
      {/* Famille */}
      {screen === "famille" && (
        <FamilleScreen user={user} onBack={() => setScreen("me")} />
      )}

      {/* Plans */}
      {screen === "plans" && (
        <PlansScreen user={user} onBack={() => setScreen("me")} />
      )}

      {/* Settings */}
      {screen === "settings" && (
        <Settings user={user} onBack={() => setScreen("me")} onLogout={handleLogout} onUserUpdate={setUser} readingMode={readingMode} setReadingMode={setReadingMode} />
      )}

      {/* Chapitres */}
      {screen === "chapters" && currentSubject && (
        <ChapterList
          user={user}
          subject={currentSubject}
          chapters={chapters}
          progress={progress}
          onChapter={(ch) => handleChapter(ch, currentSubject)}
          onBack={() => setScreen("learn")}
          onNav={handleNav}
        />
      )}

      {/* Contenu chapitre */}
      {screen === "chapter-content" && currentChapter && (
        <>
          <ChapterContent
            chapter={currentChapter}
            subject={currentSubject}
            user={user}
            currency={currency}
            onBack={() => setScreen("chapters")}
            onNav={handleNav}
            onKodjo={(question) => { setKodjoQuestion(question || null); setShowKodjo(true); }}
            onSaveProgress={handleSaveProgress}
            chapterProgress={progress[currentChapter.id]}
          />
        </>
      )}
      {/* Bouton Kodjo flottant — visible partout sauf dans Kodjo lui-même */}
      {user && !showKodjo && (
        <KodjoFAB onClick={() => setShowKodjo(true)} hasAlert={!!kodjoAlert} />
      )}
      {/* Bouton mode lecture flottant — visible partout */}
      <ReadingModeFAB mode={readingMode} setMode={setReadingMode} />

     {/* Écrans principaux avec bottom nav */}
      {["dashboard","learn","leagues","me"].includes(screen) && (
        <>
          {screen === "dashboard" && (
            <Dashboard
              user={user}
              onNav={handleNav}
              onChapter={handleChapter}
              subjects={subjects}
              levels={levels}
              lastChapter={lastChapter}
              dailyChallengeDone={dailyChallengeDone}
              isPreview={isPreview}
              currentLevelId={currentLevelId}
            />
          )}
          {screen === "learn" && (
            <LearnScreen
              user={isPreview ? {
                ...user,
                role: "student",
                level: levels.find(l => l.id === currentLevelId)?.name || "6ème",
                specialties: ["1ère Générale","Terminale Générale"].includes(
                  levels.find(l => l.id === currentLevelId)?.name
                ) ? SPECIALTIES.map(s => s.id) : [],
              } : user}
              subjects={subjects}
              levels={levels}
              onSubject={handleSubject}
              onNav={handleNav}
            />
          )}
          {screen === "leagues" && (
            <Leagues user={user} onBack={() => setScreen("dashboard")} />
          )}
          {screen === "me" && (
            <Profile user={user} onLogout={handleLogout} onNav={handleNav} />
          )}
          <BottomNav screen={screen} onNav={(s) => setScreen(s)} user={user} />
        </>
      )}
    </main>
  );
};
export default App;
